// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/curve-bg-header.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Kodchasan-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Kodchasan-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Kodchasan-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Kodchasan-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Kodchasan-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/CabinSketch-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/CabinSketch-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/CabinSketch-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/CabinSketch-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/CabinSketch-Bold.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/Roboto-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/fonts/Roboto-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/fonts/Roboto-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/fonts/Roofrunnersactive.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/fonts/Roofrunnersactive.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/fonts/Roofrunnersactive.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/fonts/Roofrunnersactive.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../assets/fonts/Roofrunnersactive.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../assets/fonts/Inter-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../assets/fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../assets/fonts/Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../assets/fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../../assets/fonts/Inter-Regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../../assets/images/border-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../../assets/images/BsComBtnBorder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../../assets/images/cardborder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../../assets/images/singleline.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../../assets/images/blue-bg-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../../assets/images/GuppyStoriesBehindTheScene.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../../assets/images/behind-the-scene.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../../assets/images/vertical-dashed.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../../assets/images/dashed-line.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../../assets/images/MenuBorderImg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../../assets/images/faq-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../../assets/images/record-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../../assets/images/yellow-border-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../../assets/images/menunewyellowlight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("../../assets/images/mobilemenubtnLigthblueborder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("../../assets/images/StoryAdventureBorder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("../../assets/images/MyStoryFlows-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("../../assets/images/badal-right.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("../../assets/images/StoryBorderCreate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("../../assets/images/border-bottom-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../../assets/images/ActiveLeft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../../assets/images/ActiveRight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../../assets/images/dark-blue-border-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../../assets/images/mysub1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../../assets/images/mysub2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../../assets/images/redborderImg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../../assets/images/borderNewMainStory.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../../assets/images/leftMobileActiveEffect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../../assets/images/rightMobileActiveEffect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../../assets/images/sign-up-right-img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../../assets/images/my-stories-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../../assets/images/my-stories-mobile-bg-zig.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../../assets/images/my-stories-mobile-bg-cir.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../../assets/images/MySubmissionInfoDraftblue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../../assets/images/MySubmissionInfoDraftyellow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../../assets/images/submissionDraftCircle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../../assets/images/submission-red-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../../assets/images/YellowZigZagRight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../../assets/images/YellowZigZagLeft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../../assets/images/YellowStoryBottomBgLeft.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../../assets/images/YellowStoryBottomBgRight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../../assets/images/createAnewStoryYellowBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../../assets/images/createStoryTOpBgline.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../../assets/images/celebrationBorder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../../assets/images/whiteRightHover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../../assets/images/whiteLeftHover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../../assets/images/BlackDashedLineNew.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "#Kodchasan-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "#CabinSketch-Bold" });
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "#Roboto-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "#Roofrunnersactive" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#Inter-Regular" });
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landingpage_btnFill__Ctw\\+3,
.landingpage_btnUnfill__uGDrD {
  margin: 0 10px;
  text-align: center;
  cursor: pointer;
}

.landingpage_border-main__XW\\+Vt,
.landingpage_btnUnfill__uGDrD {
  border: 3px solid #0d5268;
}

.landingpage_btnFill__Ctw\\+3,
.landingpage_btnUnfill__uGDrD,
h2,
h4 {
  text-align: center;
}

.landingpage_header_section__eWp\\+J::before,
.landingpage_is_sticky__Km9Ty::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 100%;
  top: -20px;
  background-position: center;
  left: 0;
  background-size: cover;
}

.landingpage_btnFill__Ctw\\+3,
.landingpage_btnUnfill__uGDrD,
.landingpage_headerGs__HYoJR p {
  font-size: 36px;
  line-height: 47px;
}

.landingpage_cardPickSection__-x4G0::before,
.landingpage_cardborder__Zk6K9,
.landingpage_header_section__eWp\\+J::before,
.landingpage_is_sticky__Km9Ty::before,
.landingpage_signUpInfo__lrGdo::after {
  content: "";
  background-repeat: no-repeat;
}

.landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo,
.landingpage_cardPickSection__-x4G0::before,
.landingpage_cardborder__Zk6K9,
.landingpage_cardborderthree__nKoeR,
.landingpage_header_section__eWp\\+J::before,
.landingpage_is_sticky__Km9Ty::before,
.landingpage_signUpInfo__lrGdo::after {
  background-repeat: no-repeat;
}

.landingpage_border-main__XW\\+Vt,
.landingpage_footerLeft__c5Eka a {
  display: inline-block;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV a,
.landingpage_footerMid__ZQV9z a,
.landingpage_footerMidLeft__xizVl a,
.landingpage_loginBg__JZmcK .landingpage_forgerPass__DTiZ6 a,
.landingpage_logoutMenuBottomNew__Plo0X a.landingpage_logoutMenuBottoma__C2qUI,
.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3,
.landingpage_menuMain__CIvXY a.landingpage_logoutMenu__le580,
.landingpage_mobileFooter__zaew6 .landingpage_mobilelink__NqFmt a,
.landingpage_myaccount_main__ToIhz .landingpage_logout__b7eba a,
.landingpage_storyPagecompMain__gqaI6 a {
  text-decoration-line: underline;
}

.landingpage_MySubmission__jt\\+jE
  .landingpage_MySubmissionInfo__vCULm
  .landingpage_MySubmissiondetail_Ingredients__Vo1Um
  .landingpage_MySubmissionInfoInner__BmzgZ
  h3,
.landingpage_btnFill__Ctw\\+3,
.landingpage_btsSection__l5qw9 .landingpage_theaterInfo__nmkAq .landingpage_theaterLeftInfo__PxUNY h4,
body {
  font-family: Kodchasan, sans-serif;
}

.landingpage_MyStories__xS1Bu,
.landingpage_MyStoryFlowMain__PvUat,
.landingpage_PackagesMain__vvtmP,
.landingpage_PasswordUpdatedScreenMain__89uxS,
.landingpage_loginBg__JZmcK,
.landingpage_menuMain__CIvXY,
.landingpage_myavtarsection__6IZ7k,
.landingpage_signUpBg__6ajTf {
  min-height: 100vh;
}

@font-face {
  font-family: Kodchasan;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___})
      format("svg");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Cabin Sketch";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_12___})
      format("svg");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Roboto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("svg");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Roof runners active";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_24___})
      format("svg");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: Inter;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___})
      format("embedded-opentype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype"),
    url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("svg");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --black: #000000;
  --blue: #56cdd5;
  --white: #ffffff;
  --green: #d9eb41;
  --red: #ed4c55;
  --dark-blue: #0d5268;
  --yellow: #f2dd4e;
}

body {
  font-size: 16px;
  font-weight: 400;
}

h1,
h2 {
  font-family: "Cabin Sketch", cursive;
  color: #000;
  margin-bottom: 0;
}

.landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsBottom__yPJBt ul li,
li {
  list-style-type: none;
}

#landingpage_MainMenu__CnRM\\+ {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

#landingpage_MainMenu__CnRM\\+ ::-webkit-scrollbar {
  display: none;
}

p {
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  color: var(--black);
  margin-bottom: 0;
}

.landingpage_btnFill__Ctw\\+3,
.landingpage_btnUnfill__uGDrD,
.landingpage_headerGs__HYoJR p,
h1,
h2,
h4 {
  font-weight: 700;
}

.landingpage_btnFill__Ctw\\+3 {
  color: #fff;
  padding: 7px 25px;
  background-color: #0d5268;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-image-outset: 8px 8px 14px 8px;
}

.landingpage_btnUnfill__uGDrD {
  background-color: transparent;
  padding: 7px 30px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-image-outset: 0 0 8px 0;
  color: #0d5268;
}

a:hover {
  text-decoration: none;
}

img {
  max-width: 100%;
}

.landingpage_rotating__PJL95 {
  transform: rotate(360deg);
}

.landingpage_border-main__XW\\+Vt {
  border-radius: 255px 15px 225px/15px 225px 15px 255px;
  padding: 5px;
}

button:focus,
button:focus-visible {
  outline: 0;
}

h1 {
  font-size: 48px;
  line-height: 56px;
  text-align: left;
}

h2 {
  font-size: 72px;
  line-height: 84px;
}

.landingpage_cardPickSection__-x4G0 .landingpage_cardborderfouth__qNzpV,
h4 {
  line-height: 56px;
  font-family: "Cabin Sketch", cursive;
}

h4 {
  font-style: normal;
  font-size: 48px;
  color: #000;
  margin-bottom: 0;
}

.landingpage_is_sticky__Km9Ty {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}

.landingpage_is_sticky__Km9Ty::before {
  height: 160%;
  position: absolute;
}

header {
  z-index: 9;
  position: relative;
}

.landingpage_header_section__eWp\\+J {
  position: sticky;
  z-index: 999;
  top: 0;
  padding-top: 15px;
}

.landingpage_MyStoryFlowInfo__u-zOd,
.landingpage_PackagesInfoInnerImg__dXNPB,
.landingpage_activeEffect__moV0-,
.landingpage_backbtn__JCEeY,
.landingpage_banner__GQV94 .landingpage_bannerSlideCar__GLM3r,
.landingpage_bannerLeft__4go00,
.landingpage_btnFill__Ctw\\+3,
.landingpage_btnStory__C12kQ,
.landingpage_headerGs__HYoJR,
.landingpage_header_section__eWp\\+J .landingpage_navheader__PpA9S,
.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a,
.landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O,
.landingpage_sharestorysec__AIFxv,
.landingpage_signUpInfo__lrGdo,
.landingpage_storyPageMain__C2nSX {
  position: relative;
}

.landingpage_header_section__eWp\\+J .landingpage_navheader__PpA9S .landingpage_navheaderBgImg__OxKhc {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.landingpage_header_section__eWp\\+J::before {
  height: 165%;
  position: absolute;
}

.landingpage_headerGs__HYoJR p {
  color: #f2dd4e;
}

.landingpage_headerContact__BDbrF,
.landingpage_headerGs__HYoJR,
.landingpage_storynavigatemain__QgymB .landingpage_storynavigatemainInner__RGbmb img:hover {
  cursor: pointer;
}

.landingpage_PasswordUpdatedScreenMain__89uxS .landingpage_PasswordUpdatedBottom__P4K-7 img,
.landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 .landingpage_barcode_inner__OqFVD .landingpage_barcode_box__Urdz8 img,
.landingpage_header_section__eWp\\+J .landingpage_headerGb__NsDub img,
.landingpage_header_section__eWp\\+J .landingpage_headerGsNew__FgHBK img {
  width: 200px;
}

.landingpage_cardborder__Zk6K9 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  height: 512px;
  margin-left: 20%;
}

.landingpage_cardborderthree__nKoeR {
  position: absolute;
  right: 22.9%;
  bottom: 0;
  background-size: contain;
  width: 57%;
  font-size: 32px;
  height: 30%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
}

.landingpage_cardborderfouth__qNzpV {
  display: flex;
  flex: 1 1;
  background-color: #dffdff;
  margin-top: 5px;
  width: 99%;
  height: 92%;
  border-bottom-left-radius: 42px;
  border-bottom-right-radius: 42px;
  align-self: center;
  align-items: center;
  justify-content: center;
  margin-left: 3px;
}

.landingpage_headerGb__NsDub p {
  font-weight: 500;
  font-size: 30px;
  line-height: 39px;
  color: #fff;
}

.landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL p,
.landingpage_storySection__zDXM6 p,
.landingpage_storySectiontwo__HdMel p {
  font-size: 33px;
  line-height: 43px;
  text-align: center;
  font-weight: 700;
}

.landingpage_banner__GQV94 {
  background: #d9eb41;
  position: relative;
  z-index: 0;
  margin-top: -5px;
}

.landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL h1 {
  text-align: center;
  margin-bottom: 20px;
}

.landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL p {
  color: var(--black);
  margin-bottom: 35px;
}

.landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl,
.landingpage_MyStories__xS1Bu .landingpage_PackagesInfoInnerImg__dXNPB,
.landingpage_MyStories__xS1Bu .landingpage_StoryFlowInfoBtn__BLWad,
.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfoInnerImg__dXNPB,
.landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL,
.landingpage_footerLeft__c5Eka,
.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl,
.landingpage_mobileFooter__zaew6 .landingpage_mobilelink__NqFmt,
.landingpage_myaccount_main__ToIhz .landingpage_logout__b7eba,
.landingpage_signUpOtp__hGlWQ,
.landingpage_socialIcon__UuuAD {
  text-align: center;
}

.landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL span {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #000;
}

.landingpage_banner__GQV94 .landingpage_owl-dots__6nUIx {
  position: absolute;
  width: 100%;
}

.landingpage_swiperNavBanner__L6H1D {
  position: absolute;
  top: 0;
  right: 0;
  align-items: center;
}

.landingpage_swiperNavBannertwo__ZClJ9 {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 99;
  width: 100%;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiperNavBanner__L6H1D .landingpage_page_num__WXNI7 {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  color: #000;
}

.landingpage_swiperNavBanner__L6H1D button,
.landingpage_swiperNavBannertwo__ZClJ9 button,
.landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH button {
  border: 0;
  background: 0 0;
}

.landingpage_swiperNavBanner__L6H1D button img,
.landingpage_swiperNavBannertwo__ZClJ9 button img {
  max-width: 92px;
}

.landingpage_swiperNavBanner__L6H1D .landingpage_swiperNext__Fr-HA,
.landingpage_swiperNavBannertwo__ZClJ9 .landingpage_swiperNext__Fr-HA {
  transform: rotate(180deg);
}

.landingpage_bannerLeft__4go00 img {
  height: 100%;
}

.landingpage_bannerSlideCar__GLM3r .landingpage_owlSlideText__k14pg {
  justify-content: flex-end;
  align-items: center;
}

.landingpage_bannerLeft__4go00 .landingpage_whtsNew__YQy2a {
  position: absolute;
  top: 20px;
  right: -70px;
}

.landingpage_bannerLeft__4go00 .landingpage_whtsNew__YQy2a img {
  max-width: 200px;
}

.landingpage_cardPickSection__-x4G0 {
  background-color: #f2dd4e;
  padding: 160px 0 60px;
  text-align: center;
  position: relative;
  z-index: 0;
}

.landingpage_cardPickSection__-x4G0::before {
  position: absolute;
  top: 4%;
  left: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  width: 230px;
  height: 352px;
}

.landingpage_cardPickSection__-x4G0 .landingpage_bgImageOverflow__ledaW {
  position: absolute;
  bottom: 155px;
  right: 0;
  overflow: hidden;
  z-index: -1;
}

.landingpage_PasswordUpdatedScreenMain__89uxS p.landingpage_PasswordNewSuccesspara2__Ko0Uk,
.landingpage_cardPickSection__-x4G0 .landingpage_swiperSlide__2xd3F .landingpage_img__XZj7u img {
  margin-bottom: 20px;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiper__EDbDx {
  width: auto;
  height: 500px;
  position: relative;
  overflow: hidden;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiperSlide__2xd3F .landingpage_swiperSlideActive__0E7bW {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH .landingpage_swiperNext__Fr-HA {
  position: absolute;
  top: 0;
  right: 0;
}

.landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH .landingpage_swiperNext__Fr-HA img,
.landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH .landingpage_swiperPrev__WqtYH img {
  width: 75px;
}

.landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH .landingpage_swiperPrev__WqtYH {
  position: absolute;
  top: 0;
  left: 0;
}

.landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH {
  position: absolute;
  top: 32%;
  width: 100%;
  margin-top: -10px;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiperSection__tFPRl {
  position: relative;
  margin: 35px 0 20px;
}

.landingpage_swiper-3d__onPI8 .landingpage_swiperSlideShadow__KRdL\\+ {
  width: auto;
}

.landingpage_cardPickSection__-x4G0 .landingpage_muniaMiddleImg__mwiFo img {
  position: absolute;
  right: 54px;
  top: 158px;
  border-radius: 100%;
}

.landingpage_cardPickSection__-x4G0 .landingpage_cardborderfouth__qNzpV {
  font-weight: 700;
  font-size: 48px;
  text-align: center;
  color: #000;
}

.landingpage_storySection__zDXM6 {
  background: #56cdd5;
  padding: 47px 0 60px;
  text-align: center;
  position: relative;
  z-index: 0;
}

.landingpage_storySection__zDXM6 .landingpage_dashedLine__cAwpn,
.landingpage_storySectiontwo__HdMel .landingpage_dashedLine__cAwpn {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.landingpage_storySection__zDXM6 .landingpage_bgImageStoryNewLeft__-rs1G {
  position: absolute;
  top: 130px;
  left: 0;
}

.landingpage_storySection__zDXM6 .landingpage_bgImageOverflow__ledaW,
.landingpage_storySectiontwo__HdMel .landingpage_bgImageOverflow__ledaW {
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: hidden;
}

.landingpage_storySection__zDXM6 .landingpage_bgImageOverflow__ledaW img,
.landingpage_storySectiontwo__HdMel .landingpage_bgImageOverflow__ledaW img {
  margin-bottom: -100px;
}

.landingpage_storySection__zDXM6 h2,
.landingpage_storySectiontwo__HdMel h2 {
  margin-bottom: 16px;
}

.landingpage_storySection__zDXM6 p,
.landingpage_storySectiontwo__HdMel p {
  margin-bottom: 25px;
  color: #0d5268;
}

.landingpage_storySection__zDXM6 .landingpage_btnStory__C12kQ,
.landingpage_storySectiontwo__HdMel .landingpage_btnStory__C12kQ {
  margin-bottom: 45px;
}

.landingpage_createStorySection__0UUkg,
.landingpage_storySectiontwo__HdMel {
  text-align: center;
  position: relative;
}

.landingpage_storySectiontwo__HdMel .landingpage_dashedLinebottom__t6BpV {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.landingpage_storySectiontwo__HdMel .landingpage_btnStory__C12kQ button {
  margin-right: 17px;
}

.landingpage_googleAdSection__ufifs {
  position: relative;
  padding: 28px 0 31px;
  border: 2.45px solid #000;
}

.landingpage_googleAdSection__ufifs span {
  position: absolute;
  top: 2px;
  right: 14px;
}

.landingpage_googleAdSection__ufifs button {
  position: absolute;
  right: 14px;
  bottom: 14px;
  font-weight: 400;
  font-size: 39px;
  line-height: 46px;
  text-align: center;
  color: #fff;
  border: 0;
  background: #4285f4;
  border-radius: 12px;
  padding: 7px 23px;
  font-family: Roboto, sans-serif;
}

.landingpage_footerMid__ZQV9z a,
.landingpage_footerMid__ZQV9z p {
  font-size: 24px;
  line-height: 31px;
}

.landingpage_footerMidLeft__xizVl a,
.landingpage_footerMidLeft__xizVl p {
  font-size: 24px;
  line-height: 31px;
}

.landingpage_btsSection__l5qw9 {
  padding: 53px 0 62px;
  background-color: var(--green);
  position: relative;
}

.landingpage_btsSection__l5qw9 .landingpage_dashedLine__cAwpn {
  position: absolute;
  bottom: 40%;
  left: 0;
  width: 100%;
}

.landingpage_dashedLine__cAwpn img {
  width: 100%;
}

.landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo {
  margin-bottom: 70px;
  width: 100%;
  height: 400px;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  background-size: contain;
}

.landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button.landingpage_btnUnfill__uGDrD {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  border-image-repeat: stretch;
  border-image-slice: 18;
  border-image-width: 9px;
  border-image-outset: inherit;
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 600px;
  padding: 11px 32px;
  background-color: var(--green);
}

.landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button {
  padding: 20px 32px;
  font-weight: 700;
  font-size: 48px;
  line-height: 62px;
  text-align: center;
  color: #0d5268;
}

.landingpage_btsSection__l5qw9 .landingpage_theaterInfo__nmkAq .landingpage_theaterLeftInfo__PxUNY h4 {
  font-weight: 700;
  font-size: 48px;
  line-height: 62px;
  color: var(--black);
  margin-bottom: 13px;
  text-align: left;
}

.landingpage_btsSection__l5qw9 .landingpage_theaterInfo__nmkAq .landingpage_theaterLeftInfo__PxUNY p {
  font-weight: 500;
  font-size: 28px;
  line-height: 36px;
  color: var(--black);
}

.landingpage_btsSection__l5qw9 .landingpage_theaterInfo__nmkAq .landingpage_storeIconRight__js8d\\+ span {
  display: block;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #000;
  margin-bottom: 12px;
}

.landingpage_btsSection__l5qw9 .landingpage_theaterInfo__nmkAq .landingpage_storeIconRight__js8d\\+ a {
  margin-bottom: 14px;
  display: block;
}

.landingpage_theaterInfo__nmkAq {
  padding-top: 58px;
}

footer {
  background-color: var(--yellow);
  padding: 52px 0 60px;
}

.landingpage_footerLeft__c5Eka .landingpage_socialIcon__UuuAD a {
  margin: 0 9px;
}

.landingpage_faqMain__0o88r h4,
.landingpage_footerLeft__c5Eka .landingpage_footerLogo__hRtO6 img,
.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt {
  margin-bottom: 24px;
}

.landingpage_footerMid__ZQV9z a {
  display: block;
  font-weight: 600;
  color: var(--black);
  margin-bottom: 23px;
}

.landingpage_footerMid__ZQV9z {
  padding-left: 85px;
}

.landingpage_footerMid__ZQV9z p {
  font-weight: 700;
  color: var(--black);
  margin-bottom: 5px;
}
.landingpage_centerImg__82\\+Oo {
  width: 100%;
  max-width: 100%;
  object-fit: contain;
}
.landingpage_footerMidLeft__xizVl a {
  display: block;
  font-weight: 600;
  color: var(--black);
  margin-bottom: 23px;
}

.landingpage_footerMidLeft__xizVl {
  padding-left: 85px;
}

.landingpage_footerMidLeft__xizVl p {
  font-weight: 700;
  color: var(--black);
  margin-bottom: 15px;
}

.landingpage_contactIcon__6C-hH a {
  margin-right: 22px;
  display: inline-block;
  margin-bottom: 53px;
}

.landingpage_footerRight__XMjSl h4 {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  color: var(--black);
  margin-bottom: 6px;
  text-align: left;
}

.landingpage_footerRight__XMjSl p {
  margin-bottom: 30px;
}

.landingpage_footerRight__XMjSl input {
  padding: 13px 20px;
  border: 0;
}

.landingpage_footerRight__XMjSl input:focus,
.landingpage_footerRight__XMjSl input:focus-visible {
  outline: 0;
  border: 0;
}

.landingpage_footerRight__XMjSl input::placeholder {
  font-family: Kodchasan;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: var(--black);
}

.landingpage_LoadingMainChild__KSStZ,
.landingpage_cardFooter__DpSg9 .landingpage_cardfooterName__k7kVi,
.landingpage_downoadGuppyApp__eQPEW .landingpage_GuppyAppInner__DsNDX p,
.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a,
.landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN h4 {
  font-family: "Cabin Sketch", cursive;
}

.landingpage_emailInput__j2Jzp {
  position: relative;
  display: inline-block;
  border: 1px solid #000;
}

.landingpage_emailInput__j2Jzp img {
  background: var(--white);
  border: 0;
  width: 50px;
  height: 50px;
  margin-top: -3px;
}

.landingpage_emailInput__j2Jzp button img {
  height: 53px;
  border: 1px solid var(--black);
  border-left: 0;
  width: 50px;
}

.landingpage_emailInput__j2Jzp input:focus-visible {
  outline: 0;
}

.landingpage_mobileFooter__zaew6 h4 {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #000;
  margin-bottom: 7px;
}

.landingpage_mobileFooter__zaew6 .landingpage_mobilelink__NqFmt a {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000;
  margin: 0 8px;
}

.landingpage_mobileFooter__zaew6 .landingpage_footerMid__ZQV9z {
  padding-left: 0;
}
.landingpage_mobileFooter__zaew6 .landingpage_footerMidLeft__xizVl {
  padding-left: 0;
}

.landingpage_mobileFooter__zaew6 .landingpage_footerLeft__c5Eka p,
.landingpage_mobileFooter__zaew6 .landingpage_footerMid__ZQV9z p {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #000;
  margin-bottom: 12px;
}
.landingpage_mobileFooter__zaew6 .landingpage_footerMidLeft__xizVl p {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #000;
  margin-bottom: 12px;
}

.landingpage_mobileFooter__zaew6 .landingpage_footerRight__XMjSl .landingpage_emailInput__j2Jzp {
  display: block;
  margin-bottom: 24px;
}

.landingpage_mobileFooter__zaew6 .landingpage_footerRight__XMjSl input {
  width: 93%;
}

.landingpage_mobileFooter__zaew6 .landingpage_emailInput__j2Jzp button {
  right: 5px;
}

.landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl .landingpage_PalacecomMainInnerinfo__mAT1e,
.landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb,
.landingpage_mobileFooter__zaew6 .landingpage_footerIconRow__FtgnG {
  display: flex;
  justify-content: space-between;
}

.landingpage_mobileFooter__zaew6 .landingpage_footerIconRow__FtgnG img {
  max-width: 41px;
}

.landingpage_mobileFooter__zaew6 .landingpage_contactIcon__6C-hH a {
  margin-right: 13px;
}

.landingpage_mobileFooter__zaew6 .landingpage_footerLeft__c5Eka .landingpage_socialIcon__UuuAD a {
  margin: 0 3px;
}

.landingpage_navbarToggler__y0Aca {
  background-color: transparent;
  border: 0;
  position: absolute;
}

.landingpage_cardNew__cPEuz {
  border: 4px solid #000;
  border-radius: 40px;
  max-width: 550px;
  margin: auto;
  overflow: hidden;
}

.landingpage_cardFooter__DpSg9 .landingpage_cardfooterName__k7kVi {
  font-weight: 700;
  font-size: 36px;
  line-height: 40px;
  text-align: center;
  color: #000;
}

.landingpage_cardFooter__DpSg9 {
  background: #dffdff;
  border-bottom-left-radius: 40px;
  border-bottom-right-radius: 40px;
  border-top: 6px solid #000;
  padding: 12px 10px;
}

.landingpage_cardHeader__nUyBC img {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.landingpage_signUpBg__6ajTf {
  background-color: #56cdd5;
}

.landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z {
  text-align: center;
  padding-top: 95px;
}

.landingpage_signUpInfo__lrGdo::after {
  position: absolute;
  top: 40px;
  right: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  width: 10px;
  height: 436px;
  left: 50%;
}

.landingpage_ContactBottom__U6x2n::before,
.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  background-repeat: no-repeat;
  height: 10%;
  width: 100%;
  content: "";
}

.landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z img {
  border-radius: 100%;
}

.landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z h5 {
  font-weight: 600;
  font-size: 28px;
  line-height: 36px;
  color: #000;
  margin-bottom: 0;
}

.landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z p {
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  text-align: center;
  color: #000;
  margin-bottom: 30px;
}

.landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z .landingpage_socialIcon__UuuAD,
.landingpage_storynavigatemain__QgymB .landingpage_storynavigatemainInner__RGbmb {
  display: flex;
  justify-content: center;
}

.landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z .landingpage_socialIcon__UuuAD img {
  width: 83px;
  border-radius: 0;
  margin: 0 42px;
}

form label {
  font-style: italic;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  display: block;
  margin-bottom: 0;
}

form input {
  background: #fff;
  border-radius: 22px;
  border: 3px solid #000;
  width: 100%;
  height: 67px;
  padding: 0 15px;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt span {
  font-weight: 400;
  font-size: 22px;
  line-height: 27px;
  color: #000;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt .landingpage_checkboxdiv__1s2XC {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt span a {
  text-decoration: underline;
  color: #000;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt .landingpage_checkboxdiv__1s2XC input[type="checkbox"] {
  max-width: 6%;
  flex: 0 0 6%;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt .landingpage_checkboxdiv__1s2XC span {
  max-width: 93%;
  flex: 0 0 93%;
  font-family: Inter, sans-serif;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt .landingpage_checkboxdiv__1s2XC button {
  width: auto;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  opacity: 0.5;
  margin-top: 15px;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_btndiv__gSekl {
  margin-top: 30px;
  text-align: center;
}

.landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S {
  padding-left: 86px;
}

.landingpage_arrowImgMain__k6Tgg {
  position: relative;
  padding: 156px 0;
  overflow: hidden;
}

.landingpage_signLogRightLine__lTD86 {
  position: absolute;
  top: -60px;
  right: -55px;
}

.landingpage_signBgLeft__SfKCz {
  position: absolute;
  bottom: 0;
  left: 0;
}

.landingpage_loginBg__JZmcK {
  background: #f2dd4e;
}

.landingpage_loginBg__JZmcK .landingpage_forgerPass__DTiZ6 {
  margin: 25px 0 32px;
}

.landingpage_loginBg__JZmcK .landingpage_forgerPass__DTiZ6 a {
  display: block;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  text-align: right;
  color: #000;
}

.landingpage_loginBg__JZmcK .landingpage_againreg__EAIEE {
  margin-top: 43px;
  text-align: center;
}

.landingpage_loginBg__JZmcK .landingpage_againreg__EAIEE p {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #000;
  display: inline-block;
}

.landingpage_loginBg__JZmcK .landingpage_againreg__EAIEE a {
  display: inline-block;
  color: #000;
  text-decoration: underline;
}

.landingpage_TermsConditionsMain__wM2cb span,
.landingpage_faqMain__0o88r span,
form input,
form textarea {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #000;
}

.landingpage_myavtarsection__6IZ7k {
  padding: 57px 0;
  background: #56cdd5;
  text-align: center;
}

.landingpage_backbtn__JCEeY a {
  position: absolute;
  left: 0;
  top: 10px;
}

.landingpage_backbtn__JCEeY img {
  width: 85px;
}

.landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN h4 {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
  color: #000;
  margin-bottom: 25px;
}

.landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN .landingpage_avtarMain__XNI0G {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN .landingpage_avtarmainInfo__\\+AuSN {
  flex: 0 0 30%;
  max-width: 30%;
  margin-top: 30px;
}

.landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN .landingpage_avtarmainInfo__\\+AuSN p {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  color: #000;
  margin-top: 15px;
}

.landingpage_myavtarsection__6IZ7k .landingpage_backbtn__JCEeY a {
  left: 85px;
}

.landingpage_ContactTop__-7\\+Ca {
  background: #56cdd5;
  padding: 39px 0;
}

.landingpage_ContactTop__-7\\+Ca .landingpage_contactTopInfo__sIedu h4,
.landingpage_MyStoryFlowMain__PvUat h4,
.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menuMainInnerImg__Y5ME5 {
  margin-bottom: 37px;
}

.landingpage_ContactTop__-7\\+Ca .landingpage_contactTopInfo__sIedu p {
  font-weight: 500;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  margin-bottom: 45px;
}

.landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 span {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  margin-bottom: 19px;
  display: inline-block;
}

.landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 .landingpage_socialIcon__UuuAD span {
  text-decoration-line: underline;
  font-weight: 500;
  margin-bottom: 0;
}

.landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 .landingpage_socialIcon__UuuAD {
  text-align: left;
  margin-bottom: 24px;
}

.landingpage_PackagesMain__vvtmP h4,
.landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 .landingpage_socialIcon__UuuAD:nth-child(n) {
  margin-bottom: 15px;
}

.landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 .landingpage_socialIcon__UuuAD img {
  margin-right: 32px;
}

.landingpage_ContactBottom__U6x2n {
  background: #d9eb41;
  padding: 70px 0 45px;
  position: relative;
}

.landingpage_ContactBottom__U6x2n::before {
  position: absolute;
  top: 0;
  left: 0;
  background-size: contain;
}

.landingpage_ContactBottom__U6x2n form label {
  margin-bottom: 10px;
}

.landingpage_contactSection__EICPg .landingpage_backbtn__JCEeY a {
  left: 80px;
}

.landingpage_ContactBottom__U6x2n form,
.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createStoryMidInner__0rqe3,
.landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.landingpage_ContactBottom__U6x2n form .landingpage_wrapdiv__kXFlt {
  margin-bottom: 20px;
  flex: 0 0 48%;
  max-width: 48%;
}

.landingpage_ContactBottom__U6x2n form textarea {
  background: #fff;
  border-radius: 22px;
  border: 3px solid #000;
  width: 100%;
  padding: 10px 15px;
}

.landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl,
.landingpage_ContactBottom__U6x2n form,
.landingpage_contactTopInfo__sIedu {
  margin: 0 95px;
}

.landingpage_ContactBottom__U6x2n form .landingpage_wrapdiv__kXFlt:last-child {
  flex: 100% 1;
  max-width: 100%;
}

.landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl button {
  margin: 0 10px;
}

.landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl button.landingpage_btnUnfill__uGDrD {
  border-image-outset: 0 0 0 0;
}

.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en::before {
  position: absolute;
  top: 80%;
  left: 0;
  background-size: cover;
  z-index: -1;
}

.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en {
  position: relative;
  background: #d9eb41;
  padding-top: 15px;
  z-index: 2;
}

.landingpage_myaccount_main__ToIhz .landingpage_account_bottom_main__U-sTv {
  background: #d9eb41;
  padding-top: 57px;
  padding-bottom: 12px;
  min-height: 100vh;
  position: relative;
  z-index: 0;
}

.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en img {
  width: 252px;
  max-width: 20%;
  flex: 0 0 20%;
}

.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span {
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  color: #0d5268;
  display: inline-block;
  margin-left: 25px;
  max-width: 75%;
  flex: 0 0 75%;
}

.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span .landingpage_Uid__Mwqbl {
  margin-left: 0;
}

.landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span strong {
  font-weight: 600;
  font-size: 48px;
  line-height: 62px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
}

.landingpage_myaccount_main__ToIhz .landingpage_logout__b7eba a {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #0d5268;
  text-transform: uppercase;
}

.landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O img {
  position: absolute;
  top: -35px;
  left: -26px;
}

.landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O a {
  background: #0d5268;
  display: flex;
  height: 85px;
  padding: 0 80px;
  margin: 0 35px 57px;
  align-items: center;
  justify-content: center;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 20px;
  border-image-outset: 3px;
  border-style: solid;
}

.landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O span {
  font-weight: 600;
  font-size: 36px;
  line-height: 36px;
  text-align: center;
  color: #d9eb41;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz .landingpage_profile_top_img__RM0\\+1 {
  text-align: center;
  margin-bottom: 12px;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz h4 {
  margin-bottom: 19px;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz {
  background: #56cdd5;
  padding: 44px 0;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz form .landingpage_profileInfo__OtQHM {
  flex: 0 0 50%;
  max-width: 50%;
  padding-right: 56px;
  margin-bottom: 11px;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz form .landingpage_profileInfo__OtQHM label {
  margin-bottom: 11px;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_bottom__N52NV {
  background: #d9eb41;
  padding: 75px 0 21px;
  position: relative;
  text-align: center;
  min-height: 50vh;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_bottom__N52NV button {
  margin-right: 18px;
  width: 25%;
}

.landingpage_edit_profile_section__ujP6U .landingpage_profile_bottom__N52NV button.landingpage_btnUnfill__uGDrD {
  border-image-outset: 2 0 8px 0;
}

.landingpage_faqMain__0o88r {
  background: #d9eb41;
  padding: 25px 0;
  position: relative;
  overflow: hidden;
}

.landingpage_faqMain__0o88r::before {
  content: "";
  position: absolute;
  top: 70px;
  left: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  width: 164px;
  height: 234px;
  transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
}

.landingpage_FaqBottom_main__-jPww .landingpage_faqBottomimg__xQw9W,
.landingpage_backtotop__s\\+C1y img {
  transform: rotate(90deg);
}

.landingpage_faqMain__0o88r p {
  font-weight: 600;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  margin-bottom: 22px;
}

.landingpage_faqMain__0o88r .landingpage_faqTop__f7jup span {
  margin-bottom: 38px;
  text-align: center;
  display: block;
}

.landingpage_faqMain__0o88r .landingpage_accordionTitle__hlkBF {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.landingpage_faqMain__0o88r .landingpage_accordionTitle__hlkBF span .landingpage_accordianArrrow__rGDFN {
  transform: rotate(-90deg);
  cursor: pointer;
}

.landingpage_faqMain__0o88r .landingpage_accordionItem__2MEgW {
  background: #56cdd5;
  border: 5px solid #000;
  border-radius: 34px;
  padding: 0 67px;
  margin-bottom: 35px;
}

.landingpage_faqMain__0o88r .landingpage_faqbgImg__DKgMn {
  position: absolute;
  right: 20px;
  bottom: 0;
}

.landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR span {
  font-style: italic;
  font-weight: 500;
  display: block;
  margin-bottom: 15px;
}

.landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR a {
  display: block;
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  margin-bottom: 15px;
}

.landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR .landingpage_accordianConImg__QTaNA {
  background: #000;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
}

.landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR .landingpage_accordianConImg__QTaNA .landingpage_img__XZj7u {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.landingpage_downoadGuppyApp__eQPEW {
  background: #d9eb41;
  padding: 35px 0 50px;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_GuppyAppInner__DsNDX {
  background: #0d5268;
  text-align: center;
  padding: 19px 0 30px;
  height: 100%;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_GuppyAppInner__DsNDX p {
  font-weight: 400;
  font-size: 36px;
  line-height: 42px;
  text-align: center;
  color: #d9eb41;
  margin-bottom: 25px;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 p {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  color: #000;
  text-align: left;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 span {
  font-weight: 500;
  font-size: 22px;
  line-height: 29px;
  color: #000;
  margin-bottom: 32px;
  display: block;
  text-align: left;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 .landingpage_barcode_inner__OqFVD p {
  margin-bottom: 10px;
  text-align: center;
  font-weight: 600;
  font-size: 26px;
  line-height: 34px;
  color: #000;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 {
  text-align: center;
  padding-left: 35px;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_left__VB8yg {
  border: 3px solid #0d5268;
  padding: 5px;
}

.landingpage_menuMain__CIvXY {
  background: #0d5268;
  padding: 41px 0 20px;
  position: relative;
  z-index: 1;
}

.landingpage_menuMain__CIvXY::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  position: absolute;
  bottom: 10%;
  left: 5;
  width: 171px;
  height: 137px;
  z-index: -1;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 {
  font-weight: 700;
  font-size: 40px;
  line-height: 52px;
  color: #f2dd4e;
  text-align: center;
  margin-bottom: 16px;
  display: inline-block;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-image-outset: 8px;
  border-style: solid;
  padding: 0 27px;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs .landingpage_menuMainhead_inner__FfSW6 {
  margin-top: 16px;
  position: relative;
  z-index: 2;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs .landingpage_menuMainhead_inner__FfSW6 img {
  flex: 0 0 25%;
  max-width: 25%;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs .landingpage_menuMainhead_inner__FfSW6 span {
  flex: 0 0 62%;
  max-width: 62%;
  text-align: left;
}

.landingpage_menuMain__CIvXY a.landingpage_logoutMenu__le580 {
  display: block;
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  color: #f2dd4e;
  margin-top: 15px;
}

.landingpage_logoutMenuBottomNew__Plo0X {
  margin-top: 30px;
  text-align: center;
  display: flex;
  justify-content: space-around;
}

.landingpage_logoutMenuBottomNew__Plo0X a.landingpage_logoutMenuBottoma__C2qUI {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #f2dd4e;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 img {
  margin-left: 15px;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
  display: inline-block;
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  color: #000;
  background: #d9eb41;
  padding: 10px 65px;
  margin-bottom: 27px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  border-image-repeat: stretch;
  border-image-slice: 10;
  border-image-width: 15px;
  border-style: solid;
  border-image-outset: 1;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu a {
  background: #56cdd5;
  margin: 0 25px;
  width: 35%;
  padding: 10px 15px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  border-image-repeat: stretch;
  border-image-slice: 10;
  border-image-width: 15px;
  border-style: solid;
  border-image-outset: 1;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu {
  margin-bottom: 74px;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menuMainInnerImg__Y5ME5 img {
  margin: 0 13px;
  max-width: 274px;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs {
  text-align: center;
  z-index: 0;
  position: relative;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs span {
  font-weight: 500;
  font-size: 24px;
  line-height: 31px;
  color: #f2dd4e;
  margin-left: 25px;
  display: inline-block;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs span strong {
  font-weight: 600;
  font-size: 48px;
  line-height: 62px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.landingpage_MyStoryFlowInfo__u-zOd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 442px;
  background: #d9eb41;
  border-radius: 40px;
  padding: 36px 18px 24px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 16px;
  border-image-outset: 1;
  border-style: solid;
}

.landingpage_StoryFlowTop__9XFEz:nth-child(2n) .landingpage_MyStoryFlowInfo__u-zOd,
.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD {
  background: #f2dd4e;
}

.landingpage_StoryFlowTop__9XFEz {
  margin-bottom: 35px;
}

.landingpage_MyStoryFlowMainExpand__mmOZv {
  width: 70%;
  margin: auto;
  text-align: center;
}

.landingpage_StoryFlowInfoBtn__BLWad button {
  position: relative;
  padding: 0 80px;
  margin-top: 70px;
}

.landingpage_StoryFlowInfoBtn__BLWad button img {
  position: absolute;
  left: -125px;
  top: -80px;
}

.landingpage_MyStoryFlowMain__PvUat .landingpage_StoryFlowTop__9XFEz:nth-child(2n),
.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n),
.landingpage_leftalign__lfnY6 {
  text-align: -webkit-right;
}

.landingpage_MyStoryFlowInfo__u-zOd .landingpage_MyStoryFlowInner__Kdfmu h5 {
  font-weight: 700;
  font-size: 36px;
  line-height: 51px;
  color: #000;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.landingpage_MyStoryFlowInfo__u-zOd .landingpage_MyStoryFlowInner__Kdfmu p {
  font-weight: 700;
  font-size: 24px;
  line-height: 34px;
  color: #000;
  text-align: left;
}

.landingpage_MyStoryFlowMain__PvUat {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_47___}) bottom/cover
    no-repeat;
  padding: 40px 0;
}

.landingpage_StoryFlows_top__NuDly .landingpage_StoryFlowTop__9XFEz .landingpage_MyStoryFlowInfo__u-zOd {
  margin: auto;
  padding: 24px 20px;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlows_top__NuDly {
  background: #56cdd5;
  padding: 40px 0 20px;
  position: relative;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bottom__3eYYZ {
  background: #dffdff;
  padding: 59px 0;
  text-align: center;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bottom__3eYYZ .landingpage_StoryFlowInfo__6Ytzx p {
  font-weight: 500;
  font-size: 36px;
  line-height: 50px;
  color: #000;
  margin-top: 25px;
  text-align: left;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bottom__3eYYZ .landingpage_StoryFlowInfo__6Ytzx p:last-child {
  line-height: 47px;
  margin: 0 80px 25px;
  font-style: italic;
  text-align: center;
}

.landingpage_StoryFlow_bottomBtn__YFqsw {
  background: #56cdd5;
  padding: 69px 0;
  text-align: center;
  position: relative;
}

.landingpage_StoryFlow_bottomBtn__YFqsw::before,
.landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlows_top__NuDly::before {
  content: "";
  left: 0;
  top: 0;
  position: absolute;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_48___}) no-repeat;
  width: 15%;
  height: 86%;
}

.landingpage_Storysharebtn__Xq0oQ a {
  position: absolute;
  top: 19%;
  right: 18%;
}

.landingpage_StoryFlows_top__NuDly .landingpage_MyStoryFlowInfo__u-zOd {
  position: relative;
  background: #d9eb41 !important;
}

.landingpage_StoryFlows_top__NuDly .landingpage_MyStoryFlowInfoeditpencil__CKGvY {
  content: "";
  position: absolute;
  top: -30px;
  right: -35px;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bgimg__deUMR {
  position: absolute;
  right: 0;
  bottom: 0;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV a {
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: #121212;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV {
  text-align: right;
  position: relative;
}

.landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV img.landingpage_storyTopImg__HkE2l {
  position: absolute;
  top: 10px;
  left: 0;
}

.landingpage_sharestorysecbg__fqoqD {
  background: #eff7ff;
  text-align: center;
}

.landingpage_sharestorysecbg__fqoqD .landingpage_sharestorysec__AIFxv button {
  position: relative;
  padding: 20px 60px;
}

.landingpage_sharestorysecbg__fqoqD .landingpage_sharestorysec__AIFxv button img {
  position: absolute;
  top: -85px;
  left: -60px;
}

.landingpage_sharestorysecbg__fqoqD .landingpage_sharestorysec__AIFxv {
  padding: 77px 0 50px;
}

.landingpage_theEndImg__KceN5 {
  text-align: center;
  position: relative;
  padding: 25px 0;
}

.landingpage_backtotop__s\\+C1y,
.landingpage_storyPageMainBottom__LY77y {
  text-align: left;
}

.landingpage_backtotop__s\\+C1y img {
  width: 98px;
}

.landingpage_ViewCardStory__QSRQZ .landingpage_mystoriesInnerInfo__3Hxzr {
  background: #d9eb41;
  padding: 20px 10px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 4px solid #1c2452;
  border-radius: 5px;
}

.landingpage_ViewCardStory__QSRQZ .landingpage_cardHeader__nUyBC img {
  border-radius: 0;
}

.landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz {
  border: 4px solid #1c2452;
  border-radius: 5px;
}

.landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz .landingpage_cardFooterNew__Gp5tU .landingpage_mystoriesInnerInfo__3Hxzr h3 {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  color: #000;
}

.landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz .landingpage_cardFooterNew__Gp5tU .landingpage_mystoriesInnerInfo__3Hxzr p {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  margin-bottom: 0;
  text-align: left;
}

.landingpage_activeEffect__moV0-:focus-visible {
  outline: 0;
}

@media (min-width: 768px) {
  .landingpage_activeEffect__moV0- {
    font-size: 36px;
    line-height: 42px;
  }
  .landingpage_btnFillRight__vprmz {
    margin-left: 50px;
  }
  .landingpage_header_section__eWp\\+J .landingpage_navheader__PpA9S .landingpage_navheaderBgImg__OxKhc,
  .landingpage_mobileFooter__zaew6 {
    display: none;
  }
  .landingpage_ZidZagDesktopStory__Wi\\+yI {
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
  }
}

@media (max-width: 767px) {
  .landingpage_activeEffect__moV0- {
    font-size: 24px !important;
    line-height: 28px !important;
  }
  .landingpage_cardNew__cPEuz {
    border: 3px solid #000;
    border-radius: 20px;
  }
  .landingpage_cardHeader__nUyBC {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .landingpage_cardFooter__DpSg9 {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_cardHeader__nUyBC img {
    width: 279px !important;
    height: 176px !important;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz .landingpage_cardFooterNew__Gp5tU .landingpage_mystoriesInnerInfo__3Hxzr,
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
    padding: 10px;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz .landingpage_cardFooterNew__Gp5tU .landingpage_mystoriesInnerInfo__3Hxzr h3 {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 0;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_swiperSection__tFPRl .landingpage_swiperSectionInfo_inner__m0gQX {
    margin-top: 55px !important;
    height: 22em !important;
    margin-bottom: 10px;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz {
    width: 60%;
    border: 3px solid #1c2452;
  }
  .landingpage_ContactTop__-7\\+Ca .landingpage_contactTopInfo__sIedu p br,
  .landingpage_StoryFlow_bottomBtn__YFqsw::before,
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bgimg__deUMR,
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlows_top__NuDly::before,
  .landingpage_ZidZagDesktopStory__Wi\\+yI,
  .landingpage_banner__GQV94 .landingpage_bannerSlideCar__GLM3r .landingpage_swiperNav__KUIrH,
  .landingpage_cardPickSection__-x4G0 .landingpage_bgImageOverflow__ledaW img,
  .landingpage_cardPickSection__-x4G0:before,
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75:first-child span,
  .landingpage_dashedLine__cAwpn,
  .landingpage_desktopFooter__uHw7\\+,
  .landingpage_faqMain__0o88r .landingpage_faqbgImg__DKgMn,
  .landingpage_headerGb__NsDub,
  .landingpage_headerGs__HYoJR,
  .landingpage_header_section__eWp\\+J::before,
  .landingpage_menuMain__CIvXY .landingpage_backbtn__JCEeY,
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs .landingpage_menuMainhead_inner__FfSW6::after,
  .landingpage_signUpInfo__lrGdo::after,
  .landingpage_storySection__zDXM6 p,
  .landingpage_swiperNav__KUIrH,
  .landingpage_swiperNavBanner__L6H1D,
  .landingpage_theaterInfo__nmkAq {
    display: none;
  }
  .landingpage_MuniaMiddle__p\\+N7F {
    width: 80px !important;
  }
  .landingpage_edit_profile_section__ujP6U .landingpage_profile_bottom__N52NV {
    padding: 45px 0 21px;
  }
  .landingpage_edit_profile_section__ujP6U .landingpage_profile_bottom__N52NV button {
    width: 40%;
  }
  .landingpage_contactSection__EICPg .landingpage_backbtn__JCEeY a,
  .landingpage_menuMain__CIvXY::after {
    left: 0;
  }
  .landingpage_StoryFlows_top__NuDly .landingpage_MyStoryFlowInfoeditpencil__CKGvY {
    top: 0;
    right: 0;
  }
  .landingpage_backtotop__s\\+C1y img {
    width: 57px;
  }
  .landingpage_Storysharebtn__Xq0oQ a {
    right: 0;
    bottom: 0;
    top: auto;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlows_top__NuDly .landingpage_MyStoryFlowInfo__u-zOd {
    padding: 15px 10px;
    max-width: 195px;
    position: initial;
  }
  .landingpage_StoryFlowTop__9XFEz {
    position: relative;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlows_top__NuDly {
    margin-bottom: 0;
  }
  .landingpage_Storysharebtn__Xq0oQ a img {
    width: 45px;
  }
  .landingpage_StoryFlows_top__NuDly .landingpage_MyStoryFlowInfo__u-zOd::after {
    top: 40px;
    right: -51px;
    background-size: contain;
  }
  .landingpage_theEndImg__KceN5 {
    padding: 15px 0;
  }
  .landingpage_sharestorysecbg__fqoqD .landingpage_sharestorysec__AIFxv {
    padding: 25px 0 50px;
  }
  .landingpage_sharestorysecbg__fqoqD .landingpage_sharestorysec__AIFxv button img {
    max-width: 77px;
    top: -47px;
    left: -25px;
  }
  .landingpage_sharestorysecbg__fqoqD .landingpage_sharestorysec__AIFxv button {
    padding: 10px 35px;
  }
  .landingpage_StoryFlow_bottomBtn__YFqsw {
    padding: 25px 0;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV img.landingpage_storyTopImg__HkE2l {
    width: 26px;
    height: 42px;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV a {
    font-size: 14px;
    line-height: 18px;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_Viewfullstory__KUltV a img {
    width: 49px;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bottom__3eYYZ .landingpage_StoryFlowInfo__6Ytzx p {
    font-size: 24px;
    line-height: 34px;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bottom__3eYYZ .landingpage_StoryFlowInfo__6Ytzx p:last-child {
    font-size: 24px;
    line-height: 31px;
    margin: 0 10px 20px;
  }
  .landingpage_MyStoryFlowMain__PvUat .landingpage_backbtn__JCEeY a {
    left: -12px;
    top: -5px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd {
    border-image-slice: 16;
    border-image-width: 10px;
    border-image-outset: 1;
    max-width: 250px;
    border-radius: 25px;
    padding: 15px 10px;
  }
  .landingpage_MyStoryFlowMainExpand__mmOZv {
    width: 100%;
  }
  .landingpage_MyStoryFlowMain__PvUat {
    background-position: right;
  }
  .landingpage_StoryFlowInfoBtn__BLWad button {
    line-height: 26px;
    padding: 0 55px;
    margin-top: 25px;
  }
  .landingpage_StoryFlowInfoBtn__BLWad button img {
    max-width: 115px;
    left: -50px;
    top: -42px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd .landingpage_MyStoryFlowInner__Kdfmu h5 {
    font-size: 18px;
    line-height: 28px;
    width: 175px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd .landingpage_MyStoryFlowInner__Kdfmu p {
    font-size: 12px;
    line-height: 16px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd img,
  .landingpage_backbtn__JCEeY img,
  .landingpage_faqMain__0o88r .landingpage_accordionTitle__hlkBF img,
  .landingpage_faqMain__0o88r .landingpage_faqBottom__BIdlo img {
    max-width: 45px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu a {
    margin: 15px auto 0;
    display: block;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu {
    margin: 0 20px 59px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a img {
    max-width: 50px;
  }
  .landingpage_menuMain__CIvXY a.landingpage_logoutMenu__le580 {
    text-align: center;
    font-size: 18px;
    line-height: 23px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl {
    margin-top: 32px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menuMainInnerImg__Y5ME5 img {
    max-width: 175px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 img {
    max-width: 25px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 {
    font-size: 20px;
    line-height: 26px;
    padding: 0;
  }
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb,
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 span,
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 strong,
  .landingpage_signUpInfo__lrGdo {
    display: block;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 span {
    margin-left: 14px;
    font-size: 18px;
    line-height: 23px;
    vertical-align: middle;
    display: inline-block;
    text-align: left;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 span b {
    font-weight: 400;
    display: block;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 strong {
    font-size: 36px !important;
    line-height: 47px !important;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 img {
    max-width: 97px;
  }
  .landingpage_downoadGuppyApp__eQPEW {
    margin-top: -25px;
  }
  .landingpage_btnFill__Ctw\\+3,
  .landingpage_btnUnfill__uGDrD {
    margin: 0 5px;
  }
  .landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 {
    padding-left: 15px;
  }
  .landingpage_banner__GQV94,
  .landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL h1,
  .landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL p,
  .landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 p,
  .landingpage_downoadGuppyApp__eQPEW .landingpage_downoadGuppyApp_right__aW-S4 span {
    text-align: center;
  }
  .landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR .landingpage_accordianConImg__QTaNA {
    height: 150px;
  }
  .landingpage_faqMain__0o88r .landingpage_faqBottom__BIdlo,
  .landingpage_faqMain__0o88r .landingpage_faqTop__f7jup span,
  .landingpage_myaccount_main__ToIhz .landingpage_logout__b7eba a,
  .landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN .landingpage_avtarmainInfo__\\+AuSN p {
    font-size: 18px;
    line-height: 23px;
  }
  .landingpage_faqMain__0o88r .landingpage_accordionItem__2MEgW {
    padding: 5px 18px;
  }
  .landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR a,
  .landingpage_faqMain__0o88r .landingpage_accordionContent__BN-aR span {
    font-size: 16px;
    line-height: 21px;
  }
  .landingpage_faqMain__0o88r .landingpage_accordionTitle__hlkBF span {
    font-size: 20px;
    line-height: 26px;
  }
  .landingpage_ContactTop__-7\\+Ca .landingpage_contactTopInfo__sIedu p,
  .landingpage_btnFill__Ctw\\+3,
  .landingpage_faqMain__0o88r p {
    font-size: 24px;
    line-height: 31px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en h4,
  .landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN h4,
  h4 {
    font-size: 24px;
    line-height: 28px;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo {
    margin-bottom: 0 !important;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz .landingpage_cardFooterNew__Gp5tU .landingpage_mystoriesInnerInfo__3Hxzr p {
    display: block;
    font-size: 12px;
    line-height: 16px;
  }
  .landingpage_cardPickSection__-x4G0 {
    padding: 52px 0;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button {
    font-size: 18px;
    line-height: 23px;
    max-width: 400px !important;
  }
  footer {
    padding: 12px 0;
  }
  .landingpage_btsSection__l5qw9 {
    padding: 18px 0;
  }
  .landingpage_googleAdSection__ufifs img {
    max-width: 235px;
    height: 47px;
  }
  .landingpage_googleAdSection__ufifs span a img {
    height: auto;
  }
  .landingpage_googleAdSection__ufifs button {
    font-size: 16px;
    line-height: 19px;
  }
  h1 {
    font-size: 40px;
    line-height: 42px;
  }
  h2 {
    font-size: 30px;
    line-height: 32px;
  }
  .landingpage_btnUnfill__uGDrD {
    font-size: 24px;
    line-height: 28px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSection__tFPRl {
    margin-top: 9px;
  }
  .landingpage_footerMid__ZQV9z .landingpage_contactIcon__6C-hH a {
    margin-bottom: 20px;
  }
  .landingpage_footerMidLeft__xizVl .landingpage_contactIcon__6C-hH a {
    margin-bottom: 20px;
  }
  .landingpage_storySection__zDXM6 h2 {
    font-size: 45px;
    line-height: 46px;
    margin-bottom: 27px;
  }
  .landingpage_storySection__zDXM6 .landingpage_btnStory__C12kQ button.landingpage_btnUnfill__uGDrD {
    font-size: 24px;
    line-height: 31px;
    background-color: #0d5268;
    color: #fff;
    padding: 7px 35px;
    border-image-outset: 8px 5px 8px;
    margin: 0 12px;
  }
  .landingpage_storySection__zDXM6 {
    padding: 24px 0;
  }
  .landingpage_storySection__zDXM6:before {
    top: auto;
    width: 180px;
    left: -94px;
    height: 150px;
    bottom: 0;
  }
  .landingpage_storySection__zDXM6 .landingpage_bgImageOverflow__ledaW img {
    margin-bottom: 62px;
    max-width: 70px;
  }
  .landingpage_storySection__zDXM6 .landingpage_recordBg__sQ9dF {
    max-width: 177px;
    margin: auto;
    position: relative;
    z-index: 0;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSlide__2xd3F .landingpage_img__XZj7u img {
    max-width: 292px;
  }
  .landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL p {
    font-size: 25px;
    line-height: 28px;
  }
  .landingpage_headerContact__BDbrF img,
  .landingpage_navbarTogglerIcon__a9y4M img {
    max-width: 28px;
  }
  .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S {
    padding: 15px 15px 0;
  }
  .landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z {
    padding-top: 0;
    margin-bottom: 44px;
    position: relative;
  }
  .landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z::after {
    content: "";
    position: absolute;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    left: 0;
    margin-top: 15px;
  }
  .landingpage_signBgLeft__SfKCz img,
  .landingpage_signLogRightLine__lTD86 img {
    max-width: 119px;
  }
  .landingpage_signBgLeft__SfKCz {
    top: 8%;
    left: -13px;
    bottom: initial;
  }
  .landingpage_signLogRightLine__lTD86 {
    top: 5%;
    right: -15px;
  }
  .landingpage_arrowImgMain__k6Tgg {
    padding: 60px 0 15px;
  }
  .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form input,
  form input {
    height: 53px;
  }
  .landingpage_navheader__PpA9S {
    padding: 0 0 8px;
  }
  .landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN img {
    max-width: 351px;
  }
  .landingpage_avtarBody__iAICN .landingpage_avtarmainInfo__\\+AuSN img {
    max-width: 157px;
  }
  .landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN .landingpage_avtarmainInfo__\\+AuSN {
    flex: 0 0 45%;
    max-width: 45%;
  }
  .landingpage_myavtarsection__6IZ7k {
    margin-top: -25px;
    padding: 20px 0;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en {
    background: #56cdd5;
    padding-bottom: 17px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en img {
    width: 97px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span strong {
    display: block;
    font-size: 36px;
    line-height: 47px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span {
    margin-left: 14px;
    font-weight: 400;
    font-size: 18px;
    line-height: 23px;
    vertical-align: middle;
    display: block;
    flex-wrap: wrap;
    align-items: baseline;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span .landingpage_Uid__Mwqbl {
    font-size: 12px;
    line-height: 16px;
    margin-left: 0;
    display: inline-block;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en::before {
    top: 102%;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O span {
    font-size: 26px;
    line-height: 34px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O a {
    height: 75px;
    margin: 0 35px 21px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O:first-child img {
    width: 100px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O img {
    top: -9px;
    left: 20px;
    width: 80px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_logout__b7eba {
    text-align: left;
  }
  .landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl,
  .landingpage_ContactBottom__U6x2n form,
  .landingpage_contactTopInfo__sIedu {
    margin: 0;
  }
  .landingpage_ContactBottom__U6x2n form .landingpage_wrapdiv__kXFlt {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .landingpage_edit_profile_section__ujP6U .landingpage_profile_top__1Qqjz form .landingpage_profileInfo__OtQHM {
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 0;
  }
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_socialIcon__UuuAD span {
    display: inline-block !important;
    font-size: 18px;
    line-height: 23px;
    font-family: Kodchasan, sans-serif !important;
  }
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_socialIcon__UuuAD {
    text-align: center !important;
  }
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 span {
    font-family: "Cabin Sketch", cursive;
    display: block;
    text-align: center;
  }
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 .landingpage_socialIcon__UuuAD img {
    margin-right: 15px;
    width: 45px;
  }
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li,
.landingpage_storyBtn__rd8vk {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

@media (max-width: 460px) {
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
    font-size: 25px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menuMainInnerImg__Y5ME5 img {
    max-width: 100px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 span {
    font-size: 16px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 img {
    max-width: 100px !important;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 span strong {
    font-size: 30px !important;
    line-height: 30px !important;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 {
    font-size: 18px;
  }
  .landingpage_storySection__zDXM6 .landingpage_btnStory__C12kQ button.landingpage_btnUnfill__uGDrD {
    margin: auto 15px;
    padding: 7px 25px;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button {
    max-width: 88% !important;
  }
  .landingpage_myavtarsection__6IZ7k .landingpage_avtarBody__iAICN img {
    max-width: 251px;
  }
  .landingpage_avtarBody__iAICN .landingpage_avtarmainInfo__\\+AuSN img {
    max-width: 130px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O a {
    height: 75px;
    margin: 0 15px 21px;
    padding: 0 20px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O img {
    top: -13px;
    left: 5px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span strong {
    font-size: 30px;
    line-height: 35px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O span {
    font-size: 24px;
    line-height: 34px;
    width: 75%;
  }
  .landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl button,
  .landingpage_edit_profile_section__ujP6U .landingpage_profile_bottom__N52NV button {
    margin: 0 5px;
  }
  .landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl button {
    width: 45%;
    padding: 7px 25px !important;
  }
  .landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl button.landingpage_btnUnfill__uGDrD {
    border-image-outset: 5px 0 7px 0;
  }
}

.landingpage_PackagesMain__vvtmP {
  padding: 37px 0;
  background: #56cdd5;
}

.landingpage_PackagesMainGredient__y6S\\+y {
  padding: 37px 0 0;
}

.landingpage_PackagesInfo__sqhBn {
  display: flex;
  flex-wrap: wrap;
  margin-top: 41px;
  justify-content: space-between;
}

.landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj {
  flex: 0 0 30%;
  max-width: 30%;
  margin-bottom: 10px;
}

.landingpage_PackagesInfoInnerImg__dXNPB .landingpage_arrowimgBottom__CsFZ0 {
  position: absolute;
  bottom: -15px;
  right: -20px;
}

.landingpage_PackagesMain__vvtmP .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj p {
  font-weight: 500;
  padding-bottom: 0;
  border: 0;
  padding-top: 0;
}

.landingpage_PackagesMain__vvtmP p {
  font-weight: 600;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 0 0 5px 0;
  border-image-outset: 0 0 6px 0;
  border-style: solid;
  width: 60%;
  margin: auto;
}

.landingpage_PackagesInfoInnerImg__dXNPB:hover {
  font-weight: 700;
}

.landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topLeft__dXtJ4,
.landingpage_TermsConditionsMain__wM2cb .landingpage_BackToTop__ymJgK {
  text-align: right;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topLeft__dXtJ4 img {
  width: 373px;
}

.landingpage_PackagesMainGredient__y6S\\+y h4 {
  margin-bottom: 49px;
}

.landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topRight__gzFB5 h3 {
  font-family: "Cabin Sketch", cursive;
  font-weight: 700;
  font-size: 64px;
  line-height: 75px;
  color: #000;
  margin-bottom: 9px;
  text-align: center;
}

.landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topRight__gzFB5 p {
  border: 0;
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #000;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfo__sqhBn,
.landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo {
  justify-content: center;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy {
  background: #f2dd4e;
  border: 6px solid #000;
  border-radius: 57px;
  margin-top: -70px;
  margin-bottom: 39px;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy p {
  padding-top: 74px;
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  border: 0;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_top__mXWjt {
  align-items: center;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul {
  display: flex;
  justify-content: space-around;
  margin-top: 40px;
  align-items: center;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li {
  padding: 22px 39px;
  background: #56cdd5;
  border-radius: 40px;
  border-image-repeat: stretch;
  border-image-slice: 22;
  border-image-width: 23px;
  border-image-outset: 5px;
  border-style: solid;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU {
  background: #0d5268;
  position: relative;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU::before,
.landingpage_activeEffect__moV0-::before {
  content: "";
  position: absolute;
  left: -45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) 0 0 / contain no-repeat;
  width: 31px;
  height: 72px;
  top: 0;
}

.landingpage_activeEffect__moV0-::before {
  top: -6px;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU::after,
.landingpage_activeEffect__moV0-::after {
  content: "";
  position: absolute;
  right: -45px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) 0 0 / contain no-repeat;
  width: 33px;
  height: 74px;
  top: 0;
}

.landingpage_activeEffect__moV0-::after {
  top: -8px;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU span {
  color: #fff;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li span {
  font-weight: 600;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3 {
  background: #56cdd5;
  position: relative;
  padding: 57px 0 38px;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3::before {
  content: "";
  width: 100%;
  height: 20%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) 0 0 / contain no-repeat;
  position: absolute;
  top: 0;
  left: 0;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3 p {
  font-weight: 500;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #1c2452;
  padding: 39px 28px 150px;
  width: 85%;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  border-image-repeat: stretch;
  border-image-slice: 16;
  border-image-width: 15px;
  border-image-outset: inherit;
  border-style: solid;
}

.landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3 .landingpage_StoryFlowInfoBtn__BLWad {
  text-align: center;
  margin-top: -126px;
}

.landingpage_MyStories__xS1Bu {
  background: #56cdd5;
  padding: 33px 0;
  position: relative;
}

.landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A {
  text-align: center;
  margin-bottom: 41px;
  margin-top: 25px;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5,
.landingpage_PalacecomMain__3KSO2 {
  margin-bottom: 28px;
}

.landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A .landingpage_btnFill__Ctw\\+3 {
  color: #56cdd5;
  border-image-outset: 6px 6px 11px 6px;
  border-image-slice: 16;
  border-image-width: 10px;
}

.landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A .landingpage_btnFill__Ctw\\+3.landingpage_btnFillLeft__2bXxh {
  margin-right: 50px;
  width: 240px;
}

.landingpage_MyStories__xS1Bu h3 {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
}

.landingpage_MyStories__xS1Bu p {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
  color: #000;
  margin-bottom: 20px;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr {
  margin-top: -5px;
  background: #d9eb41;
  padding: 25px 39px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 4px solid #1c2452;
  border-radius: 5px;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr h3 {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  color: #000;
  text-align: left;
  margin-bottom: 0;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr p {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  text-align: left;
  margin-bottom: 0;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr .landingpage_mystoriesInnerRight__\\+MTcu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr .landingpage_mystoriesInnerRight__\\+MTcu img {
  max-width: 98px;
  height: auto;
  margin-left: 50px;
  border: 0;
}

.landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 img {
  width: 100%;
  height: 366px;
  border: 4px solid #1c2452;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.landingpage_sharebtnlink__JxhRC {
  width: 168px;
  padding: 15px 33px;
  background: #0d5268;
  border: 4px solid #000;
  border-radius: 10px;
  text-align: center;
  position: relative;
}

.landingpage_sharebtnlink__JxhRC .landingpage_sharebtnimg__JZwNs {
  position: absolute;
  top: -4%;
  right: -25%;
}

.landingpage_sharebtnlink__JxhRC p {
  font-weight: 700;
  font-size: 30px;
  line-height: 40px;
  color: #fff;
  margin-bottom: 22px;
}

.landingpage_sharebtnlink__JxhRC img {
  width: 70px;
}

.landingpage_sharebtnlink__JxhRC a {
  margin-bottom: 20px;
  display: block;
}

.landingpage_sharebtnlink__JxhRC span {
  font-weight: 600;
  font-size: 19px;
  line-height: 25px;
  color: #fff;
}

.landingpage_MyStories__xS1Bu .landingpage_PackagesInfoInnerImg__dXNPB .landingpage_arrowimgBottom__CsFZ0 {
  bottom: 10px;
  right: 25px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissionInfoInner__BmzgZ h3 {
  font-family: "Roof runners active";
  font-weight: 700;
  font-size: 36px;
  line-height: 41px;
  text-align: center;
  color: #0d5268;
}

.landingpage_MySubmission__jt\\+jE
  .landingpage_MySubmissionInfo__vCULm
  .landingpage_MySubmissiondetail_story__HHe86
  .landingpage_MySubmissionInfoInner__BmzgZ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

.landingpage_MySubmission__jt\\+jE
  .landingpage_MySubmissionInfo__vCULm
  .landingpage_MySubmissiondetail_Ingredients__Vo1Um
  .landingpage_MySubmissionInfoInner__BmzgZ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  height: 350px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_publish__NLDrF .landingpage_tick__GcADW,
.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_read__BQH4W .landingpage_tick__GcADW,
.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_submit__dT5H5 .landingpage_tick__GcADW {
  position: absolute;
  top: 0;
  right: 15px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_story__HHe86 .landingpage_tick__GcADW {
  top: -10px;
  right: -20px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail__Jn9xs {
  margin-top: -130px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail__Jn9xs:first-child,
.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs:first-child {
  margin-top: 0;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm {
  margin: 0 200px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissionInfoInner__BmzgZ h4 {
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  color: #0d5268;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm h4.landingpage_MySubmissionInfo_publish__TmMlT {
  color: #ed4c55;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 11px;
  border-style: solid;
  display: inline-block;
  padding: 5px;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissionInfoInner__BmzgZ {
  background-repeat: no-repeat;
  width: 340px;
  height: 281px;
  background-size: cover;
  padding: 68px 0 0;
  text-align: center;
  display: block;
  position: relative;
}

.landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissionInfoInner__BmzgZ p {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  color: #000;
  margin-bottom: 30px;
}

.landingpage_storynavigatemain__QgymB .landingpage_storynavigatemainInner__RGbmb img {
  margin: 0 10px;
  object-fit: contain;
}

.landingpage_storynavigatemain__QgymB {
  text-align: center;
  padding: 25px 0;
}

.landingpage_storynavigatemain__QgymB p {
  font-weight: 700;
  font-size: 24px;
  line-height: 31px;
  text-align: right;
  color: #0d5268;
}

.landingpage_MuniaMiddle__p\\+N7F {
  position: fixed;
  width: 120px;
  height: 120px;
  border-radius: 100px;
  object-fit: contain;
  bottom: 5%;
  right: 10%;
  z-index: 1;
  cursor: pointer;
}

.landingpage_storyPagecompMain__gqaI6 img {
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  border-image-repeat: stretch;
  border-image-slice: 30;
  border-image-width: 14px;
  border-image-outset: 0;
  border-style: solid;
  height: 350px;
  object-fit: contain;
}

.landingpage_storyPagecompMain__gqaI6 a img {
  width: auto;
  border: 0;
  height: auto;
}

.landingpage_storyPagecompMain__gqaI6 a {
  font-weight: 700;
  font-size: 36px;
  line-height: 50px;
  color: #000;
  display: inline-block;
}

.landingpage_storyPagecompMain__gqaI6 p {
  font-weight: 500;
  font-size: 28px;
  line-height: 35px;
  color: #000;
  margin: 30px 0;
  text-align: left;
}

.landingpage_storyPageMain__C2nSX,
.landingpage_storyPageMainBottom__LY77y {
  background-color: #f5fef0;
  text-align: center;
  padding: 145px 0 0;
}

.landingpage_storyPageMain__C2nSX .landingpage_storyPAgeMainTitle__tCtS5 {
  font-weight: 700;
  font-size: 50px;
  line-height: 60px;
  text-align: center;
  font-family: "Roof runners active" !important;
  color: #0d5268;
  margin-bottom: 20px;
  display: block;
}

.landingpage_storyPageMainMid__M9TlP {
  background: #e4f2ff;
  text-align: center;
  padding: 65px 0 40px;
  position: relative;
  z-index: 0;
}

.landingpage_storyPageMainMid__M9TlP p {
  font-weight: 700;
  font-size: 42px;
  line-height: 55px;
  text-align: center;
  color: #000;
}

.landingpage_storyPageMainMid__M9TlP span {
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
  text-align: center;
  color: #000;
}

.landingpage_storyPageMainMid__M9TlP .landingpage_storyPageMidimg__dI1ZO {
  display: flex;
  justify-content: center;
  margin-top: 70px;
}

.landingpage_storyPageMainMid__M9TlP .landingpage_storyPageMidimg__dI1ZO .landingpage_storyimgInner__tpNQn img:last-child {
  margin-top: -50px;
}

.landingpage_storyPageMainBottom__LY77y p {
  margin-bottom: 43px;
  font-weight: 500;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
}

.landingpage_storyPageMainMid__M9TlP .landingpage_whereText__yGNqP span {
  font-size: 30px;
  line-height: 45px;
  margin-top: -20px;
}

.landingpage_PalacecomMain__3KSO2 {
  display: flex;
  padding: 10px;
  border-radius: 15px;
  align-items: center;
}

.landingpage_PalacecomMain__3KSO2 h2 {
  font-weight: 700;
  font-size: 45px;
  line-height: 53px;
  color: #000;
  margin-bottom: 45px;
  text-align: left;
}

.landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl {
  margin: 0 50px;
}

.landingpage_ConfirmedBlueInner__x1ATD .landingpage_ConfirmedBlueInnerInfo__vTO5k {
  display: flex;
  justify-content: center;
  align-items: center;
}

.landingpage_ConfirmedBlueInner__x1ATD .landingpage_ConfirmedBlueInnerInfo__vTO5k p {
  text-align: left;
  color: #0d5268;
  margin-left: 15px;
  font-weight: 600;
}

.landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl button.landingpage_btnFill__Ctw\\+3,
.landingpage_storyPageMain__C2nSX button {
  padding: 0 25px;
}

.landingpage_PasswordUpdatedScreenMain__89uxS .landingpage_PasswordUpdatedTop__V5SuE img,
.landingpage_banner__GQV94,
.landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel .landingpage_ZidZagDesktopStory__Wi\\+yI,
.landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel .landingpage_dashedLinebottom__t6BpV,
.landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel h2,
.landingpage_myaccount_main__ToIhz .landingpage_storySectiontwo__HdMel h2,
.landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo::after,
.landingpage_storySectiontwo__HdMel .landingpage_bgImageStoryNewLeft__-rs1G,
.landingpage_storySectiontwo__HdMel .landingpage_dashedLine__cAwpn,
.landingpage_swiperNavBanner__L6H1D,
.landingpage_swiperNavtwo__vMqck {
  display: none;
}

@media (min-width: 768px) {
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul .landingpage_PackagesMain_arrow__RYhCl,
  .landingpage_storySection__zDXM6 .landingpage_RedZigZagHomeStory__ntzXI {
    display: none;
  }
  .landingpage_myavtarsection__6IZ7k {
    margin-top: -15px;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo {
    border-image-slice: 21;
    border-image-width: 12px;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button {
    border-image-slice: 24 !important;
    border-image-width: 18px !important;
  }
}

@media (max-width: 767px) {
  .landingpage_storyPagecompMain__gqaI6 img {
    height: auto;
  }
  .landingpage_storyPageMain__C2nSX,
  .landingpage_storyPageMainBottom__LY77y {
    padding: 25px 0 0;
  }
  .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S .landingpage_btndiv__gSekl .landingpage_btnFill__Ctw\\+3 {
    width: 140px !important;
    margin: 0 15px;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_whereText__yGNqP span {
    font-size: 18px;
    line-height: 30px;
    margin-top: -10px;
  }
  .landingpage_MyStories__xS1Bu h3,
  .landingpage_PackagesMain__vvtmP .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj p,
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li span,
  .landingpage_storyPageMainBottom__LY77y p,
  .landingpage_storyPageMainMid__M9TlP p {
    font-size: 24px;
    line-height: 31px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li {
    border-image-slice: 22;
    border-image-width: 17px;
    border-image-outset: 4px;
    border-radius: 27px;
    padding: 5px 24px;
    height: 60px;
  }
  .landingpage_MyStories__xS1Bu p br,
  .landingpage_MyStories__xS1Bu::after,
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj:nth-child(4),
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj:nth-child(5),
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li,
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU::after,
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU::before,
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topRight__gzFB5,
  .landingpage_PalacecomMain__3KSO2 img,
  .landingpage_banner__GQV94 .landingpage_bannerLeft__4go00 .landingpage_whtsNew__YQy2a img,
  .landingpage_faqMain__0o88r .landingpage_faqbgImg__DKgMn,
  .landingpage_faqMain__0o88r::before {
    display: none;
  }
  .landingpage_activeEffect__moV0-::before {
    left: -30px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
    width: 16px;
    height: 36px;
  }
  .landingpage_activeEffect__moV0-::after {
    right: -30px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
    width: 17px;
    height: 37px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInnerImg__dXNPB img {
    width: 203px;
  }
  .landingpage_storyPageMain__C2nSX button img {
    width: 45px;
  }
  .landingpage_storyPageMain__C2nSX p,
  .landingpage_storyPagecompMain__gqaI6 a {
    font-size: 24px;
    line-height: 34px;
  }
  .landingpage_storyPagecompMain__gqaI6 a img {
    width: 30px;
  }
  .landingpage_storynavigatemain__QgymB .landingpage_storynavigatemainInner__RGbmb .landingpage_active__I2XuU img {
    width: 50px;
  }
  .landingpage_PackagesInfo__sqhBn {
    overflow: auto;
    height: 100%;
  }
  .landingpage_contactSection__EICPg .landingpage_mainInfo__2wT75 .landingpage_mainInfoMobile__gScC0 {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
  .landingpage_contactSection__EICPg .landingpage_mainInfo__2wT75 .landingpage_mainInfoMobile__gScC0 .landingpage_socialIcon__UuuAD img {
    display: block;
    margin: auto;
  }
  .landingpage_contactSection__EICPg .landingpage_mainInfo__2wT75 .landingpage_mainInfoMobile__gScC0 .landingpage_socialIcon__UuuAD {
    width: 50%;
  }
  .landingpage_contactSection__EICPg .landingpage_mainInfo__2wT75 .landingpage_mainInfoMobile__gScC0 .landingpage_socialIcon__UuuAD:first-child {
    order: 2;
  }
  .landingpage_contactSection__EICPg .landingpage_mainInfo__2wT75 .landingpage_mainInfoMobile__gScC0 .landingpage_socialIcon__UuuAD:nth-child(2) {
    order: 1;
  }
  .landingpage_contactSection__EICPg .landingpage_mainInfo__2wT75 .landingpage_mainInfoMobile__gScC0 .landingpage_socialIcon__UuuAD:nth-child(3) {
    order: 3;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
    width: 70%;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu a {
    width: 55%;
  }
  .landingpage_storynavigatemain__QgymB .landingpage_storynavigatemainInner__RGbmb img {
    width: 25px;
  }
  .landingpage_PalacecomMain__3KSO2 {
    padding: 15px 10px;
  }
  .landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl {
    margin: 0;
  }
  .landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl h2 {
    font-size: 35px;
    line-height: 35px;
    margin-bottom: 35px;
  }
  .landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl .landingpage_PalacecomMainInnerinfo__mAT1e img {
    display: initial;
  }
  .landingpage_storyPageMainBottom__LY77y p strong {
    display: block;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_storyPageMidimg__dI1ZO {
    margin-top: 35px;
  }
  .landingpage_MyStories__xS1Bu,
  .landingpage_MyStoryFlowMain__PvUat,
  .landingpage_PackagesMain__vvtmP,
  .landingpage_StoryFlows__ZB9Nz,
  .landingpage_contactSection__EICPg,
  .landingpage_edit_profile_section__ujP6U,
  .landingpage_faqMain__0o88r,
  .landingpage_loginBg__JZmcK,
  .landingpage_menuMain__CIvXY,
  .landingpage_myaccount_main__ToIhz,
  .landingpage_signUpBg__6ajTf,
  .landingpage_storyPageMain__C2nSX,
  .landingpage_storyPageMainMid__M9TlP .landingpage_storyPageMidimg__dI1ZO .landingpage_storyimgInner__tpNQn img:last-child {
    margin-top: -25px;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_storyPageMidimg__dI1ZO .landingpage_storyimgInner__tpNQn img {
    max-width: 125px;
    display: block;
  }
  .landingpage_storyPageMainMid__M9TlP::before {
    width: 110px;
    top: 50px;
  }
  .landingpage_storyPageMainMid__M9TlP::after {
    left: -129px;
  }
  .landingpage_storyPageMainMid__M9TlP span {
    font-size: 18px;
    line-height: 30px;
  }
  .landingpage_storyPageMain__C2nSX .landingpage_storyPAgeMainTitle__tCtS5 {
    font-size: 28px;
    line-height: 32px;
  }
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissionInfoInner__BmzgZ {
    width: 305px;
    height: 250px;
    padding: 52px 0 0;
  }
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n),
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topLeft__dXtJ4 {
    text-align: center;
  }
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail__Jn9xs {
    margin-top: 0;
    margin-bottom: 50px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_PackagesInfoInnerImg__dXNPB .landingpage_arrowimgBottom__CsFZ0 {
    bottom: 35px;
    right: 22%;
  }
  .landingpage_MyStories__xS1Bu .landingpage_PackagesInfoInner__\\+Ftfj {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A button {
    padding: 0 10px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A button.landingpage_btnUnfill__uGDrD {
    border-image-outset: 3 0 15px 0;
  }
  .landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr {
    padding: 10px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 img {
    height: 213px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr .landingpage_mystoriesInnerRight__\\+MTcu img {
    max-width: 57px;
    margin-left: 0;
  }
  .landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr p {
    font-size: 12px;
    line-height: 16px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_mystoriesInner__4yyn5 .landingpage_mystoriesInnerInfo__3Hxzr h3 {
    font-size: 20px;
    line-height: 26px;
  }
  .landingpage_MyStories__xS1Bu p {
    font-size: 24px;
    line-height: 31px;
    margin: 5px 0;
  }
  .landingpage_MyStories__xS1Bu::before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) no-repeat;
    width: 26%;
    height: 27%;
    top: -90px;
  }
  .landingpage_PackagesInfoInnerImg__dXNPB .landingpage_arrowimgBottom__CsFZ0 {
    right: -3px;
    width: 57px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3 p {
    width: 100%;
    padding: 25px 15px 65px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3 .landingpage_StoryFlowInfoBtn__BLWad {
    margin-top: -50px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul .landingpage_PackagesMain_arrow__RYhCl,
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li.landingpage_active__I2XuU {
    display: inherit;
    padding: 13px 30px;
    align-items: center;
  }
  .landingpage_PackagesMainGredient__y6S\\+y
    .landingpage_PackagesMain_nav__Rf4MK
    ul
    .landingpage_PackagesMain_arrow__RYhCl:nth-child(odd) {
    transform: rotate(180deg);
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li a,
  .landingpage_PackagesMainGredient__y6S\\+y p {
    font-size: 24px !important;
    line-height: 31px !important;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul .landingpage_PackagesMain_arrow__RYhCl img {
    width: 57px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy {
    margin-top: -60px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_61___}) 0 0 / cover
      no-repeat;
    border: 0;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj {
    flex: 0 0 100%;
    max-width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
  .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .landingpage_PackagesMain__vvtmP p {
    font-size: 18px;
    line-height: 23px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 img {
    max-width: 134px;
  }
  .landingpage_MAinMEnudashedLineYellow__HZipE {
    margin-top: -60px !important;
    z-index: -1;
    position: relative;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_imgafterstoryPageLeft__YmDUE {
    width: 60px !important;
    z-index: -1;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_imgafterstoryPageRight__VbQpC {
    width: 100px !important;
  }
  .landingpage_myavtarsection__6IZ7k .landingpage_backbtn__JCEeY a {
    left: 0;
  }

  .landingpage_header_section__eWp\\+J .landingpage_navheader__PpA9S .landingpage_container-fluid__A1w4A .landingpage_navbar__nOwoJ .landingpage_navbarBrand__MthO3 {
    margin: auto !important;
  }

  .landingpage_header_section__eWp\\+J .landingpage_navheader__PpA9S .landingpage_navbarBrand__MthO3 img {
    width: 84px;
    padding-bottom: 10px;
  }
  .landingpage_banner__GQV94 {
    margin-top: -20px;
  }
  .landingpage_banner__GQV94 .landingpage_banner_container__AMCt\\+ {
    padding-left: 0;
    padding-right: 0;
  }
  .landingpage_banner__GQV94 .landingpage_bannerRightText__3qipL {
    margin: 25px auto;
    max-width: 80%;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX {
    margin-left: 0 !important;
    height: 25em !important;
    display: flex;
    justify-content: center;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX .landingpage_swiperSlide__2xd3F .landingpage_cardNew__cPEuz {
    max-width: 75%;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSection__tFPRl {
    margin-top: 15% !important;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX .landingpage_swiperSection_InfoDe__HyLRa {
    max-width: 100%;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfo__sqhBn .landingpage_PackagesInfoInner__\\+Ftfj:nth-child(3) {
    margin-bottom: 12%;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy p {
    padding-top: 50px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_pacakageNextcontent__Ctp\\+3 {
    margin-top: -85px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y {
    position: relative;
  }
  .landingpage_PackagesMainGredient__y6S\\+y::before {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_62___}) no-repeat;
    width: 111px;
    height: 111px;
    position: absolute;
    top: 7%;
    left: 0;
  }
  .landingpage_PackagesMainGredient__y6S\\+y::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_63___}) no-repeat;
    width: 48px;
    height: 72px;
    position: absolute;
    top: 17%;
    right: 0;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topLeft__dXtJ4 img {
    width: 285px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y
    .landingpage_PackagesInfo__sqhBn
    .landingpage_PackagesInfoInner__\\+Ftfj
    .landingpage_PackagesInfoInnerImg__dXNPB
    img {
    width: 172px;
  }
}

@media (max-width: 575px) {
  .landingpage_ViewCardStory__QSRQZ .landingpage_cardNew__cPEuz {
    max-width: 285px;
    width: 100%;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
    width: 90%;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu a {
    width: 82%;
  }
  .landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl .landingpage_PalacecomMainInnerinfo__mAT1e {
    display: block;
  }
  .landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl .landingpage_PalacecomMainInnerinfo__mAT1e img {
    margin-bottom: 50px;
  }
  .landingpage_PalacecomMain__3KSO2 .landingpage_PalacecomMainInner__URsUl .landingpage_PalacecomMainInnerinfo__mAT1e button img {
    margin-bottom: 0;
  }
  .landingpage_cardPickSection__-x4G0
    .landingpage_swiperSectionInfo_inner__m0gQX
    .landingpage_swiperSlide__2xd3F
    .landingpage_cardNew__cPEuz
    .landingpage_cardFooter__DpSg9
    .landingpage_cardfooterName__k7kVi {
    font-size: 26px;
    line-height: 35px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 17em !important;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs .landingpage_menuMainhead_inner__FfSW6 span b {
    display: block;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span .landingpage_Uid__Mwqbl {
    display: inline-block;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en::before {
    top: 87%;
  }
  .landingpage_MAinMEnudashedLineYellow__HZipE {
    margin-top: -90px !important;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O span {
    font-size: 28px;
    line-height: 34px;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_imgafterstoryPageLeft__YmDUE {
    width: 128px !important;
  }
  .landingpage_storyPageMainMid__M9TlP .landingpage_imgafterstoryPageRight__VbQpC {
    width: 170px !important;
  }
  .landingpage_btsSection__l5qw9 .landingpage_theaterInfo__nmkAq .landingpage_theaterLeftInfo__PxUNY p br,
  .landingpage_contactSection__EICPg .landingpage_ContactTop__-7\\+Ca .landingpage_contactTopInfo__sIedu p br,
  .landingpage_faqMain__0o88r .landingpage_faqTop__f7jup span br,
  .landingpage_faqMain__0o88r .landingpage_faqbgImg__DKgMn,
  .landingpage_faqMain__0o88r::before {
    display: none;
  }
  .landingpage_menuMain__CIvXY::after {
    left: 0;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl .landingpage_menubtn__xRDwu a {
    width: 41%;
  }
  .landingpage_header_section__eWp\\+J .landingpage_headerGb__NsDub p,
  .landingpage_header_section__eWp\\+J .landingpage_headerGs__HYoJR p {
    font-size: 25px;
    line-height: 40px;
  }
  .landingpage_header_section__eWp\\+J .landingpage_headerContact__BDbrF img,
  .landingpage_header_section__eWp\\+J .landingpage_navbarTogglerIcon__a9y4M img {
    width: 45px;
  }
  .landingpage_header_section__eWp\\+J .landingpage_headerGb__NsDub img,
  .landingpage_header_section__eWp\\+J .landingpage_headerGsNew__FgHBK img,
  .landingpage_header_section__eWp\\+J .landingpage_navbarBrand__MthO3 img {
    width: 130px;
  }
  h2 {
    font-size: 38px;
    line-height: 42px;
  }
  .landingpage_swiperNavBanner__L6H1D button img {
    max-width: 50px;
  }
  .landingpage_swiperNavBannertwo__ZClJ9 button img {
    max-width: 60px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperNavBanner__L6H1D .landingpage_page_num__WXNI7 {
    font-size: 24px;
    line-height: 37px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH button img {
    max-width: 75px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_cardFooter__DpSg9 .landingpage_cardfooterName__k7kVi {
    font-size: 40px;
    line-height: 40px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_cardHeader__nUyBC img {
    max-width: 400px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSection__tFPRl .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 23em !important;
  }
  .landingpage_cardPickSection__-x4G0::before {
    left: -55px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_bgImageOverflow__ledaW {
    right: -120px;
  }
  .landingpage_googleAdSection__ufifs img {
    max-width: 300px;
  }
  .landingpage_googleAdSection__ufifs button {
    font-size: 27px;
    line-height: 33px;
  }
  .landingpage_desktopFooter__uHw7\\+ .landingpage_footerLeft__c5Eka .landingpage_footerLogo__hRtO6 img {
    width: 280px;
  }
  .landingpage_MyStories__xS1Bu,
  .landingpage_MyStoryFlowMain__PvUat,
  .landingpage_PackagesMain__vvtmP,
  .landingpage_StoryFlows__ZB9Nz,
  .landingpage_contactSection__EICPg,
  .landingpage_edit_profile_section__ujP6U,
  .landingpage_faqMain__0o88r,
  .landingpage_loginBg__JZmcK,
  .landingpage_menuMain__CIvXY,
  .landingpage_myaccount_main__ToIhz,
  .landingpage_signUpBg__6ajTf,
  .landingpage_storyPageMain__C2nSX {
    margin-top: -15px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs span strong,
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span strong {
    font-size: 40px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 {
    font-size: 28px;
    line-height: 35px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs h3 img {
    width: 35px;
  }
  .landingpage_backbtn__JCEeY img {
    width: 60px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 img,
  .landingpage_menuMainInner__Fb0Xl .landingpage_menuMainInnerImg__Y5ME5 img,
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en img {
    width: 200px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
    font-size: 31px;
    line-height: 38px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O img {
    left: 5px;
    width: 110px;
  }
  .landingpage_faqMain__0o88r p {
    font-size: 30px;
    line-height: 37px;
  }
  .landingpage_faqMain__0o88r .landingpage_faqTop__f7jup span {
    font-size: 22px;
    line-height: 29px;
  }
  .landingpage_contactSection__EICPg .landingpage_ContactTop__-7\\+Ca .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb img {
    margin-right: 15px;
  }
  .landingpage_ContactBottom__U6x2n .landingpage_btndiv__gSekl,
  .landingpage_ContactBottom__U6x2n form,
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm,
  .landingpage_contactTopInfo__sIedu {
    margin: 0;
  }
  .landingpage_MyStoryFlowMainExpand__mmOZv {
    width: 85%;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlows_top__NuDly .landingpage_Storysharebtn__Xq0oQ a {
    right: 7%;
    width: 100px;
    z-index: 1;
  }
  .landingpage_PackagesInfoInnerImg__dXNPB .landingpage_arrowimgBottom__CsFZ0 {
    width: 70px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en::before {
    top: 85%;
  }
  .landingpage_storynavigatemain__QgymB .landingpage_storynavigatemainInner__RGbmb img {
    max-width: -moz-fit-content;
    max-width: fit-content;
    margin: 0;
  }
  .landingpage_desktopFooter__uHw7\\+ .landingpage_footerLeft__c5Eka,
  .landingpage_desktopFooter__uHw7\\+ .landingpage_footerMidLeft__xizVl,
  .landingpage_desktopFooter__uHw7\\+ .landingpage_footerMid__ZQV9z,
  .landingpage_desktopFooter__uHw7\\+ .landingpage_footerRight__XMjSl {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .landingpage_desktopFooter__uHw7\\+ .landingpage_footerLeft__c5Eka {
    text-align: left;
  }
  .landingpage_desktopFooter__uHw7\\+ .landingpage_socialIcon__UuuAD {
    text-align: center;
    width: 280px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_top__mXWjt .landingpage_PackagesMain_topLeft__dXtJ4 {
    text-align: center;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li a {
    font-size: 26px;
    line-height: 30px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_nav__Rf4MK ul li {
    padding: 18px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy p br {
    display: none;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy p {
    font-size: 28px;
    line-height: 35px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y
    .landingpage_PackagesInfo__sqhBn
    .landingpage_PackagesInfoInner__\\+Ftfj
    .landingpage_PackagesInfoInnerImg__dXNPB
    img {
    width: 182px;
  }
}

.landingpage_MySubmissionInfoDraft__aHgi3 {
  margin: 0 180px;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ span {
  display: block;
  margin-top: 40%;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #0d5268;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs {
  margin-top: -70px;
}

.landingpage_MySubmissionInfoDraft__aHgi3
  .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n)
  .landingpage_MySubmissionInfoInner__BmzgZ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  height: 337px;
}

.landingpage_MySubmissionInfoDraft__aHgi3
  .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n)
  .landingpage_MySubmissionInfoInner__BmzgZ
  h2 {
  background: #d9eb41;
  top: 30px;
  left: 60px;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ {
  background-repeat: no-repeat;
  width: 340px;
  height: 281px;
  background-size: cover;
  padding: 68px 0 0;
  text-align: center;
  display: block;
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ h2 {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  color: #000;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  border-style: solid;
  border-image-repeat: stretch;
  border-image-slice: 12;
  border-image-width: 11px;
  border-image-outset: 0;
  padding: 0 15px;
  background: #56cdd5;
  border-radius: 100%;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_progressdivsubmission__8\\+nF5 {
  transform: rotate(-1.82deg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 23%;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_progressdivsubmission__8\\+nF5 p {
  font-weight: 700 !important;
  font-size: 30px !important;
  line-height: 36px !important;
  text-align: center !important;
  color: #fff !important;
  transform: rotate(8.18deg);
  margin-bottom: 0 !important;
  padding: 45px 0;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs .landingpage_EditInfoSubmission__4o0Fn {
  position: absolute;
  top: -20px;
  right: -57px;
}

.landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n) .landingpage_EditInfoSubmission__4o0Fn {
  top: 20px;
  right: 10px;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX .landingpage_swiperSection_InfoDe__HyLRa:nth-child(2n) {
  rotate: 10deg !important;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX .landingpage_swiperSection_InfoDe__HyLRa:nth-child(odd) {
  rotate: -10deg !important;
}

.landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX .landingpage_swiperSection_InfoDe__HyLRa:last-child {
  rotate: 0deg !important;
}

.landingpage_cardPickSection__-x4G0
  .landingpage_swiperSectionInfo_inner__m0gQX
  .landingpage_swiperSection_InfoDe__HyLRa
  .landingpage_swiperSlide__2xd3F
  .landingpage_cardHeader__nUyBC
  img {
  width: 400px;
  height: 255px;
}

.landingpage_birdTopText__vnNOx {
  position: fixed;
  bottom: 5%;
  right: 10%;
  z-index: 105;
  border-radius: 100%;
  overflow: hidden;
  border-color: transparent;
}

.landingpage_birdTopText__vnNOx img.landingpage_MuniaMiddle__p\\+N7F {
  position: static;
}

.landingpage_birdTopText__vnNOx span {
  display: inline-block;
  position: absolute;
  right: 0;
  z-index: 100;
  top: -5px;
  width: 120px;
  padding: 5px 0;
  text-align: center;
  cursor: pointer;
}

.landingpage_PickStoryHome__W8mYH p,
.landingpage_storyBtn__rd8vk {
  font-size: 48px;
  line-height: 62px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo {
  background: #56cdd5;
  position: relative;
  padding-top: 40px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___}) no-repeat;
  width: 235px;
  height: 308px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) no-repeat;
  width: 223px;
  height: 254px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperNav__KUIrH button {
  background: 0 0;
  border: 0;
}

.landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp {
  position: relative;
  z-index: 0;
  margin: 50px 0;
}

.landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperNav__KUIrH {
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  align-items: center;
}

.landingpage_createStorySection__0UUkg .landingpage_moreStory__1x5Ug {
  display: flex;
  justify-content: center;
  padding: 85px 0;
  align-items: center;
}

.landingpage_createStorySection__0UUkg .landingpage_moreStory__1x5Ug .landingpage_moreStoryInner__2NNY3 {
  position: relative;
  display: inline-block;
  margin: 0 15px;
}

.landingpage_createStorySection__0UUkg .landingpage_moreStory__1x5Ug .landingpage_moreStoryInner__2NNY3 img.landingpage_RedCross__OkwOP {
  position: absolute;
  left: -10px;
  top: -4px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomShare__Ymsn5 span {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  display: block;
  text-align: left;
  margin-bottom: 5px;
  margin-left: 10px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomShare__Ymsn5 img {
  margin-right: 24px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomShare__Ymsn5 {
  width: 50%;
  margin: auto;
}

.landingpage_footerMidLeft__xizVl {
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 992px) {
  .landingpage_qrdiv__eStKa {
    width: 50%;
  }
  .landingpage_footerMidLeft__xizVl {
    align-items: flex-start;
    padding-left: 0px;
  }
}

@media (min-width: 1024px) {
  .landingpage_qrdiv__eStKa {
    width: 80%;
  }
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 {
  background-color: #56cdd5;
  padding: 50px 0;
  position: relative;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_70___}) no-repeat;
  width: 253px;
  height: 389px;
  top: 100px;
  left: 0;
  position: absolute;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9::after {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_71___}) no-repeat;
  width: 260px;
  height: 297px;
  bottom: 0;
  right: 0;
  position: absolute;
}

.landingpage_storyBtn__rd8vk {
  font-weight: 600;
  text-align: center;
  color: #000;
  padding: 12px 30px !important;
  background: #56cdd5;
  border-image-repeat: stretch;
  border-image-slice: 22;
  border-image-width: 23px;
  border-image-outset: 5px;
  border-radius: 40px;
  border-style: solid;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createStoryMidInner__0rqe3 .landingpage_createMidInnerInfo__F6n1\\+ {
  flex: 0 0 48%;
  max-width: 48%;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ button {
  margin-bottom: 40px;
  padding: 8px 15px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ .landingpage_findIngredients__Uz4kN img {
  margin-top: -15px;
  transition: transform 0.7s ease-in-out;
}

.landingpage_createStorySection__0UUkg
  .landingpage_createStoryMid__u2\\+wD
  .landingpage_createMidInnerInfo__F6n1\\+
  .landingpage_findIngredients__Uz4kN
  img:hover {
  transform: rotate(360deg);
  cursor: pointer;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ p {
  color: #000;
  margin-bottom: 25px;
  font-style: italic;
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  text-align: center;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ span {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  margin: 30px 0;
  display: block;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ {
  margin: 26px 0;
  position: relative;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+:first-child:after,
.landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+:nth-child(2):after {
  content: "";
  position: absolute;
  bottom: -20px;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) no-repeat;
  width: 100%;
  height: 3%;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 p {
  font-weight: 600;
  font-size: 48px;
  line-height: 71px;
  text-align: center;
  color: #000;
  margin-bottom: 0;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv,
.landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel {
  margin: 50px 0;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv button.landingpage_btnFill__Ctw\\+3 {
  padding: 6px 25px;
  border-image-outset: 6px 6px 12px 7px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv button.landingpage_btnUnfill__uGDrD {
  padding: 11px 80px 4px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv button {
  margin: 0 25px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_dashedLine__cAwpn img {
  margin-top: -100px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo p {
  font-style: italic;
  font-weight: 600;
  font-size: 36px;
  line-height: 46px;
  text-align: center;
  color: #000;
  margin-bottom: 36px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTopMaintext__h8Gxh p {
  font-weight: 400;
  font-size: 36px;
  line-height: 54px;
  text-align: center;
  color: #000;
  font-style: normal;
  margin: 15px 0 70px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_cardFooter__DpSg9 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_72___}) 0 0 / cover
    no-repeat;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top: 0;
  padding: 12px 0;
  position: absolute;
  bottom: -15px;
  width: 100%;
  height: 120px;
  margin: 0 auto;
  left: 0;
  right: 0;
}

.landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_cardHeader__nUyBC img {
  border-radius: 13px;
  width: 410px;
  height: 380px;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  border-image-repeat: stretch;
  border-image-slice: 30;
  border-image-width: 30px;
  border-image-outset: 0;
  border-style: solid;
  border-radius: 35px;
}

.landingpage_createStorySection__0UUkg .landingpage_cardFooter__DpSg9 .landingpage_cardfooterName__k7kVi {
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  text-align: center;
  color: #000;
  font-family: Kodchasan, sans-serif;
  display: block;
  margin-top: 35px;
}

.landingpage_createStorySection__0UUkg .landingpage_cardNew__cPEuz {
  max-width: 410px;
}

.landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxInner__1ERDc p {
  font-weight: 700;
  font-size: 36px;
  line-height: 42px;
  color: #0d5268;
  padding-top: 50px;
}

.landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxBtn__hEAVI img {
  position: absolute;
  top: -42px;
  left: -55px;
  width: 175px;
}

.landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxBtn__hEAVI a {
  font-weight: 700;
  font-size: 36px;
  line-height: 39px;
  text-align: center;
  color: #fff;
  background: #0d5268;
  display: flex;
  padding: 12px 35px;
  align-items: center;
  justify-content: center;
  width: 42%;
  margin: auto;
  position: relative;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  border-image-repeat: stretch;
  border-image-slice: 22;
  border-image-width: 23px;
  border-image-outset: 15px 10px 12px;
  border-style: solid;
}

.landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxBtn__hEAVI {
  padding-bottom: 40px;
  padding-top: 40px;
}

.landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperSectionInfo_inner__m0gQX {
  margin: auto !important;
  display: flex;
  justify-content: center;
}

.landingpage_createStorySection__0UUkg .landingpage_moreStoryInner__2NNY3 .landingpage_moreStoryInnerMainNew__Hjvc1 {
  object-fit: cover;
  border-radius: 20px !important;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .landingpage_MySubmissionInfoDraft__aHgi3 {
    margin: 0;
  }
  .landingpage_MyStories__xS1Bu::after,
  .landingpage_MyStories__xS1Bu::before,
  .landingpage_MySubmission__jt\\+jE::after,
  .landingpage_MySubmission__jt\\+jE::before,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9::after,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9::before,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo::after,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo::before {
    display: none;
  }
  .landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxInner__1ERDc p {
    font-size: 30px;
    line-height: 40px;
  }
  .landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxBtn__hEAVI a {
    width: 60%;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomShare__Ymsn5 {
    width: 100%;
    margin: auto;
    text-align: center;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomShare__Ymsn5 span {
    text-align: center;
    margin-left: 0;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv button {
    margin: 0 12px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 p {
    font-size: 35px;
    line-height: 45px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ .landingpage_findIngredients__Uz4kN img {
    width: 60px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo {
    margin-top: -15px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_moreStory__1x5Ug .landingpage_moreStoryInner__2NNY3 img.landingpage_RedCross__OkwOP {
    width: 50px;
    height: 50px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ button {
    margin-bottom: 40px;
    padding: 2px 10px;
    font-size: 30px;
  }
  .landingpage_PickStoryHome__W8mYH p {
    font-size: 40px;
    line-height: 56px;
  }
  .landingpage_storySection__zDXM6 .landingpage_bgImageStoryNewLeft__-rs1G img {
    width: 150px;
  }
}

@media (max-width: 767px) {
  .landingpage_ContactTop__-7\\+Ca {
    position: relative;
  }
  .landingpage_ContactTop__-7\\+Ca::before {
    content: "";
    position: absolute;
    bottom: 45%;
    left: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
    background-repeat: no-repeat;
    width: 100%;
    height: 2%;
    background-size: contain;
  }
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 span {
    margin-top: 50px;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs,
  .landingpage_contactTopInfo__sIedu .landingpage_contactinfoMain__Wo6Sb .landingpage_mainInfo__2wT75 .landingpage_socialIcon__UuuAD span {
    margin-top: 0;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 {
    margin: 0;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ .landingpage_progressdivsubmission__8\\+nF5 p {
    font-size: 24px !important;
    line-height: 18px !important;
    padding: 63px 0 !important;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ h2 {
    font-size: 24px;
    line-height: 28px;
    padding: 0 9px;
    border-image-slice: 10;
    border-image-width: 7px;
    top: 12px;
    left: 20px;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ .landingpage_EditInfoSubmission__4o0Fn {
    width: 70px;
    top: 0;
    right: -13px;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3
    .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n)
    .landingpage_MySubmissionInfoInner__BmzgZ
    .landingpage_EditInfoSubmission__4o0Fn {
    top: 25px;
    right: 45px;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissionInfoInner__BmzgZ {
    margin: auto;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3
    .landingpage_MySubmissiondetail__Jn9xs:nth-child(2n)
    .landingpage_MySubmissionInfoInner__BmzgZ
    h2 {
    top: 40px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_moreStoryInner__2NNY3 .landingpage_moreStoryInnerMainNew__Hjvc1 {
    width: 230px !important;
    height: 155px !important;
    object-fit: cover;
    border-radius: 20px !important;
  }
  .landingpage_swiperNavtwo__vMqck {
    display: flex;
    position: absolute;
    width: 100%;
    bottom: 40%;
    z-index: 999;
    justify-content: space-between;
  }
  .landingpage_swiperNavtwo__vMqck .landingpage_swiperNext__Fr-HA,
  .landingpage_swiperNavtwo__vMqck .landingpage_swiperPrev__WqtYH {
    background-color: #0000;
    outline: 0;
    border: none;
    width: 20%;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp {
    margin: 30px 0 50px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_newparaCreateastory__WeQEh {
    font-size: 20px !important;
    line-height: 30px !important;
    padding-bottom: 20px !important;
  }
  .landingpage_createStorySection__0UUkg .landingpage_cardFooter__DpSg9 .landingpage_cardfooterName__k7kVi {
    font-size: 24px;
    line-height: 31px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_cardHeader__nUyBC img {
    width: 270px;
    height: auto;
  }
  .landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxBtn__hEAVI img {
    width: 117px;
  }
  .landingpage_celebrationBoxInner__1ERDc {
    text-align: center;
  }
  .landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxInner__1ERDc p {
    font-size: 22px;
    line-height: 26px;
    padding-top: 20px;
  }
  .landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxBtn__hEAVI a {
    font-size: 24px;
    line-height: 26px;
    padding: 5px 35px;
    width: 70%;
  }
  .landingpage_celebrationBox__ZR8Bo {
    padding: 12px 0;
  }
  .landingpage_celebrationBox__ZR8Bo .landingpage_celebrationBoxInner__1ERDc img {
    width: 141px !important;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 p {
    font-size: 24px;
    line-height: 32px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+:after {
    content: "";
    position: absolute;
    bottom: -20px;
    left: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_39___}) no-repeat;
    width: 100%;
    height: 3%;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv button.landingpage_btnUnfill__uGDrD,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomShare__Ymsn5,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9::after,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9::before,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+:last-child::after,
  .landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperNav__KUIrH,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo::after,
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo::before {
    display: none;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createStoryMidInner__0rqe3 .landingpage_createMidInnerInfo__F6n1\\+ {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo {
    margin-top: -25px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperSectionInfo_inner__m0gQX {
    margin: auto !important;
    height: 19em !important;
  }
  .landingpage_createStorySection__0UUkg .landingpage_moreStory__1x5Ug {
    padding: 30px 0;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo p {
    font-size: 24px;
    line-height: 30px;
    padding-bottom: 25px;
    margin-bottom: 0;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryBottom__oCOx9 .landingpage_createStoryBottomBtn__HcwAv {
    margin: 50px 0 0;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ p {
    font-size: 18px;
    line-height: 23px;
  }
  .landingpage_createStorySection__0UUkg
    .landingpage_createStoryMid__u2\\+wD
    .landingpage_createMidInnerInfo__F6n1\\+
    .landingpage_createMidInnerMainImg__LLO57 {
    width: 200px;
    height: 213px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ .landingpage_findIngredients__Uz4kN img {
    width: 68px;
    height: 64px;
    margin-top: -10px;
    margin-right: 15px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryMid__u2\\+wD .landingpage_createMidInnerInfo__F6n1\\+ span img {
    width: 141px;
  }
  .landingpage_storyBtn__rd8vk {
    font-size: 36px;
    line-height: 47px;
    border-image-slice: 25;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_MuniaMiddle__p\\+N7F {
    width: 65px;
    height: 63px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo h2 {
    font-size: 48px;
    line-height: 64px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_moreStory__1x5Ug .landingpage_moreStoryInner__2NNY3 img.landingpage_RedCross__OkwOP {
    width: 38px;
    height: 38px;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_createStoryTopMaintext__h8Gxh p {
    font-size: 20px;
    line-height: 30px;
    margin-top: 0;
  }
}

.landingpage_PickStoryHome__W8mYH p {
  font-weight: 600;
  text-align: center;
  color: #000;
  margin: 98px 0 35px;
}

.landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInnerInfo__C1SgF h4 {
  display: block !important;
}

.landingpage_storySectiontwo__HdMel {
  background: #d9eb41;
  padding: 12px 0;
}

.landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0;
}

.landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 .landingpage_btnStory__C12kQ,
.landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 p {
  flex: 0 0 50%;
  max-width: 50%;
}

.landingpage_btnFillRight__vprmz {
  width: 240px;
}

@media (min-width: 992px) and (max-width: 1199px) {
  .landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 27em !important;
  }
}

@media (max-width: 991px) {
  .landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 20em !important;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_cardHeader__nUyBC img {
    width: 300px;
    height: 285px;
    object-fit: cover;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O a {
    margin: 0 auto 57px;
    width: 90%;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O img {
    left: 40px;
  }
}

@media (max-width: 767px) {
  .landingpage_PickStoryHome__W8mYH p,
  .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 p {
    font-size: 18px;
    line-height: 23px;
  }
  .landingpage_btnFillRight__vprmz {
    width: 150px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A .landingpage_btnFill__Ctw\\+3.landingpage_btnFillLeft__2bXxh {
    margin-right: 0;
    width: 140px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_backbtn__JCEeY a {
    top: -5px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_account_bottom_info__Bg0\\+O img {
    left: 12px;
  }
  .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 {
    margin: 20px 0;
  }
  .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 .landingpage_btnStory__C12kQ,
  .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 p {
    flex: 0 0 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }
  .landingpage_storySectiontwo__HdMel {
    background: #56cdd5;
  }
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_publish__NLDrF .landingpage_tick__GcADW,
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_read__BQH4W .landingpage_tick__GcADW,
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_submit__dT5H5 .landingpage_tick__GcADW {
    width: 60px;
  }
  .landingpage_MySubmission__jt\\+jE .landingpage_MySubmissionInfo__vCULm .landingpage_MySubmissiondetail_read__BQH4W .landingpage_tick__GcADW {
    top: 20px;
    right: 32px;
  }
  .landingpage_mobileFooter__zaew6 .landingpage_footerRight__XMjSl .landingpage_emailInput__j2Jzp {
    display: flex;
    align-items: center;
  }
  .landingpage_mobileFooter__zaew6 .landingpage_footerRight__XMjSl .landingpage_emailInput__j2Jzp input {
    width: 100%;
  }
  .landingpage_mobileFooter__zaew6 .landingpage_footerRight__XMjSl .landingpage_emailInput__j2Jzp img {
    margin-top: 0;
  }
  .landingpage_PickStoryHome__W8mYH p {
    margin: 35px 0;
  }
  .landingpage_storySection__zDXM6 .landingpage_bgImageStoryNewLeft__-rs1G img {
    width: 85px;
  }
  .landingpage_storySection__zDXM6 .landingpage_bgImageStoryNewLeft__-rs1G {
    top: inherit;
    bottom: -12px;
    left: -45px;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button {
    bottom: 15px !important;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo {
    height: 200px;
  }
  .landingpage_MySubmission__jt\\+jE
    .landingpage_MySubmissionInfo__vCULm
    .landingpage_MySubmissiondetail_Ingredients__Vo1Um
    .landingpage_MySubmissionInfoInner__BmzgZ {
    width: 340px;
  }
}

@media (min-width: 991px) {
  .landingpage_ZidZagDesktopStory__Wi\\+yI img {
    width: 205px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_MenuCircularImgBottom__-RzME {
    display: none;
  }
}

@media (max-width: 450px) {
  .landingpage_ViewCardStory__QSRQZ .landingpage_swiperSection__tFPRl .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 19em !important;
  }
}

@media (max-width: 480px) {
  .landingpage_createStorySection__0UUkg .landingpage_createStoryTop__C9bFo .landingpage_cardHeader__nUyBC img {
    width: 250px;
    height: 235px;
    object-fit: cover;
  }
  .landingpage_createStorySection__0UUkg .landingpage_createStorySwiperInfo__4aOnp .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 16em !important;
  }
}

.landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S {
  margin-top: -85px;
}

.landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 {
  margin-bottom: 0;
}

.landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 .landingpage_btnStory__C12kQ button {
  margin-right: -1px;
}

.landingpage_menuMain__CIvXY .landingpage_backbtn__JCEeY {
  top: -20px;
}

.landingpage_menuMain__CIvXY .landingpage_backbtn__JCEeY img {
  width: 65px;
  z-index: 1;
  position: relative;
}

.landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel {
  background-color: transparent;
  margin: 0 0 50px;
}

.landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel h4 {
  display: none !important;
}

.landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 p {
  color: #f2dd4e;
  font-size: 24px;
  line-height: 31px;
}

.landingpage_menuMainHead__ZzQTs
  .landingpage_menuNoLogin__XFI9E
  .landingpage_storySectiontwo__HdMel
  .landingpage_storySectionTwoInner__Uyga1
  .landingpage_btnStory__C12kQ
  .landingpage_btnUnfill__uGDrD {
  color: #f2dd4e;
  border-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  border-image-repeat: stretch;
  border-image-slice: 15;
  border-image-width: 9px;
  border-image-outset: 0 0 8px 0;
}

.landingpage_MyStoryFlowInfo__u-zOd:active::after,
.landingpage_MyStoryFlowInfo__u-zOd:hover::after,
.landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:hover::after {
  content: "";
  position: absolute;
  right: -55px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) 0 0 / contain no-repeat;
  width: 24px;
  height: 60px;
  top: 20px;
}

.landingpage_MyStoryFlowInfo__u-zOd:active::before,
.landingpage_MyStoryFlowInfo__u-zOd:hover::before,
.landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:active:before,
.landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:hover:before,
.landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::before,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::before,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::before,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:active:before,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover:before,
.landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:active::before,
.landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:hover::before {
  content: "";
  position: absolute;
  left: -60px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) 0 0 / contain no-repeat;
  width: 24px;
  height: 65px;
  top: 20px;
}

.landingpage_MyStoryFlowInfo__u-zOd:active::after,
.landingpage_MyStoryFlowInfo__u-zOd:active::before,
.landingpage_MyStoryFlowInfo__u-zOd:hover::after,
.landingpage_MyStoryFlowInfo__u-zOd:hover::before {
  top: 33px;
  cursor: pointer;
}
.landingpage_createStoryTop__C9bFo .landingpage_btnFill__Ctw\\+3:hover::before,
.landingpage_createStoryTop__C9bFo .landingpage_btnFill__Ctw\\+3:active::before {
  content: "";
  position: absolute;
  left: -60px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) 0 0 / contain no-repeat;
  width: 24px;
  height: 65px;
  top: 0;
}
.landingpage_createStoryTop__C9bFo .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_createStoryTop__C9bFo .landingpage_btnFill__Ctw\\+3:active::after {
  content: "";
  position: absolute;
  right: -55px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_52___}) 0 0 / contain no-repeat;
  width: 24px;
  height: 60px;
  top: 0;
}
.landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::before,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::before,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::before,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover::after,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover:before {
  top: 0;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:active::after,
.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:hover::after {
  content: "";
  position: absolute;
  right: -35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___}) 0 0 / contain
    no-repeat;
  width: 19px;
  height: 42px;
  top: 20px;
}

.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:active::before,
.landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:hover::before {
  content: "";
  position: absolute;
  left: -35px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_76___}) 0 0 / contain
    no-repeat;
  width: 17px;
  height: 41px;
  top: 20px;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:active::after,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover::after {
  height: 60px;
}

.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:active:before,
.landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover:before {
  width: 30px;
  height: 100px;
  left: -50px;
}

.landingpage_ShareStoryFlowNewbottom__R7pli {
  background: #56cdd5;
  padding: 50px 0;
  margin-top: -30px;
  position: relative;
}

.landingpage_ShareStoryFlowNewbottom__R7pli p {
  font-weight: 600;
  font-size: 48px;
  line-height: 71px;
  text-align: center;
  color: #000;
  margin-bottom: 50px;
}

.landingpage_ShareStoryFlowNewbottom__R7pli .landingpage_createStoryBottomBtn__HcwAv .landingpage_btnUnfill__uGDrD {
  padding: 12px 80px;
}

.landingpage_ShareStoryFlowNewbottom__R7pli .landingpage_createStoryBottomShare__Ymsn5 {
  width: 50%;
  margin: 50px auto auto;
}

.landingpage_ShareStoryFlowNewbottom__R7pli .landingpage_createStoryBottomShare__Ymsn5 span {
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #000;
  display: block;
  text-align: left;
  margin-bottom: 5px;
}

@media (max-width: 767px) {
  .landingpage_cardPickSection__-x4G0
    .landingpage_swiperSectionInfo_inner__m0gQX
    .landingpage_swiperSection_InfoDe__HyLRa
    .landingpage_swiperSlide__2xd3F
    .landingpage_cardHeader__nUyBC
    img {
    width: 542px;
    height: 152px;
  }
  .landingpage_birdTopText__vnNOx span {
    top: 16px;
    width: 80px;
    font-size: 12px;
    line-height: 14px;
    right: -2px;
  }
  .landingpage_ShareStoryFlowNewbottom__R7pli .landingpage_createStoryBottomShare__Ymsn5 span,
  .landingpage_ShareStoryFlowNewbottom__R7pli img,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z .landingpage_socialIcon__UuuAD,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z h5,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z p,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_leftInfo__0XV3z:after {
    display: none;
  }
  .landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S {
    margin-top: 0;
  }
  .landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 p {
    font-size: 18px;
    line-height: 23px;
  }
  .landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel {
    margin: 0 0 15px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:active::after,
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:hover::after {
    top: 12px;
    right: -25px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:active::before,
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a:hover::before {
    top: 12px;
    left: -28px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd:active::before,
  .landingpage_MyStoryFlowInfo__u-zOd:hover::before,
  .landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:active:before,
  .landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:hover:before,
  .landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::before,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::before,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::before,
  .landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:active:before,
  .landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover:before,
  .landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:active::before,
  .landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:hover::before {
    top: 10px;
    left: -35px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
    width: 16px;
    height: 36px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd:active::after,
  .landingpage_MyStoryFlowInfo__u-zOd:hover::after,
  .landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:active::after,
  .landingpage_StoryFlowInfoBtn__BLWad .landingpage_btnFill__Ctw\\+3:hover::after,
  .landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:active::after,
  .landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::after,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::after,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::after,
  .landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:active::after,
  .landingpage_downoadGuppyApp__eQPEW .landingpage_btnFill__Ctw\\+3:hover::after,
  .landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:active::after,
  .landingpage_sharestorysec__AIFxv .landingpage_btnFill__Ctw\\+3:hover::after {
    top: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
    width: 17px;
    height: 37px;
    right: -35px;
  }
  .landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::after,
  .landingpage_ViewCardStory__QSRQZ .landingpage_btnFill__Ctw\\+3:hover::before,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::after,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:active::before,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::after,
  .landingpage_btnStory__C12kQ .landingpage_btnFill__Ctw\\+3:hover::before {
    top: 4px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd:active::before,
  .landingpage_MyStoryFlowInfo__u-zOd:hover::before {
    top: 23px;
    left: -30px;
  }
  .landingpage_MyStoryFlowInfo__u-zOd:active::after,
  .landingpage_MyStoryFlowInfo__u-zOd:hover::after {
    top: 23px;
    right: -27px;
  }
  .landingpage_ShareStoryFlowNewbottom__R7pli p {
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
  }
}

@media (max-width: 400px) {
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX {
    height: 15em !important;
  }
  .landingpage_PackagesMainGredient__y6S\\+y
    .landingpage_PackagesInfo__sqhBn
    .landingpage_PackagesInfoInner__\\+Ftfj
    .landingpage_PackagesInfoInnerImg__dXNPB
    img {
    width: 105px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesInfo__sqhBn {
    margin-top: 20px;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy p {
    font-size: 16px !important;
    line-height: 22px !important;
  }
  .landingpage_PackagesMainGredient__y6S\\+y .landingpage_PackagesMain_bottom__CFvIy p br {
    display: none;
  }
  .landingpage_PackagesMainGredient__y6S\\+y::before {
    top: 9%;
  }
  .landingpage_PackagesMainGredient__y6S\\+y::after {
    top: 23%;
  }
  .landingpage_btnFill__Ctw\\+3,
  .landingpage_btnUnfill__uGDrD {
    font-size: 20px;
    line-height: 22px;
  }
  .landingpage_btnFill__Ctw\\+3 {
    padding: 5px 10px;
  }
  .landingpage_btnUnfill__uGDrD {
    padding: 5px 15px;
  }
}

.landingpage_TermsConditionsMain__wM2cb {
  background: #f2dd4e;
  padding-top: 40px;
  margin-top: -10px;
}

.landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsBottom__yPJBt ul {
  margin-left: 40px;
}

.landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsBottom__yPJBt h5,
.landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsBottom__yPJBt p,
.landingpage_TermsConditionsMain__wM2cb p span {
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #000;
  margin: 15px 0;
}

.landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsBottom__yPJBt p {
  font-weight: 500;
}

.landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsTop__bQnZ- h1 {
  text-align: center;
  display: inline-block;
  width: 90%;
}

.landingpage_TermsConditionsMain__wM2cb h2 {
  text-align: center;
  color: #000;
  font-weight: 700;
  font-size: 36px;
  line-height: 47px;
  margin: 50px 0 30px;
  position: relative;
}

.landingpage_PasswordUpdatedScreenMain__89uxS p,
.landingpage_signupHeadline__BkgvB {
  font-weight: 600;
  color: #000;
  text-align: center;
}

.landingpage_TermsConditionsMain__wM2cb h2::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  background-repeat: no-repeat;
  width: 100%;
  height: 24px;
  background-size: cover;
  position: absolute;
  top: -30px;
  left: 0;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs .landingpage_EditInfoSubmission__4o0Fn {
    right: -30px;
  }
  .landingpage_MySubmissionInfoDraft__aHgi3 .landingpage_MySubmissiondetail__Jn9xs .landingpage_EditInfoSubmission__4o0Fn img {
    width: 104px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_cardHeader__nUyBC img {
    max-width: 100%;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSection__tFPRl .landingpage_swiperSectionInfo_inner__m0gQX {
    margin-left: 0 !important;
    display: flex;
    justify-content: center;
  }
  .landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH .landingpage_swiperNext__Fr-HA {
    right: -20px;
  }
  .landingpage_swiperSection__tFPRl .landingpage_swiperNav__KUIrH .landingpage_swiperPrev__WqtYH {
    left: -20px;
  }
  .landingpage_menuMainHead__ZzQTs
    .landingpage_menuNoLogin__XFI9E
    .landingpage_storySectiontwo__HdMel
    .landingpage_storySectionTwoInner__Uyga1
    .landingpage_btnStory__C12kQ
    .landingpage_btnUnfill__uGDrD {
    font-size: 20px;
    padding: 7px 14px;
    line-height: 32px;
  }
  .landingpage_menuMainHead__ZzQTs .landingpage_menuNoLogin__XFI9E .landingpage_storySectiontwo__HdMel .landingpage_storySectionTwoInner__Uyga1 {
    align-items: center;
  }
  .landingpage_ShareStoryFlowNewbottom__R7pli p {
    font-size: 20px;
    line-height: 30px;
  }
  .landingpage_TermsConditionsMain__wM2cb h2 {
    font-size: 25px;
    line-height: 32px;
  }
  .landingpage_TermsConditionsMain__wM2cb {
    margin-top: -20px;
  }
}

.landingpage_PasswordUpdatedScreenMain__89uxS {
  background: #f2dd4e;
  text-align: center;
  position: relative;
  overflow: hidden;
  padding: 100px 0 150px;
}

.landingpage_PasswordUpdatedScreenMain__89uxS p {
  font-size: 24px;
  line-height: 37px;
}

.landingpage_PasswordUpdatedScreenMain__89uxS p.landingpage_PasswordNewSuccesspara1__RHQZg {
  margin-bottom: 40px;
  margin-top: 40px;
}

.landingpage_signupHeadline__BkgvB {
  font-size: 28px;
  line-height: 36px;
  margin-bottom: 30px;
}

.landingpage_ParentConsentFormSection__IwY8Y {
  border: 1px solid #000;
  border-radius: 10px;
  padding: 40px;
  margin: 40px auto;
}

.landingpage_ParentConsentFormSection__IwY8Y h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  color: #000;
  margin-bottom: 40px;
}

.landingpage_ParentConsentFormSection__IwY8Y p {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #000;
}

.landingpage_ParentConsentFormSection__IwY8Y p input {
  border: 0;
  border-bottom: 2px dashed #000;
}

.landingpage_ParentConsentFormSection__IwY8Y p .landingpage_fieldCommon__jYEsF {
  width: 200px;
  display: inline-block;
}

.landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S {
  max-width: 50%;
  padding-left: 15px;
}

.landingpage_ParentConsentFormSectionTop__YVFAa {
  margin-bottom: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.landingpage_LoadingMain__yz5gy {
  background-color: #f2dd4e !important;
}

.landingpage_LoadingMainChild__KSStZ,
.landingpage_LoadingMainChild__KSStZ span {
  left: 50%;
  background: 0 0;
  position: absolute;
}

.landingpage_LoadingMainChild__KSStZ {
  top: 50%;
  transform: translate(-50%, -50%);
  width: 150px;
  height: 150px;
  border: 3px solid #f2dd4e;
  border-radius: 50%;
  text-align: center;
  line-height: 150px;
  font-size: 25px;
  color: #000 !important;
  text-shadow: 0 0 10px #000;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.landingpage_LoadingMainChild__KSStZ:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid transparent;
  border-top: 3px solid #000;
  border-right: 3px solid #000;
  border-radius: 50%;
  animation: 2s linear infinite landingpage_animateC__GT-yF;
}

.landingpage_LoadingMainChild__KSStZ span {
  display: block;
  top: calc(50% - 2px);
  width: 50%;
  height: 4px;
  transform-origin: left;
  animation: 2s linear infinite landingpage_animate__60nVA;
}

.landingpage_LoadingMainChild__KSStZ span:before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #000;
  top: -6px;
  right: -8px;
  box-shadow: 0 0 20px #000;
}

@keyframes landingpage_animateC__GT-yF {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes landingpage_animate__60nVA {
  0% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(405deg);
  }
}

@media (min-width: 1200px) {
  .landingpage_menuMainHead__ZzQTs .landingpage_storySectiontwo__HdMel {
    margin: 50px 0 130px;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span .landingpage_accountTitle__yDT7z {
    display: inline-block !important;
  }
  .landingpage_myaccount_main__ToIhz .landingpage_accountmain_top__yo2en span strong {
    display: initial;
  }
}

@media (max-width: 575px) {
  .landingpage_createStorySection__0UUkg .landingpage_moreStoryInner__2NNY3 .landingpage_moreStoryInnerMainNew__Hjvc1 {
    width: 95px !important;
    height: 100px !important;
  }
  .landingpage_banner__GQV94 {
    margin-top: -22px;
  }
  .landingpage_swiperNavtwo__vMqck .landingpage_swiperNext__Fr-HA img,
  .landingpage_swiperNavtwo__vMqck .landingpage_swiperPrev__WqtYH img {
    width: 50px;
  }
  .landingpage_cardFooter__DpSg9 {
    padding: 8px 10px;
  }
  .landingpage_cardPickSection__-x4G0 .landingpage_swiperSectionInfo_inner__m0gQX .landingpage_swiperSlide__2xd3F .landingpage_cardNew__cPEuz {
    max-width: 62%;
  }
  .landingpage_swiperNavtwo__vMqck {
    bottom: 42%;
  }
  .landingpage_storySection__zDXM6 .landingpage_btnStory__C12kQ button.landingpage_btnUnfill__uGDrD {
    margin: auto 12px;
    padding: 5px;
    width: 145px;
  }
  .landingpage_btsSection__l5qw9 .landingpage_btsSectionInfo__E6rYo button {
    bottom: 0 !important;
  }
  .landingpage_storyPageMain__C2nSX p {
    font-size: 20px;
    line-height: 32px;
    margin: 15px 0;
  }
  .landingpage_StoryFlows__ZB9Nz .landingpage_StoryFlow_bottom__3eYYZ .landingpage_StoryFlowInfo__6Ytzx p {
    font-size: 20px;
    line-height: 30px;
    margin: 15px 0;
  }
  .landingpage_menuMain__CIvXY {
    width: 90% !important;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainHead__ZzQTs .landingpage_menuMainhead_inner__FfSW6 span {
    flex: 0 0 55%;
    max-width: 55%;
  }
  .landingpage_menuMain__CIvXY .landingpage_menunewdivmid__sRCGi {
    display: block !important;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainhead_inner__FfSW6 span strong {
    font-size: 25px !important;
    line-height: 25px !important;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a {
    padding: 5px !important;
    font-size: 22px;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl a img {
    max-width: 40px;
  }
  .landingpage_menuMain__CIvXY::after {
    bottom: -10px;
    left: -25px;
    display: none;
  }
  .landingpage_menuMain__CIvXY .landingpage_menuMainInner__Fb0Xl {
    margin-top: 10px;
  }
}

@media (max-width: 767px) {
  .landingpage_TermsConditionsMain__wM2cb h2 {
    font-size: 22px;
    line-height: 30px;
  }
  .landingpage_TermsConditionsMain__wM2cb {
    margin-top: -20px;
  }
  .landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsTop__bQnZ- h1 {
    width: 80%;
    font-size: 28px;
    left: 35px;
  }
  .landingpage_TermsConditionsMain__wM2cb .landingpage_TermsConditionsTop__bQnZ- img {
    width: 35px;
  }
  .landingpage_TermsConditionsMain__wM2cb a {
    font-size: 20px !important;
    line-height: 30px !important;
    word-wrap: break-word;
  }
  .landingpage_TermsConditionsMain__wM2cb .landingpage_DownloadConsentFormimg__uLmXi {
    width: 30px;
  }
  .landingpage_TermsConditionsMain__wM2cb span {
    font-size: 16px;
    line-height: 25px;
  }
  .landingpage_ParentConsentFormSectionTop__YVFAa img,
  .landingpage_PasswordUpdatedScreenMain__89uxS p.landingpage_PasswordNewSuccesspara2__Ko0Uk {
    margin-bottom: 20px;
  }
  .landingpage_PasswordUpdatedScreenMain__89uxS .landingpage_PasswordUpdatedBottom__P4K-7 img {
    width: 100px;
    margin-top: 40px;
  }
  .landingpage_PasswordUpdatedScreenMain__89uxS .landingpage_PasswordUpdatedTop__V5SuE img {
    display: block;
    width: auto;
    margin: auto;
  }
  .landingpage_PasswordUpdatedScreenMain__89uxS {
    margin-top: -35px;
  }
  .landingpage_PasswordUpdatedScreenMain__89uxS p {
    font-size: 20px;
    line-height: 31px;
  }
  .landingpage_PasswordUpdatedScreenMain__89uxS p br,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S br {
    display: none;
  }
  .landingpage_ParentConsentFormSectionTop__YVFAa {
    justify-content: center;
    flex-direction: column-reverse;
  }
  .landingpage_ParentConsentFormSectionTop__YVFAa p {
    text-align: center;
  }
  .landingpage_ParentConsentFormSection__IwY8Y p .landingpage_fieldCommon__jYEsF {
    width: 100%;
  }
  .landingpage_ParentConsentFormSection__IwY8Y p input {
    margin-bottom: 15px;
  }
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S {
    max-width: 100%;
    padding-left: 15px;
  }
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S a,
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S p {
    font-size: 20px !important;
    line-height: 24px !important;
  }
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S img {
    margin-bottom: 40px;
  }
  .landingpage_signUpOtp__hGlWQ .landingpage_signUpInfo__lrGdo {
    padding-top: 100px;
  }
  .landingpage_ParentConsentFormSection__IwY8Y {
    padding: 15px !important;
  }
  .landingpage_ParentConsentFormSection__IwY8Y p {
    font-size: 20px;
    line-height: 26px;
  }
  .landingpage_signUpInfo__lrGdo .landingpage_rightInfo__VCs2S form .landingpage_wrapdiv__kXFlt span {
    font-size: 16px;
    line-height: 24px;
  }
  .landingpage_header_section__eWp\\+J {
    padding-top: 0;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A .landingpage_submissionNewLEftBtn__6Ms8e {
    margin-right: 28px !important;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A button {
    padding: 7px 10px;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A button.landingpage_activeEffect__moV0-::after,
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A button.landingpage_activeEffect__moV0-::before {
    top: 0;
  }
  .landingpage_MyStories__xS1Bu .landingpage_storybtn__Rmk5A .landingpage_submissionNewRightBtn__W\\+neQ {
    margin-left: 30px !important;
  }
  .landingpage_DownloadConsentFormText__wwmxY {
    font-size: 16px !important;
    line-height: 28px !important;
  }
  .landingpage_BackToTOpImg__Zu1Gs {
    width: 50px !important;
  }
  .landingpage_BackToTop__ymJgK {
    margin-top: 15px;
  }
}

.landingpage_header_section__eWp\\+J {
  position: fixed;
  width: 100%;
}
.landingpage_storySection__zDXM6 .landingpage_storySectionTwoInnerInfo__C1SgF {
  display: none;
}
@media (min-width: 1200px) {
  .landingpage_MyStories__xS1Bu,
  .landingpage_MyStoryFlowMain__PvUat,
  .landingpage_PackagesMain__vvtmP,
  .landingpage_PasswordUpdatedScreenMain__89uxS,
  .landingpage_loginBg__JZmcK,
  .landingpage_myavtarsection__6IZ7k,
  .landingpage_signUpBg__6ajTf,
  .landingpage_myaccount_main__ToIhz,
  .landingpage_faqMain__0o88r,
  .landingpage_contactSection__EICPg,
  .landingpage_TermsConditionsMain__wM2cb,
  .landingpage_createStorySection__0UUkg,
  .landingpage_StoryFlows__ZB9Nz,
  .landingpage_edit_profile_section__ujP6U {
    margin-top: 115px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .landingpage_MyStories__xS1Bu,
  .landingpage_MyStoryFlowMain__PvUat,
  .landingpage_PackagesMain__vvtmP,
  .landingpage_PasswordUpdatedScreenMain__89uxS,
  .landingpage_loginBg__JZmcK,
  .landingpage_menuMain__CIvXY,
  .landingpage_myavtarsection__6IZ7k,
  .landingpage_signUpBg__6ajTf,
  .landingpage_myaccount_main__ToIhz,
  .landingpage_faqMain__0o88r,
  .landingpage_contactSection__EICPg,
  .landingpage_TermsConditionsMain__wM2cb,
  .landingpage_createStorySection__0UUkg,
  .landingpage_StoryFlows__ZB9Nz,
  .landingpage_edit_profile_section__ujP6U {
    margin-top: 75px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .landingpage_MyStories__xS1Bu,
  .landingpage_MyStoryFlowMain__PvUat,
  .landingpage_PackagesMain__vvtmP,
  .landingpage_PasswordUpdatedScreenMain__89uxS,
  .landingpage_loginBg__JZmcK,
  .landingpage_menuMain__CIvXY,
  .landingpage_myavtarsection__6IZ7k,
  .landingpage_signUpBg__6ajTf,
  .landingpage_myaccount_main__ToIhz,
  .landingpage_faqMain__0o88r,
  .landingpage_StoryFlows__ZB9Nz,
  .landingpage_contactSection__EICPg,
  .landingpage_edit_profile_section__ujP6U,
  .landingpage_storyPageMain__C2nSX,
  .landingpage_TermsConditionsMain__wM2cb,
  .landingpage_createStorySection__0UUkg {
    margin-top: 80px;
  }
}
@media (max-width: 767px) {
  .landingpage_MyStories__xS1Bu,
  .landingpage_TermsConditionsMain__wM2cb,
  .landingpage_createStorySection__0UUkg,
  .landingpage_MyStoryFlowMain__PvUat,
  .landingpage_myavtarsection__6IZ7k,
  .landingpage_PackagesMain__vvtmP,
  .landingpage_StoryFlows__ZB9Nz,
  .landingpage_contactSection__EICPg,
  .landingpage_edit_profile_section__ujP6U,
  .landingpage_faqMain__0o88r,
  .landingpage_loginBg__JZmcK,
  .landingpage_myaccount_main__ToIhz,
  .landingpage_signUpBg__6ajTf,
  .landingpage_storyPageMain__C2nSX {
    margin-top: 52px;
  }
  .landingpage_cardPickSection__-x4G0 {
    padding: 90px 0 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/landingpage.module.css"],"names":[],"mappings":"AAAA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,yDAA8D;EAC9D,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,OAAO;EACP,sBAAsB;AACxB;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;EAKE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;;;;;;EAOE,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,+BAA+B;AACjC;;AAEA;;;;;;;;EAQE,kCAAkC;AACpC;;AAEA;;;;;;;;EAQE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,4CAAoD;EACpD;;;;;;mBAMiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4CAAmD;EACnD;;;;;;mBAMiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,6CAAiD;EACjD;;;;;0DAK2E;EAC3E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,6CAAoD;EACpD;;;;;;mBAMiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6CAAgD;EAChD;;;;;0DAKyE;EACzE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;;EAME,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,sDAAuD;EACvD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,sDAAyD;EACzD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,MAAM;EACN,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;EAeE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,0DAAyD;EACzD,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,wBAAwB;EACxB,UAAU;EACV,eAAe;EACf,WAAW;EACX,0DAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,SAAO;EACP,yBAAyB;EACzB,eAAe;EACf,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;EAWE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;EAGE,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,0DAAwD;EACxD,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,0DAAyE;EACzE,wBAAwB;AAC1B;;AAEA;EACE,sDAA2D;EAC3D,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,0DAAgE;EAChE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,0DAA0D;EAC1D,4BAA4B;EAC5B,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;;;;EAIE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,YAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sDAAwD;EACxD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,0DAAqD;EACrD,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,0DAAwD;EACxD,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sDAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,sDAAuE;EACvE,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,sDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;aACW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,MAAM;EACN,kBAAkB;EAClB,8DAA8D;EAC9D,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;EACA;;;;;;;;;;;;;;;;;;;;;;IAsBE,aAAa;EACf;EACA;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,UAAU;EACZ;EACA;;IAEE,OAAO;EACT;EACA;IACE,MAAM;IACN,QAAQ;EACV;EACA;IACE,WAAW;EACb;EACA;IACE,QAAQ;IACR,SAAS;IACT,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,SAAS;IACT,YAAY;IACZ,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,UAAU;IACV,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;IAIE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,UAAU;EACZ;EACA;;;;IAIE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;;;;;IAKE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;EACA;;;IAGE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;IACT,YAAY;IACZ,WAAW;IACX,aAAa;IACb,SAAS;EACX;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,0DAA0D;IAC1D,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,OAAO;IACP,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,OAAO;IACP,WAAW;IACX,eAAe;EACjB;EACA;IACE,OAAO;IACP,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;;IAEE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,qBAAqB;EACvB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,SAAS;IACT,UAAU;IACV,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;;;IAGE,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,6CAA6C;EAC/C;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;;EAEE,sDAA4D;AAC9D;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,UAAU;EACZ;EACA;;IAEE,aAAa;EACf;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,sDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;EAC5E,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,4EAA4E;EAC5E,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,UAAU;EACV,sDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;;;EAIE,0DAAqD;AACvD;;AAEA;;;;EAIE,0DAAqD;EACrD,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sDAAuD;EACvD,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,sDAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;;;;;;;;;;EAWE,aAAa;AACf;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,iCAAiC;IACjC,mCAAmC;EACrC;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;;IAEE,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;;;;;IAKE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;EACA;;;;;;;;;;;;IAYE,aAAa;EACf;EACA;IACE,WAAW;IACX,oDAA+D;IAC/D,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,oDAAgE;IAChE,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,eAAe;EACjB;EACA;IACE,cAAc;IACd,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;EACV;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;;;;;;;;;;;;;IAaE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,SAAS;EACX;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,aAAa;IACb,eAAe;IACf,uBAAuB;EACzB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,8DAAoE;IACpE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;EACA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;;;;IAIE,yBAAyB;EAC3B;EACA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB;eACW;IACX,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,OAAO;EACT;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,8DAA2E;IAC3E,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,OAAO;EACT;EACA;IACE,WAAW;IACX,8DAA2E;IAC3E,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,QAAQ;EACV;EACA;IACE,YAAY;EACd;EACA;;;;;IAKE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;;;;;;IAME,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,QAAQ;EACV;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;;;;;IAKE,aAAa;EACf;EACA;IACE,OAAO;EACT;EACA;IACE,UAAU;EACZ;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,WAAW;EACb;EACA;;;IAGE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;;;;;;;;;;;;IAYE,iBAAiB;EACnB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;;;IAGE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;;;;IAIE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,SAAS;IACT,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,2BAAsB;IAAtB,sBAAsB;IACtB,SAAS;EACX;EACA;;;;IAIE,aAAa;IACb,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;;IAKE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,0DAAwE;EACxE,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,0DAA0E;AAC5E;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sDAAgE;EAChE,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0DAAgE;EAChE,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;EAME,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,8DAAoE;EACpE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,8DAAmE;EACnE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8DAA0E;EAC1E,YAAY;EACZ,aAAa;EACb,UAAU;EACV,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8DAA2E;EAC3E,YAAY;EACZ,aAAa;EACb,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;;;;EAKE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,8DAA8D;EAC9D,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;aACW;EACX,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,cAAc;EACd,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sDAA+D;EAC/D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE;IACE,SAAS;EACX;EACA;;;;;;;;IAQE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,0DAA0D;IAC1D,4BAA4B;IAC5B,WAAW;IACX,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,UAAU;EACZ;EACA;IACE,WAAW;IACX,MAAM;IACN,YAAY;EACd;EACA;;;;IAIE,SAAS;IACT,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;;;;IAIE,SAAS;EACX;EACA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8BAA8B;EAChC;EACA;;IAEE,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;EACA;IACE,mBAAmB;EACrB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;EACjC;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,8DAA8D;IAC9D,WAAW;IACX,UAAU;EACZ;EACA;;;;;;;;IAQE,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;;;IAIE,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;IACE,UAAU;EACZ;EACA;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;EACb;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;EACA;;;;IAIE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;;;EAME,cAAc;EACd,sDAA4D;EAC5D,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;;;;;;;;;;;;EAYE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;EAC5E,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;;;;;;;;;;EAWE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;;;EAIE,SAAS;EACT,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,4EAA2E;EAC3E,WAAW;EACX,YAAY;EACZ,MAAM;AACR;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;EAC5E,WAAW;EACX,YAAY;EACZ,MAAM;AACR;AACA;;;;;;;;EAQE,MAAM;AACR;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ;aACW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX;aACW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;;;;;;IAME,YAAY;IACZ,aAAa;EACf;EACA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;EACA;;;;;;IAME,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,SAAS;IACT,YAAY;EACd;EACA;;IAEE,SAAS;IACT,WAAW;EACb;EACA;;;;;;;;;;;IAWE,SAAS;IACT,WAAW;IACX,oDAA+D;IAC/D,WAAW;IACX,YAAY;EACd;EACA;;;;;;;;;;;;IAYE,SAAS;IACT,oDAAgE;IAChE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;EACA;;;;;;IAME,QAAQ;EACV;EACA;;IAEE,SAAS;IACT,WAAW;EACb;EACA;;IAEE,SAAS;IACT,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;;;;;IAKE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0DAAiE;EACjE,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,OAAO;AACT;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;;;;;;IAME,eAAe;IACf,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,yDAAsC;AACxC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,wDAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,gCAAgC;EAClC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;EACd;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,WAAW;IACX,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,eAAe;IACf,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;EACvB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;;IAEE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,MAAM;EACR;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE;;;;;;;;;;;;;;IAcE,iBAAiB;EACnB;AACF;AACA;EACE;;;;;;;;;;;;;;;IAeE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;;;;;;;;;;;;IAgBE,gBAAgB;EAClB;AACF;AACA;EACE;;;;;;;;;;;;;;IAcE,gBAAgB;EAClB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".btnFill,\n.btnUnfill {\n  margin: 0 10px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.border-main,\n.btnUnfill {\n  border: 3px solid #0d5268;\n}\n\n.btnFill,\n.btnUnfill,\nh2,\nh4 {\n  text-align: center;\n}\n\n.header_section::before,\n.is_sticky::before {\n  background-image: url(../../assets/images/curve-bg-header.png);\n  width: 100%;\n  top: -20px;\n  background-position: center;\n  left: 0;\n  background-size: cover;\n}\n\n.btnFill,\n.btnUnfill,\n.headerGs p {\n  font-size: 36px;\n  line-height: 47px;\n}\n\n.cardPickSection::before,\n.cardborder,\n.header_section::before,\n.is_sticky::before,\n.signUpInfo::after {\n  content: \"\";\n  background-repeat: no-repeat;\n}\n\n.btsSection .btsSectionInfo,\n.cardPickSection::before,\n.cardborder,\n.cardborderthree,\n.header_section::before,\n.is_sticky::before,\n.signUpInfo::after {\n  background-repeat: no-repeat;\n}\n\n.border-main,\n.footerLeft a {\n  display: inline-block;\n}\n\n.StoryFlows .Viewfullstory a,\n.footerMid a,\n.footerMidLeft a,\n.loginBg .forgerPass a,\n.logoutMenuBottomNew a.logoutMenuBottoma,\n.menuMain .menuMainHead h3,\n.menuMain a.logoutMenu,\n.mobileFooter .mobilelink a,\n.myaccount_main .logout a,\n.storyPagecompMain a {\n  text-decoration-line: underline;\n}\n\n.MySubmission\n  .MySubmissionInfo\n  .MySubmissiondetail_Ingredients\n  .MySubmissionInfoInner\n  h3,\n.btnFill,\n.btsSection .theaterInfo .theaterLeftInfo h4,\nbody {\n  font-family: Kodchasan, sans-serif;\n}\n\n.MyStories,\n.MyStoryFlowMain,\n.PackagesMain,\n.PasswordUpdatedScreenMain,\n.loginBg,\n.menuMain,\n.myavtarsection,\n.signUpBg {\n  min-height: 100vh;\n}\n\n@font-face {\n  font-family: Kodchasan;\n  src: url(\"../../assets/fonts/Kodchasan-Regular.eot\");\n  src: url(\"../../assets/fonts/Kodchasan-Regular.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../../assets/fonts/Kodchasan-Regular.woff2\") format(\"woff2\"),\n    url(\"../../assets/fonts/Kodchasan-Regular.woff\") format(\"woff\"),\n    url(\"../../assets/fonts/Kodchasan-Regular.ttf\") format(\"truetype\"),\n    url(\"../../assets/fonts/Kodchasan-Regular.svg#Kodchasan-Regular\")\n      format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Cabin Sketch\";\n  src: url(\"../../assets/fonts/CabinSketch-Bold.eot\");\n  src: url(\"../../assets/fonts/CabinSketch-Bold.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../../assets/fonts/CabinSketch-Bold.woff2\") format(\"woff2\"),\n    url(\"../../assets/fonts/CabinSketch-Bold.woff\") format(\"woff\"),\n    url(\"../../assets/fonts/CabinSketch-Bold.ttf\") format(\"truetype\"),\n    url(\"../../assets/fonts/CabinSketch-Bold.svg#CabinSketch-Bold\")\n      format(\"svg\");\n  font-weight: 700;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Roboto;\n  src: url(\"../../assets/fonts/Roboto-Regular.eot\");\n  src: url(\"../../assets/fonts/Roboto-Regular.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../../assets/fonts/Roboto-Regular.woff2\") format(\"woff2\"),\n    url(\"../../assets/fonts/Roboto-Regular.woff\") format(\"woff\"),\n    url(\"../../assets/fonts/Roboto-Regular.ttf\") format(\"truetype\"),\n    url(\"../../assets/fonts/Roboto-Regular.svg#Roboto-Regular\") format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Roof runners active\";\n  src: url(\"../../assets/fonts/Roofrunnersactive.eot\");\n  src: url(\"../../assets/fonts/Roofrunnersactive.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../../assets/fonts/Roofrunnersactive.woff2\") format(\"woff2\"),\n    url(\"../../assets/fonts/Roofrunnersactive.woff\") format(\"woff\"),\n    url(\"../../assets/fonts/Roofrunnersactive.ttf\") format(\"truetype\"),\n    url(\"../../assets/fonts/Roofrunnersactive.svg#Roofrunnersactive\")\n      format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: Inter;\n  src: url(\"../../assets/fonts/Inter-Regular.eot\");\n  src: url(\"../../assets/fonts/Inter-Regular.eot?#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"../../assets/fonts/Inter-Regular.woff2\") format(\"woff2\"),\n    url(\"../../assets/fonts/Inter-Regular.woff\") format(\"woff\"),\n    url(\"../../assets/fonts/Inter-Regular.ttf\") format(\"truetype\"),\n    url(\"../../assets/fonts/Inter-Regular.svg#Inter-Regular\") format(\"svg\");\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --black: #000000;\n  --blue: #56cdd5;\n  --white: #ffffff;\n  --green: #d9eb41;\n  --red: #ed4c55;\n  --dark-blue: #0d5268;\n  --yellow: #f2dd4e;\n}\n\nbody {\n  font-size: 16px;\n  font-weight: 400;\n}\n\nh1,\nh2 {\n  font-family: \"Cabin Sketch\", cursive;\n  color: #000;\n  margin-bottom: 0;\n}\n\n.TermsConditionsMain .TermsConditionsBottom ul li,\nli {\n  list-style-type: none;\n}\n\n#MainMenu {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n#MainMenu ::-webkit-scrollbar {\n  display: none;\n}\n\np {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 31px;\n  color: var(--black);\n  margin-bottom: 0;\n}\n\n.btnFill,\n.btnUnfill,\n.headerGs p,\nh1,\nh2,\nh4 {\n  font-weight: 700;\n}\n\n.btnFill {\n  color: #fff;\n  padding: 7px 25px;\n  background-color: #0d5268;\n  border-image: url(../../assets/images/border-image.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-image-outset: 8px 8px 14px 8px;\n}\n\n.btnUnfill {\n  background-color: transparent;\n  padding: 7px 30px;\n  border-image: url(../../assets/images/BsComBtnBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-image-outset: 0 0 8px 0;\n  color: #0d5268;\n}\n\na:hover {\n  text-decoration: none;\n}\n\nimg {\n  max-width: 100%;\n}\n\n.rotating {\n  transform: rotate(360deg);\n}\n\n.border-main {\n  border-radius: 255px 15px 225px/15px 225px 15px 255px;\n  padding: 5px;\n}\n\nbutton:focus,\nbutton:focus-visible {\n  outline: 0;\n}\n\nh1 {\n  font-size: 48px;\n  line-height: 56px;\n  text-align: left;\n}\n\nh2 {\n  font-size: 72px;\n  line-height: 84px;\n}\n\n.cardPickSection .cardborderfouth,\nh4 {\n  line-height: 56px;\n  font-family: \"Cabin Sketch\", cursive;\n}\n\nh4 {\n  font-style: normal;\n  font-size: 48px;\n  color: #000;\n  margin-bottom: 0;\n}\n\n.is_sticky {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 999;\n}\n\n.is_sticky::before {\n  height: 160%;\n  position: absolute;\n}\n\nheader {\n  z-index: 9;\n  position: relative;\n}\n\n.header_section {\n  position: sticky;\n  z-index: 999;\n  top: 0;\n  padding-top: 15px;\n}\n\n.MyStoryFlowInfo,\n.PackagesInfoInnerImg,\n.activeEffect,\n.backbtn,\n.banner .bannerSlideCar,\n.bannerLeft,\n.btnFill,\n.btnStory,\n.headerGs,\n.header_section .navheader,\n.menuMain .menuMainInner a,\n.myaccount_main .account_bottom_info,\n.sharestorysec,\n.signUpInfo,\n.storyPageMain {\n  position: relative;\n}\n\n.header_section .navheader .navheaderBgImg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.header_section::before {\n  height: 165%;\n  position: absolute;\n}\n\n.headerGs p {\n  color: #f2dd4e;\n}\n\n.headerContact,\n.headerGs,\n.storynavigatemain .storynavigatemainInner img:hover {\n  cursor: pointer;\n}\n\n.PasswordUpdatedScreenMain .PasswordUpdatedBottom img,\n.downoadGuppyApp .downoadGuppyApp_right .barcode_inner .barcode_box img,\n.header_section .headerGb img,\n.header_section .headerGsNew img {\n  width: 200px;\n}\n\n.cardborder {\n  background-image: url(../../assets/images/cardborder.png);\n  height: 512px;\n  margin-left: 20%;\n}\n\n.cardborderthree {\n  position: absolute;\n  right: 22.9%;\n  bottom: 0;\n  background-size: contain;\n  width: 57%;\n  font-size: 32px;\n  height: 30%;\n  background-image: url(../../assets/images/singleline.png);\n}\n\n.cardborderfouth {\n  display: flex;\n  flex: 1;\n  background-color: #dffdff;\n  margin-top: 5px;\n  width: 99%;\n  height: 92%;\n  border-bottom-left-radius: 42px;\n  border-bottom-right-radius: 42px;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-left: 3px;\n}\n\n.headerGb p {\n  font-weight: 500;\n  font-size: 30px;\n  line-height: 39px;\n  color: #fff;\n}\n\n.banner .bannerRightText p,\n.storySection p,\n.storySectiontwo p {\n  font-size: 33px;\n  line-height: 43px;\n  text-align: center;\n  font-weight: 700;\n}\n\n.banner {\n  background: #d9eb41;\n  position: relative;\n  z-index: 0;\n  margin-top: -5px;\n}\n\n.banner .bannerRightText h1 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.banner .bannerRightText p {\n  color: var(--black);\n  margin-bottom: 35px;\n}\n\n.ContactBottom .btndiv,\n.MyStories .PackagesInfoInnerImg,\n.MyStories .StoryFlowInfoBtn,\n.PackagesMainGredient .PackagesInfoInnerImg,\n.banner .bannerRightText,\n.footerLeft,\n.menuMain .menuMainInner,\n.mobileFooter .mobilelink,\n.myaccount_main .logout,\n.signUpOtp,\n.socialIcon {\n  text-align: center;\n}\n\n.banner .bannerRightText span {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n}\n\n.banner .owl-dots {\n  position: absolute;\n  width: 100%;\n}\n\n.swiperNavBanner {\n  position: absolute;\n  top: 0;\n  right: 0;\n  align-items: center;\n}\n\n.swiperNavBannertwo {\n  position: absolute;\n  right: 0;\n  display: flex;\n  align-items: center;\n  z-index: 99;\n  width: 100%;\n}\n\n.cardPickSection .swiperNavBanner .page_num {\n  font-weight: 700;\n  font-size: 32px;\n  line-height: 42px;\n  text-align: center;\n  color: #000;\n}\n\n.swiperNavBanner button,\n.swiperNavBannertwo button,\n.swiperSection .swiperNav button {\n  border: 0;\n  background: 0 0;\n}\n\n.swiperNavBanner button img,\n.swiperNavBannertwo button img {\n  max-width: 92px;\n}\n\n.swiperNavBanner .swiperNext,\n.swiperNavBannertwo .swiperNext {\n  transform: rotate(180deg);\n}\n\n.bannerLeft img {\n  height: 100%;\n}\n\n.bannerSlideCar .owlSlideText {\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.bannerLeft .whtsNew {\n  position: absolute;\n  top: 20px;\n  right: -70px;\n}\n\n.bannerLeft .whtsNew img {\n  max-width: 200px;\n}\n\n.cardPickSection {\n  background-color: #f2dd4e;\n  padding: 160px 0 60px;\n  text-align: center;\n  position: relative;\n  z-index: 0;\n}\n\n.cardPickSection::before {\n  position: absolute;\n  top: 4%;\n  left: 0;\n  background-image: url(../../assets/images/blue-bg-1.png);\n  width: 230px;\n  height: 352px;\n}\n\n.cardPickSection .bgImageOverflow {\n  position: absolute;\n  bottom: 155px;\n  right: 0;\n  overflow: hidden;\n  z-index: -1;\n}\n\n.PasswordUpdatedScreenMain p.PasswordNewSuccesspara2,\n.cardPickSection .swiperSlide .img img {\n  margin-bottom: 20px;\n}\n\n.cardPickSection .swiper {\n  width: auto;\n  height: 500px;\n  position: relative;\n  overflow: hidden;\n}\n\n.cardPickSection .swiperSlide .swiperSlideActive {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.swiperSection .swiperNav .swiperNext {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.swiperSection .swiperNav .swiperNext img,\n.swiperSection .swiperNav .swiperPrev img {\n  width: 75px;\n}\n\n.swiperSection .swiperNav .swiperPrev {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.swiperSection .swiperNav {\n  position: absolute;\n  top: 32%;\n  width: 100%;\n  margin-top: -10px;\n}\n\n.cardPickSection .swiperSection {\n  position: relative;\n  margin: 35px 0 20px;\n}\n\n.swiper-3d .swiperSlideShadow {\n  width: auto;\n}\n\n.cardPickSection .muniaMiddleImg img {\n  position: absolute;\n  right: 54px;\n  top: 158px;\n  border-radius: 100%;\n}\n\n.cardPickSection .cardborderfouth {\n  font-weight: 700;\n  font-size: 48px;\n  text-align: center;\n  color: #000;\n}\n\n.storySection {\n  background: #56cdd5;\n  padding: 47px 0 60px;\n  text-align: center;\n  position: relative;\n  z-index: 0;\n}\n\n.storySection .dashedLine,\n.storySectiontwo .dashedLine {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n}\n\n.storySection .bgImageStoryNewLeft {\n  position: absolute;\n  top: 130px;\n  left: 0;\n}\n\n.storySection .bgImageOverflow,\n.storySectiontwo .bgImageOverflow {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  overflow: hidden;\n}\n\n.storySection .bgImageOverflow img,\n.storySectiontwo .bgImageOverflow img {\n  margin-bottom: -100px;\n}\n\n.storySection h2,\n.storySectiontwo h2 {\n  margin-bottom: 16px;\n}\n\n.storySection p,\n.storySectiontwo p {\n  margin-bottom: 25px;\n  color: #0d5268;\n}\n\n.storySection .btnStory,\n.storySectiontwo .btnStory {\n  margin-bottom: 45px;\n}\n\n.createStorySection,\n.storySectiontwo {\n  text-align: center;\n  position: relative;\n}\n\n.storySectiontwo .dashedLinebottom {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n\n.storySectiontwo .btnStory button {\n  margin-right: 17px;\n}\n\n.googleAdSection {\n  position: relative;\n  padding: 28px 0 31px;\n  border: 2.45px solid #000;\n}\n\n.googleAdSection span {\n  position: absolute;\n  top: 2px;\n  right: 14px;\n}\n\n.googleAdSection button {\n  position: absolute;\n  right: 14px;\n  bottom: 14px;\n  font-weight: 400;\n  font-size: 39px;\n  line-height: 46px;\n  text-align: center;\n  color: #fff;\n  border: 0;\n  background: #4285f4;\n  border-radius: 12px;\n  padding: 7px 23px;\n  font-family: Roboto, sans-serif;\n}\n\n.footerMid a,\n.footerMid p {\n  font-size: 24px;\n  line-height: 31px;\n}\n\n.footerMidLeft a,\n.footerMidLeft p {\n  font-size: 24px;\n  line-height: 31px;\n}\n\n.btsSection {\n  padding: 53px 0 62px;\n  background-color: var(--green);\n  position: relative;\n}\n\n.btsSection .dashedLine {\n  position: absolute;\n  bottom: 40%;\n  left: 0;\n  width: 100%;\n}\n\n.dashedLine img {\n  width: 100%;\n}\n\n.btsSection .btsSectionInfo {\n  margin-bottom: 70px;\n  width: 100%;\n  height: 400px;\n  position: relative;\n  background-image: url(../../assets/images/GuppyStoriesBehindTheScene.png);\n  background-size: contain;\n}\n\n.btsSection .btsSectionInfo button.btnUnfill {\n  border-image: url(../../assets/images/behind-the-scene.png);\n  border-image-repeat: stretch;\n  border-image-slice: 18;\n  border-image-width: 9px;\n  border-image-outset: inherit;\n  position: absolute;\n  bottom: 40px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  max-width: 600px;\n  padding: 11px 32px;\n  background-color: var(--green);\n}\n\n.btsSection .btsSectionInfo button {\n  padding: 20px 32px;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 62px;\n  text-align: center;\n  color: #0d5268;\n}\n\n.btsSection .theaterInfo .theaterLeftInfo h4 {\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 62px;\n  color: var(--black);\n  margin-bottom: 13px;\n  text-align: left;\n}\n\n.btsSection .theaterInfo .theaterLeftInfo p {\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 36px;\n  color: var(--black);\n}\n\n.btsSection .theaterInfo .storeIconRight span {\n  display: block;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  color: #000;\n  margin-bottom: 12px;\n}\n\n.btsSection .theaterInfo .storeIconRight a {\n  margin-bottom: 14px;\n  display: block;\n}\n\n.theaterInfo {\n  padding-top: 58px;\n}\n\nfooter {\n  background-color: var(--yellow);\n  padding: 52px 0 60px;\n}\n\n.footerLeft .socialIcon a {\n  margin: 0 9px;\n}\n\n.faqMain h4,\n.footerLeft .footerLogo img,\n.signUpInfo .rightInfo form .wrapdiv {\n  margin-bottom: 24px;\n}\n\n.footerMid a {\n  display: block;\n  font-weight: 600;\n  color: var(--black);\n  margin-bottom: 23px;\n}\n\n.footerMid {\n  padding-left: 85px;\n}\n\n.footerMid p {\n  font-weight: 700;\n  color: var(--black);\n  margin-bottom: 5px;\n}\n.centerImg {\n  width: 100%;\n  max-width: 100%;\n  object-fit: contain;\n}\n.footerMidLeft a {\n  display: block;\n  font-weight: 600;\n  color: var(--black);\n  margin-bottom: 23px;\n}\n\n.footerMidLeft {\n  padding-left: 85px;\n}\n\n.footerMidLeft p {\n  font-weight: 700;\n  color: var(--black);\n  margin-bottom: 15px;\n}\n\n.contactIcon a {\n  margin-right: 22px;\n  display: inline-block;\n  margin-bottom: 53px;\n}\n\n.footerRight h4 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  color: var(--black);\n  margin-bottom: 6px;\n  text-align: left;\n}\n\n.footerRight p {\n  margin-bottom: 30px;\n}\n\n.footerRight input {\n  padding: 13px 20px;\n  border: 0;\n}\n\n.footerRight input:focus,\n.footerRight input:focus-visible {\n  outline: 0;\n  border: 0;\n}\n\n.footerRight input::placeholder {\n  font-family: Kodchasan;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 23px;\n  color: var(--black);\n}\n\n.LoadingMainChild,\n.cardFooter .cardfooterName,\n.downoadGuppyApp .GuppyAppInner p,\n.menuMain .menuMainInner a,\n.myavtarsection .avtarBody h4 {\n  font-family: \"Cabin Sketch\", cursive;\n}\n\n.emailInput {\n  position: relative;\n  display: inline-block;\n  border: 1px solid #000;\n}\n\n.emailInput img {\n  background: var(--white);\n  border: 0;\n  width: 50px;\n  height: 50px;\n  margin-top: -3px;\n}\n\n.emailInput button img {\n  height: 53px;\n  border: 1px solid var(--black);\n  border-left: 0;\n  width: 50px;\n}\n\n.emailInput input:focus-visible {\n  outline: 0;\n}\n\n.mobileFooter h4 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #000;\n  margin-bottom: 7px;\n}\n\n.mobileFooter .mobilelink a {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #000;\n  margin: 0 8px;\n}\n\n.mobileFooter .footerMid {\n  padding-left: 0;\n}\n.mobileFooter .footerMidLeft {\n  padding-left: 0;\n}\n\n.mobileFooter .footerLeft p,\n.mobileFooter .footerMid p {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #000;\n  margin-bottom: 12px;\n}\n.mobileFooter .footerMidLeft p {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #000;\n  margin-bottom: 12px;\n}\n\n.mobileFooter .footerRight .emailInput {\n  display: block;\n  margin-bottom: 24px;\n}\n\n.mobileFooter .footerRight input {\n  width: 93%;\n}\n\n.mobileFooter .emailInput button {\n  right: 5px;\n}\n\n.PalacecomMain .PalacecomMainInner .PalacecomMainInnerinfo,\n.contactTopInfo .contactinfoMain,\n.mobileFooter .footerIconRow {\n  display: flex;\n  justify-content: space-between;\n}\n\n.mobileFooter .footerIconRow img {\n  max-width: 41px;\n}\n\n.mobileFooter .contactIcon a {\n  margin-right: 13px;\n}\n\n.mobileFooter .footerLeft .socialIcon a {\n  margin: 0 3px;\n}\n\n.navbarToggler {\n  background-color: transparent;\n  border: 0;\n  position: absolute;\n}\n\n.cardNew {\n  border: 4px solid #000;\n  border-radius: 40px;\n  max-width: 550px;\n  margin: auto;\n  overflow: hidden;\n}\n\n.cardFooter .cardfooterName {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 40px;\n  text-align: center;\n  color: #000;\n}\n\n.cardFooter {\n  background: #dffdff;\n  border-bottom-left-radius: 40px;\n  border-bottom-right-radius: 40px;\n  border-top: 6px solid #000;\n  padding: 12px 10px;\n}\n\n.cardHeader img {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.signUpBg {\n  background-color: #56cdd5;\n}\n\n.signUpInfo .leftInfo {\n  text-align: center;\n  padding-top: 95px;\n}\n\n.signUpInfo::after {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background-image: url(\"../../assets/images/vertical-dashed.png\");\n  width: 10px;\n  height: 436px;\n  left: 50%;\n}\n\n.ContactBottom::before,\n.myaccount_main .accountmain_top::before {\n  background-image: url(../../assets/images/dashed-line.png);\n  background-repeat: no-repeat;\n  height: 10%;\n  width: 100%;\n  content: \"\";\n}\n\n.signUpInfo .leftInfo img {\n  border-radius: 100%;\n}\n\n.signUpInfo .leftInfo h5 {\n  font-weight: 600;\n  font-size: 28px;\n  line-height: 36px;\n  color: #000;\n  margin-bottom: 0;\n}\n\n.signUpInfo .leftInfo p {\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 26px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 30px;\n}\n\n.signUpInfo .leftInfo .socialIcon,\n.storynavigatemain .storynavigatemainInner {\n  display: flex;\n  justify-content: center;\n}\n\n.signUpInfo .leftInfo .socialIcon img {\n  width: 83px;\n  border-radius: 0;\n  margin: 0 42px;\n}\n\nform label {\n  font-style: italic;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  display: block;\n  margin-bottom: 0;\n}\n\nform input {\n  background: #fff;\n  border-radius: 22px;\n  border: 3px solid #000;\n  width: 100%;\n  height: 67px;\n  padding: 0 15px;\n}\n\n.signUpInfo .rightInfo form .wrapdiv span {\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 27px;\n  color: #000;\n}\n\n.signUpInfo .rightInfo form .wrapdiv .checkboxdiv {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.signUpInfo .rightInfo form .wrapdiv span a {\n  text-decoration: underline;\n  color: #000;\n}\n\n.signUpInfo .rightInfo form .wrapdiv .checkboxdiv input[type=\"checkbox\"] {\n  max-width: 6%;\n  flex: 0 0 6%;\n}\n\n.signUpInfo .rightInfo form .wrapdiv .checkboxdiv span {\n  max-width: 93%;\n  flex: 0 0 93%;\n  font-family: Inter, sans-serif;\n}\n\n.signUpInfo .rightInfo form .wrapdiv .checkboxdiv button {\n  width: auto;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 18px;\n  color: #fff;\n  opacity: 0.5;\n  margin-top: 15px;\n}\n\n.signUpInfo .rightInfo form .btndiv {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.signUpInfo .rightInfo {\n  padding-left: 86px;\n}\n\n.arrowImgMain {\n  position: relative;\n  padding: 156px 0;\n  overflow: hidden;\n}\n\n.signLogRightLine {\n  position: absolute;\n  top: -60px;\n  right: -55px;\n}\n\n.signBgLeft {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n\n.loginBg {\n  background: #f2dd4e;\n}\n\n.loginBg .forgerPass {\n  margin: 25px 0 32px;\n}\n\n.loginBg .forgerPass a {\n  display: block;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  text-align: right;\n  color: #000;\n}\n\n.loginBg .againreg {\n  margin-top: 43px;\n  text-align: center;\n}\n\n.loginBg .againreg p {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  color: #000;\n  display: inline-block;\n}\n\n.loginBg .againreg a {\n  display: inline-block;\n  color: #000;\n  text-decoration: underline;\n}\n\n.TermsConditionsMain span,\n.faqMain span,\nform input,\nform textarea {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n}\n\n.myavtarsection {\n  padding: 57px 0;\n  background: #56cdd5;\n  text-align: center;\n}\n\n.backbtn a {\n  position: absolute;\n  left: 0;\n  top: 10px;\n}\n\n.backbtn img {\n  width: 85px;\n}\n\n.myavtarsection .avtarBody h4 {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 25px;\n}\n\n.myavtarsection .avtarBody .avtarMain {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.myavtarsection .avtarBody .avtarmainInfo {\n  flex: 0 0 30%;\n  max-width: 30%;\n  margin-top: 30px;\n}\n\n.myavtarsection .avtarBody .avtarmainInfo p {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  color: #000;\n  margin-top: 15px;\n}\n\n.myavtarsection .backbtn a {\n  left: 85px;\n}\n\n.ContactTop {\n  background: #56cdd5;\n  padding: 39px 0;\n}\n\n.ContactTop .contactTopInfo h4,\n.MyStoryFlowMain h4,\n.menuMain .menuMainInner .menuMainInnerImg {\n  margin-bottom: 37px;\n}\n\n.ContactTop .contactTopInfo p {\n  font-weight: 500;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 45px;\n}\n\n.contactTopInfo .contactinfoMain .mainInfo span {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  margin-bottom: 19px;\n  display: inline-block;\n}\n\n.contactTopInfo .contactinfoMain .mainInfo .socialIcon span {\n  text-decoration-line: underline;\n  font-weight: 500;\n  margin-bottom: 0;\n}\n\n.contactTopInfo .contactinfoMain .mainInfo .socialIcon {\n  text-align: left;\n  margin-bottom: 24px;\n}\n\n.PackagesMain h4,\n.contactTopInfo .contactinfoMain .mainInfo .socialIcon:nth-child(n) {\n  margin-bottom: 15px;\n}\n\n.contactTopInfo .contactinfoMain .mainInfo .socialIcon img {\n  margin-right: 32px;\n}\n\n.ContactBottom {\n  background: #d9eb41;\n  padding: 70px 0 45px;\n  position: relative;\n}\n\n.ContactBottom::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-size: contain;\n}\n\n.ContactBottom form label {\n  margin-bottom: 10px;\n}\n\n.contactSection .backbtn a {\n  left: 80px;\n}\n\n.ContactBottom form,\n.createStorySection .createStoryMid .createStoryMidInner,\n.edit_profile_section .profile_top form {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.ContactBottom form .wrapdiv {\n  margin-bottom: 20px;\n  flex: 0 0 48%;\n  max-width: 48%;\n}\n\n.ContactBottom form textarea {\n  background: #fff;\n  border-radius: 22px;\n  border: 3px solid #000;\n  width: 100%;\n  padding: 10px 15px;\n}\n\n.ContactBottom .btndiv,\n.ContactBottom form,\n.contactTopInfo {\n  margin: 0 95px;\n}\n\n.ContactBottom form .wrapdiv:last-child {\n  flex: 100%;\n  max-width: 100%;\n}\n\n.ContactBottom .btndiv button {\n  margin: 0 10px;\n}\n\n.ContactBottom .btndiv button.btnUnfill {\n  border-image-outset: 0 0 0 0;\n}\n\n.myaccount_main .accountmain_top::before {\n  position: absolute;\n  top: 80%;\n  left: 0;\n  background-size: cover;\n  z-index: -1;\n}\n\n.myaccount_main .accountmain_top {\n  position: relative;\n  background: #d9eb41;\n  padding-top: 15px;\n  z-index: 2;\n}\n\n.myaccount_main .account_bottom_main {\n  background: #d9eb41;\n  padding-top: 57px;\n  padding-bottom: 12px;\n  min-height: 100vh;\n  position: relative;\n  z-index: 0;\n}\n\n.myaccount_main .accountmain_top img {\n  width: 252px;\n  max-width: 20%;\n  flex: 0 0 20%;\n}\n\n.myaccount_main .accountmain_top span {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 31px;\n  color: #0d5268;\n  display: inline-block;\n  margin-left: 25px;\n  max-width: 75%;\n  flex: 0 0 75%;\n}\n\n.myaccount_main .accountmain_top span .Uid {\n  margin-left: 0;\n}\n\n.myaccount_main .accountmain_top span strong {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 62px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  display: block;\n}\n\n.myaccount_main .logout a {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #0d5268;\n  text-transform: uppercase;\n}\n\n.myaccount_main .account_bottom_info img {\n  position: absolute;\n  top: -35px;\n  left: -26px;\n}\n\n.myaccount_main .account_bottom_info a {\n  background: #0d5268;\n  display: flex;\n  height: 85px;\n  padding: 0 80px;\n  margin: 0 35px 57px;\n  align-items: center;\n  justify-content: center;\n  border-image: url(../../assets/images/MenuBorderImg.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 20px;\n  border-image-outset: 3px;\n  border-style: solid;\n}\n\n.myaccount_main .account_bottom_info span {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 36px;\n  text-align: center;\n  color: #d9eb41;\n}\n\n.edit_profile_section .profile_top .profile_top_img {\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.edit_profile_section .profile_top h4 {\n  margin-bottom: 19px;\n}\n\n.edit_profile_section .profile_top {\n  background: #56cdd5;\n  padding: 44px 0;\n}\n\n.edit_profile_section .profile_top form .profileInfo {\n  flex: 0 0 50%;\n  max-width: 50%;\n  padding-right: 56px;\n  margin-bottom: 11px;\n}\n\n.edit_profile_section .profile_top form .profileInfo label {\n  margin-bottom: 11px;\n}\n\n.edit_profile_section .profile_bottom {\n  background: #d9eb41;\n  padding: 75px 0 21px;\n  position: relative;\n  text-align: center;\n  min-height: 50vh;\n}\n\n.edit_profile_section .profile_bottom button {\n  margin-right: 18px;\n  width: 25%;\n}\n\n.edit_profile_section .profile_bottom button.btnUnfill {\n  border-image-outset: 2 0 8px 0;\n}\n\n.faqMain {\n  background: #d9eb41;\n  padding: 25px 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.faqMain::before {\n  content: \"\";\n  position: absolute;\n  top: 70px;\n  left: 20px;\n  background-image: url(../../assets/images/faq-bg.png);\n  background-repeat: no-repeat;\n  width: 164px;\n  height: 234px;\n  transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n}\n\n.FaqBottom_main .faqBottomimg,\n.backtotop img {\n  transform: rotate(90deg);\n}\n\n.faqMain p {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 22px;\n}\n\n.faqMain .faqTop span {\n  margin-bottom: 38px;\n  text-align: center;\n  display: block;\n}\n\n.faqMain .accordionTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.faqMain .accordionTitle span .accordianArrrow {\n  transform: rotate(-90deg);\n  cursor: pointer;\n}\n\n.faqMain .accordionItem {\n  background: #56cdd5;\n  border: 5px solid #000;\n  border-radius: 34px;\n  padding: 0 67px;\n  margin-bottom: 35px;\n}\n\n.faqMain .faqbgImg {\n  position: absolute;\n  right: 20px;\n  bottom: 0;\n}\n\n.faqMain .accordionContent span {\n  font-style: italic;\n  font-weight: 500;\n  display: block;\n  margin-bottom: 15px;\n}\n\n.faqMain .accordionContent a {\n  display: block;\n  text-align: center;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  margin-bottom: 15px;\n}\n\n.faqMain .accordionContent .accordianConImg {\n  background: #000;\n  height: 350px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.faqMain .accordionContent .accordianConImg .img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.downoadGuppyApp {\n  background: #d9eb41;\n  padding: 35px 0 50px;\n}\n\n.downoadGuppyApp .GuppyAppInner {\n  background: #0d5268;\n  text-align: center;\n  padding: 19px 0 30px;\n  height: 100%;\n}\n\n.downoadGuppyApp .GuppyAppInner p {\n  font-weight: 400;\n  font-size: 36px;\n  line-height: 42px;\n  text-align: center;\n  color: #d9eb41;\n  margin-bottom: 25px;\n}\n\n.downoadGuppyApp .downoadGuppyApp_right p {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  color: #000;\n  text-align: left;\n}\n\n.downoadGuppyApp .downoadGuppyApp_right span {\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 29px;\n  color: #000;\n  margin-bottom: 32px;\n  display: block;\n  text-align: left;\n}\n\n.downoadGuppyApp .downoadGuppyApp_right .barcode_inner p {\n  margin-bottom: 10px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 26px;\n  line-height: 34px;\n  color: #000;\n}\n\n.downoadGuppyApp .downoadGuppyApp_right {\n  text-align: center;\n  padding-left: 35px;\n}\n\n.downoadGuppyApp .downoadGuppyApp_left {\n  border: 3px solid #0d5268;\n  padding: 5px;\n}\n\n.menuMain {\n  background: #0d5268;\n  padding: 41px 0 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.menuMain::after {\n  content: \"\";\n  background-image: url(../../assets/images/record-bg.png);\n  position: absolute;\n  bottom: 10%;\n  left: 5;\n  width: 171px;\n  height: 137px;\n  z-index: -1;\n}\n\n.menuMain .menuMainHead h3 {\n  font-weight: 700;\n  font-size: 40px;\n  line-height: 52px;\n  color: #f2dd4e;\n  text-align: center;\n  margin-bottom: 16px;\n  display: inline-block;\n  border-image: url(../../assets/images/yellow-border-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-image-outset: 8px;\n  border-style: solid;\n  padding: 0 27px;\n}\n\n.menuMain .menuMainHead .menuMainhead_inner {\n  margin-top: 16px;\n  position: relative;\n  z-index: 2;\n}\n\n.menuMain .menuMainHead .menuMainhead_inner img {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.menuMain .menuMainHead .menuMainhead_inner span {\n  flex: 0 0 62%;\n  max-width: 62%;\n  text-align: left;\n}\n\n.menuMain a.logoutMenu {\n  display: block;\n  text-align: center;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  color: #f2dd4e;\n  margin-top: 15px;\n}\n\n.logoutMenuBottomNew {\n  margin-top: 30px;\n  text-align: center;\n  display: flex;\n  justify-content: space-around;\n}\n\n.logoutMenuBottomNew a.logoutMenuBottoma {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 18px;\n  color: #f2dd4e;\n}\n\n.menuMain .menuMainHead h3 img {\n  margin-left: 15px;\n}\n\n.menuMain .menuMainInner a {\n  display: inline-block;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  color: #000;\n  background: #d9eb41;\n  padding: 10px 65px;\n  margin-bottom: 27px;\n  border-image: url(../../assets/images/menunewyellowlight.png);\n  border-image-repeat: stretch;\n  border-image-slice: 10;\n  border-image-width: 15px;\n  border-style: solid;\n  border-image-outset: 1;\n}\n\n.menuMain .menuMainInner .menubtn a {\n  background: #56cdd5;\n  margin: 0 25px;\n  width: 35%;\n  padding: 10px 15px;\n  border-image: url(../../assets/images/mobilemenubtnLigthblueborder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 10;\n  border-image-width: 15px;\n  border-style: solid;\n  border-image-outset: 1;\n}\n\n.menuMain .menuMainInner .menubtn {\n  margin-bottom: 74px;\n}\n\n.menuMain .menuMainInner .menuMainInnerImg img {\n  margin: 0 13px;\n  max-width: 274px;\n}\n\n.menuMain .menuMainHead {\n  text-align: center;\n  z-index: 0;\n  position: relative;\n}\n\n.menuMain .menuMainHead span {\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 31px;\n  color: #f2dd4e;\n  margin-left: 25px;\n  display: inline-block;\n}\n\n.menuMain .menuMainHead span strong {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 62px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.MyStoryFlowInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 442px;\n  background: #d9eb41;\n  border-radius: 40px;\n  padding: 36px 18px 24px;\n  border-image: url(../../assets/images/StoryAdventureBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 16px;\n  border-image-outset: 1;\n  border-style: solid;\n}\n\n.StoryFlowTop:nth-child(2n) .MyStoryFlowInfo,\n.createStorySection .createStoryMid {\n  background: #f2dd4e;\n}\n\n.StoryFlowTop {\n  margin-bottom: 35px;\n}\n\n.MyStoryFlowMainExpand {\n  width: 70%;\n  margin: auto;\n  text-align: center;\n}\n\n.StoryFlowInfoBtn button {\n  position: relative;\n  padding: 0 80px;\n  margin-top: 70px;\n}\n\n.StoryFlowInfoBtn button img {\n  position: absolute;\n  left: -125px;\n  top: -80px;\n}\n\n.MyStoryFlowMain .StoryFlowTop:nth-child(2n),\n.MySubmissionInfoDraft .MySubmissiondetail:nth-child(2n),\n.leftalign {\n  text-align: -webkit-right;\n}\n\n.MyStoryFlowInfo .MyStoryFlowInner h5 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 51px;\n  color: #000;\n  text-align: left;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.MyStoryFlowInfo .MyStoryFlowInner p {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 34px;\n  color: #000;\n  text-align: left;\n}\n\n.MyStoryFlowMain {\n  background: url(../../assets/images/MyStoryFlows-bg.png) bottom/cover\n    no-repeat;\n  padding: 40px 0;\n}\n\n.StoryFlows_top .StoryFlowTop .MyStoryFlowInfo {\n  margin: auto;\n  padding: 24px 20px;\n}\n\n.StoryFlows .StoryFlows_top {\n  background: #56cdd5;\n  padding: 40px 0 20px;\n  position: relative;\n}\n\n.StoryFlows .StoryFlow_bottom {\n  background: #dffdff;\n  padding: 59px 0;\n  text-align: center;\n}\n\n.StoryFlows .StoryFlow_bottom .StoryFlowInfo p {\n  font-weight: 500;\n  font-size: 36px;\n  line-height: 50px;\n  color: #000;\n  margin-top: 25px;\n  text-align: left;\n}\n\n.StoryFlows .StoryFlow_bottom .StoryFlowInfo p:last-child {\n  line-height: 47px;\n  margin: 0 80px 25px;\n  font-style: italic;\n  text-align: center;\n}\n\n.StoryFlow_bottomBtn {\n  background: #56cdd5;\n  padding: 69px 0;\n  text-align: center;\n  position: relative;\n}\n\n.StoryFlow_bottomBtn::before,\n.StoryFlows .StoryFlows_top::before {\n  content: \"\";\n  left: 0;\n  top: 0;\n  position: absolute;\n  background: url(../../assets/images/badal-right.png) no-repeat;\n  width: 15%;\n  height: 86%;\n}\n\n.Storysharebtn a {\n  position: absolute;\n  top: 19%;\n  right: 18%;\n}\n\n.StoryFlows_top .MyStoryFlowInfo {\n  position: relative;\n  background: #d9eb41 !important;\n}\n\n.StoryFlows_top .MyStoryFlowInfoeditpencil {\n  content: \"\";\n  position: absolute;\n  top: -30px;\n  right: -35px;\n}\n\n.StoryFlows .StoryFlow_bgimg {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.StoryFlows .Viewfullstory a {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 23px;\n  color: #121212;\n}\n\n.StoryFlows .Viewfullstory {\n  text-align: right;\n  position: relative;\n}\n\n.StoryFlows .Viewfullstory img.storyTopImg {\n  position: absolute;\n  top: 10px;\n  left: 0;\n}\n\n.sharestorysecbg {\n  background: #eff7ff;\n  text-align: center;\n}\n\n.sharestorysecbg .sharestorysec button {\n  position: relative;\n  padding: 20px 60px;\n}\n\n.sharestorysecbg .sharestorysec button img {\n  position: absolute;\n  top: -85px;\n  left: -60px;\n}\n\n.sharestorysecbg .sharestorysec {\n  padding: 77px 0 50px;\n}\n\n.theEndImg {\n  text-align: center;\n  position: relative;\n  padding: 25px 0;\n}\n\n.backtotop,\n.storyPageMainBottom {\n  text-align: left;\n}\n\n.backtotop img {\n  width: 98px;\n}\n\n.ViewCardStory .mystoriesInnerInfo {\n  background: #d9eb41;\n  padding: 20px 10px;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 4px solid #1c2452;\n  border-radius: 5px;\n}\n\n.ViewCardStory .cardHeader img {\n  border-radius: 0;\n}\n\n.ViewCardStory .cardNew {\n  border: 4px solid #1c2452;\n  border-radius: 5px;\n}\n\n.ViewCardStory .cardNew .cardFooterNew .mystoriesInnerInfo h3 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  color: #000;\n}\n\n.ViewCardStory .cardNew .cardFooterNew .mystoriesInnerInfo p {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.activeEffect:focus-visible {\n  outline: 0;\n}\n\n@media (min-width: 768px) {\n  .activeEffect {\n    font-size: 36px;\n    line-height: 42px;\n  }\n  .btnFillRight {\n    margin-left: 50px;\n  }\n  .header_section .navheader .navheaderBgImg,\n  .mobileFooter {\n    display: none;\n  }\n  .ZidZagDesktopStory {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    overflow: hidden;\n  }\n}\n\n@media (max-width: 767px) {\n  .activeEffect {\n    font-size: 24px !important;\n    line-height: 28px !important;\n  }\n  .cardNew {\n    border: 3px solid #000;\n    border-radius: 20px;\n  }\n  .cardHeader {\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n  }\n  .cardFooter {\n    border-bottom-left-radius: 20px;\n    border-bottom-right-radius: 20px;\n  }\n  .ViewCardStory .cardHeader img {\n    width: 279px !important;\n    height: 176px !important;\n  }\n  .ViewCardStory .cardNew .cardFooterNew .mystoriesInnerInfo,\n  .menuMain .menuMainInner a {\n    padding: 10px;\n  }\n  .ViewCardStory .cardNew .cardFooterNew .mystoriesInnerInfo h3 {\n    font-size: 20px;\n    line-height: 26px;\n    margin-bottom: 0;\n  }\n  .ViewCardStory .swiperSection .swiperSectionInfo_inner {\n    margin-top: 55px !important;\n    height: 22em !important;\n    margin-bottom: 10px;\n  }\n  .ViewCardStory .cardNew {\n    width: 60%;\n    border: 3px solid #1c2452;\n  }\n  .ContactTop .contactTopInfo p br,\n  .StoryFlow_bottomBtn::before,\n  .StoryFlows .StoryFlow_bgimg,\n  .StoryFlows .StoryFlows_top::before,\n  .ZidZagDesktopStory,\n  .banner .bannerSlideCar .swiperNav,\n  .cardPickSection .bgImageOverflow img,\n  .cardPickSection:before,\n  .contactTopInfo .contactinfoMain .mainInfo:first-child span,\n  .dashedLine,\n  .desktopFooter,\n  .faqMain .faqbgImg,\n  .headerGb,\n  .headerGs,\n  .header_section::before,\n  .menuMain .backbtn,\n  .menuMain .menuMainHead .menuMainhead_inner::after,\n  .signUpInfo::after,\n  .storySection p,\n  .swiperNav,\n  .swiperNavBanner,\n  .theaterInfo {\n    display: none;\n  }\n  .MuniaMiddle {\n    width: 80px !important;\n  }\n  .edit_profile_section .profile_bottom {\n    padding: 45px 0 21px;\n  }\n  .edit_profile_section .profile_bottom button {\n    width: 40%;\n  }\n  .contactSection .backbtn a,\n  .menuMain::after {\n    left: 0;\n  }\n  .StoryFlows_top .MyStoryFlowInfoeditpencil {\n    top: 0;\n    right: 0;\n  }\n  .backtotop img {\n    width: 57px;\n  }\n  .Storysharebtn a {\n    right: 0;\n    bottom: 0;\n    top: auto;\n  }\n  .StoryFlows .StoryFlows_top .MyStoryFlowInfo {\n    padding: 15px 10px;\n    max-width: 195px;\n    position: initial;\n  }\n  .StoryFlowTop {\n    position: relative;\n  }\n  .StoryFlows .StoryFlows_top {\n    margin-bottom: 0;\n  }\n  .Storysharebtn a img {\n    width: 45px;\n  }\n  .StoryFlows_top .MyStoryFlowInfo::after {\n    top: 40px;\n    right: -51px;\n    background-size: contain;\n  }\n  .theEndImg {\n    padding: 15px 0;\n  }\n  .sharestorysecbg .sharestorysec {\n    padding: 25px 0 50px;\n  }\n  .sharestorysecbg .sharestorysec button img {\n    max-width: 77px;\n    top: -47px;\n    left: -25px;\n  }\n  .sharestorysecbg .sharestorysec button {\n    padding: 10px 35px;\n  }\n  .StoryFlow_bottomBtn {\n    padding: 25px 0;\n  }\n  .StoryFlows .Viewfullstory img.storyTopImg {\n    width: 26px;\n    height: 42px;\n  }\n  .StoryFlows .Viewfullstory a {\n    font-size: 14px;\n    line-height: 18px;\n  }\n  .StoryFlows .Viewfullstory a img {\n    width: 49px;\n  }\n  .StoryFlows .StoryFlow_bottom .StoryFlowInfo p {\n    font-size: 24px;\n    line-height: 34px;\n  }\n  .StoryFlows .StoryFlow_bottom .StoryFlowInfo p:last-child {\n    font-size: 24px;\n    line-height: 31px;\n    margin: 0 10px 20px;\n  }\n  .MyStoryFlowMain .backbtn a {\n    left: -12px;\n    top: -5px;\n  }\n  .MyStoryFlowInfo {\n    border-image-slice: 16;\n    border-image-width: 10px;\n    border-image-outset: 1;\n    max-width: 250px;\n    border-radius: 25px;\n    padding: 15px 10px;\n  }\n  .MyStoryFlowMainExpand {\n    width: 100%;\n  }\n  .MyStoryFlowMain {\n    background-position: right;\n  }\n  .StoryFlowInfoBtn button {\n    line-height: 26px;\n    padding: 0 55px;\n    margin-top: 25px;\n  }\n  .StoryFlowInfoBtn button img {\n    max-width: 115px;\n    left: -50px;\n    top: -42px;\n  }\n  .MyStoryFlowInfo .MyStoryFlowInner h5 {\n    font-size: 18px;\n    line-height: 28px;\n    width: 175px;\n  }\n  .MyStoryFlowInfo .MyStoryFlowInner p {\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .MyStoryFlowInfo img,\n  .backbtn img,\n  .faqMain .accordionTitle img,\n  .faqMain .faqBottom img {\n    max-width: 45px;\n  }\n  .menuMain .menuMainInner .menubtn a {\n    margin: 15px auto 0;\n    display: block;\n  }\n  .menuMain .menuMainInner .menubtn {\n    margin: 0 20px 59px;\n  }\n  .menuMain .menuMainInner a img {\n    max-width: 50px;\n  }\n  .menuMain a.logoutMenu {\n    text-align: center;\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .menuMain .menuMainInner {\n    margin-top: 32px;\n  }\n  .menuMain .menuMainInner .menuMainInnerImg img {\n    max-width: 175px;\n  }\n  .menuMain .menuMainHead h3 img {\n    max-width: 25px;\n  }\n  .menuMain .menuMainHead h3 {\n    font-size: 20px;\n    line-height: 26px;\n    padding: 0;\n  }\n  .contactTopInfo .contactinfoMain,\n  .menuMain .menuMainhead_inner span,\n  .menuMain .menuMainhead_inner strong,\n  .signUpInfo {\n    display: block;\n  }\n  .menuMain .menuMainhead_inner span {\n    margin-left: 14px;\n    font-size: 18px;\n    line-height: 23px;\n    vertical-align: middle;\n    display: inline-block;\n    text-align: left;\n  }\n  .menuMain .menuMainhead_inner span b {\n    font-weight: 400;\n    display: block;\n  }\n  .menuMain .menuMainhead_inner strong {\n    font-size: 36px !important;\n    line-height: 47px !important;\n  }\n  .menuMain .menuMainhead_inner img {\n    max-width: 97px;\n  }\n  .downoadGuppyApp {\n    margin-top: -25px;\n  }\n  .btnFill,\n  .btnUnfill {\n    margin: 0 5px;\n  }\n  .downoadGuppyApp .downoadGuppyApp_right {\n    padding-left: 15px;\n  }\n  .banner,\n  .banner .bannerRightText h1,\n  .banner .bannerRightText p,\n  .downoadGuppyApp .downoadGuppyApp_right p,\n  .downoadGuppyApp .downoadGuppyApp_right span {\n    text-align: center;\n  }\n  .faqMain .accordionContent .accordianConImg {\n    height: 150px;\n  }\n  .faqMain .faqBottom,\n  .faqMain .faqTop span,\n  .myaccount_main .logout a,\n  .myavtarsection .avtarBody .avtarmainInfo p {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .faqMain .accordionItem {\n    padding: 5px 18px;\n  }\n  .faqMain .accordionContent a,\n  .faqMain .accordionContent span {\n    font-size: 16px;\n    line-height: 21px;\n  }\n  .faqMain .accordionTitle span {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .ContactTop .contactTopInfo p,\n  .btnFill,\n  .faqMain p {\n    font-size: 24px;\n    line-height: 31px;\n  }\n  .myaccount_main .accountmain_top h4,\n  .myavtarsection .avtarBody h4,\n  h4 {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  .btsSection .btsSectionInfo {\n    margin-bottom: 0 !important;\n  }\n  .ViewCardStory .cardNew .cardFooterNew .mystoriesInnerInfo p {\n    display: block;\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .cardPickSection {\n    padding: 52px 0;\n  }\n  .btsSection .btsSectionInfo button {\n    font-size: 18px;\n    line-height: 23px;\n    max-width: 400px !important;\n  }\n  footer {\n    padding: 12px 0;\n  }\n  .btsSection {\n    padding: 18px 0;\n  }\n  .googleAdSection img {\n    max-width: 235px;\n    height: 47px;\n  }\n  .googleAdSection span a img {\n    height: auto;\n  }\n  .googleAdSection button {\n    font-size: 16px;\n    line-height: 19px;\n  }\n  h1 {\n    font-size: 40px;\n    line-height: 42px;\n  }\n  h2 {\n    font-size: 30px;\n    line-height: 32px;\n  }\n  .btnUnfill {\n    font-size: 24px;\n    line-height: 28px;\n  }\n  .cardPickSection .swiperSection {\n    margin-top: 9px;\n  }\n  .footerMid .contactIcon a {\n    margin-bottom: 20px;\n  }\n  .footerMidLeft .contactIcon a {\n    margin-bottom: 20px;\n  }\n  .storySection h2 {\n    font-size: 45px;\n    line-height: 46px;\n    margin-bottom: 27px;\n  }\n  .storySection .btnStory button.btnUnfill {\n    font-size: 24px;\n    line-height: 31px;\n    background-color: #0d5268;\n    color: #fff;\n    padding: 7px 35px;\n    border-image-outset: 8px 5px 8px;\n    margin: 0 12px;\n  }\n  .storySection {\n    padding: 24px 0;\n  }\n  .storySection:before {\n    top: auto;\n    width: 180px;\n    left: -94px;\n    height: 150px;\n    bottom: 0;\n  }\n  .storySection .bgImageOverflow img {\n    margin-bottom: 62px;\n    max-width: 70px;\n  }\n  .storySection .recordBg {\n    max-width: 177px;\n    margin: auto;\n    position: relative;\n    z-index: 0;\n  }\n  .cardPickSection .swiperSlide .img img {\n    max-width: 292px;\n  }\n  .banner .bannerRightText p {\n    font-size: 25px;\n    line-height: 28px;\n  }\n  .headerContact img,\n  .navbarTogglerIcon img {\n    max-width: 28px;\n  }\n  .signUpInfo .rightInfo {\n    padding: 15px 15px 0;\n  }\n  .signUpInfo .leftInfo {\n    padding-top: 0;\n    margin-bottom: 44px;\n    position: relative;\n  }\n  .signUpInfo .leftInfo::after {\n    content: \"\";\n    position: absolute;\n    background-image: url(../../assets/images/dashed-line.png);\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    margin-top: 15px;\n  }\n  .signBgLeft img,\n  .signLogRightLine img {\n    max-width: 119px;\n  }\n  .signBgLeft {\n    top: 8%;\n    left: -13px;\n    bottom: initial;\n  }\n  .signLogRightLine {\n    top: 5%;\n    right: -15px;\n  }\n  .arrowImgMain {\n    padding: 60px 0 15px;\n  }\n  .signUpInfo .rightInfo form input,\n  form input {\n    height: 53px;\n  }\n  .navheader {\n    padding: 0 0 8px;\n  }\n  .myavtarsection .avtarBody img {\n    max-width: 351px;\n  }\n  .avtarBody .avtarmainInfo img {\n    max-width: 157px;\n  }\n  .myavtarsection .avtarBody .avtarmainInfo {\n    flex: 0 0 45%;\n    max-width: 45%;\n  }\n  .myavtarsection {\n    margin-top: -25px;\n    padding: 20px 0;\n  }\n  .myaccount_main .accountmain_top {\n    background: #56cdd5;\n    padding-bottom: 17px;\n  }\n  .myaccount_main .accountmain_top img {\n    width: 97px;\n  }\n  .myaccount_main .accountmain_top span strong {\n    display: block;\n    font-size: 36px;\n    line-height: 47px;\n  }\n  .myaccount_main .accountmain_top span {\n    margin-left: 14px;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 23px;\n    vertical-align: middle;\n    display: block;\n    flex-wrap: wrap;\n    align-items: baseline;\n  }\n  .myaccount_main .accountmain_top span .Uid {\n    font-size: 12px;\n    line-height: 16px;\n    margin-left: 0;\n    display: inline-block;\n  }\n  .myaccount_main .accountmain_top::before {\n    top: 102%;\n  }\n  .myaccount_main .account_bottom_info span {\n    font-size: 26px;\n    line-height: 34px;\n  }\n  .myaccount_main .account_bottom_info a {\n    height: 75px;\n    margin: 0 35px 21px;\n  }\n  .myaccount_main .account_bottom_info:first-child img {\n    width: 100px;\n  }\n  .myaccount_main .account_bottom_info img {\n    top: -9px;\n    left: 20px;\n    width: 80px;\n  }\n  .myaccount_main .logout {\n    text-align: left;\n  }\n  .ContactBottom .btndiv,\n  .ContactBottom form,\n  .contactTopInfo {\n    margin: 0;\n  }\n  .ContactBottom form .wrapdiv {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .edit_profile_section .profile_top form .profileInfo {\n    flex: 0 0 100%;\n    max-width: 100%;\n    padding-right: 0;\n  }\n  .contactTopInfo .contactinfoMain .socialIcon span {\n    display: inline-block !important;\n    font-size: 18px;\n    line-height: 23px;\n    font-family: Kodchasan, sans-serif !important;\n  }\n  .contactTopInfo .contactinfoMain .socialIcon {\n    text-align: center !important;\n  }\n  .contactTopInfo .contactinfoMain .mainInfo span {\n    font-family: \"Cabin Sketch\", cursive;\n    display: block;\n    text-align: center;\n  }\n  .contactTopInfo .contactinfoMain .mainInfo .socialIcon img {\n    margin-right: 15px;\n    width: 45px;\n  }\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li,\n.storyBtn {\n  border-image: url(../../assets/images/StoryBorderCreate.png);\n}\n\n@media (max-width: 460px) {\n  .menuMain .menuMainInner a {\n    font-size: 25px;\n  }\n  .menuMain .menuMainInner .menuMainInnerImg img {\n    max-width: 100px;\n  }\n  .menuMain .menuMainhead_inner span {\n    font-size: 16px;\n  }\n  .menuMain .menuMainhead_inner img {\n    max-width: 100px !important;\n  }\n  .menuMain .menuMainhead_inner span strong {\n    font-size: 30px !important;\n    line-height: 30px !important;\n  }\n  .menuMain .menuMainHead h3 {\n    font-size: 18px;\n  }\n  .storySection .btnStory button.btnUnfill {\n    margin: auto 15px;\n    padding: 7px 25px;\n  }\n  .btsSection .btsSectionInfo button {\n    max-width: 88% !important;\n  }\n  .myavtarsection .avtarBody img {\n    max-width: 251px;\n  }\n  .avtarBody .avtarmainInfo img {\n    max-width: 130px;\n  }\n  .myaccount_main .account_bottom_info a {\n    height: 75px;\n    margin: 0 15px 21px;\n    padding: 0 20px;\n  }\n  .myaccount_main .account_bottom_info img {\n    top: -13px;\n    left: 5px;\n  }\n  .myaccount_main .accountmain_top span strong {\n    font-size: 30px;\n    line-height: 35px;\n  }\n  .myaccount_main .account_bottom_info span {\n    font-size: 24px;\n    line-height: 34px;\n    width: 75%;\n  }\n  .ContactBottom .btndiv button,\n  .edit_profile_section .profile_bottom button {\n    margin: 0 5px;\n  }\n  .ContactBottom .btndiv button {\n    width: 45%;\n    padding: 7px 25px !important;\n  }\n  .ContactBottom .btndiv button.btnUnfill {\n    border-image-outset: 5px 0 7px 0;\n  }\n}\n\n.PackagesMain {\n  padding: 37px 0;\n  background: #56cdd5;\n}\n\n.PackagesMainGredient {\n  padding: 37px 0 0;\n}\n\n.PackagesInfo {\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: 41px;\n  justify-content: space-between;\n}\n\n.PackagesInfo .PackagesInfoInner {\n  flex: 0 0 30%;\n  max-width: 30%;\n  margin-bottom: 10px;\n}\n\n.PackagesInfoInnerImg .arrowimgBottom {\n  position: absolute;\n  bottom: -15px;\n  right: -20px;\n}\n\n.PackagesMain .PackagesInfo .PackagesInfoInner p {\n  font-weight: 500;\n  padding-bottom: 0;\n  border: 0;\n  padding-top: 0;\n}\n\n.PackagesMain p {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  border-image: url(../../assets/images/border-bottom-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 0 0 5px 0;\n  border-image-outset: 0 0 6px 0;\n  border-style: solid;\n  width: 60%;\n  margin: auto;\n}\n\n.PackagesInfoInnerImg:hover {\n  font-weight: 700;\n}\n\n.PackagesMain_top .PackagesMain_topLeft,\n.TermsConditionsMain .BackToTop {\n  text-align: right;\n}\n\n.PackagesMainGredient .PackagesMain_top .PackagesMain_topLeft img {\n  width: 373px;\n}\n\n.PackagesMainGredient h4 {\n  margin-bottom: 49px;\n}\n\n.PackagesMain_top .PackagesMain_topRight h3 {\n  font-family: \"Cabin Sketch\", cursive;\n  font-weight: 700;\n  font-size: 64px;\n  line-height: 75px;\n  color: #000;\n  margin-bottom: 9px;\n  text-align: center;\n}\n\n.PackagesMain_top .PackagesMain_topRight p {\n  border: 0;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  color: #000;\n}\n\n.PackagesMainGredient .PackagesInfo,\n.signUpOtp .signUpInfo {\n  justify-content: center;\n}\n\n.PackagesMainGredient .PackagesMain_bottom {\n  background: #f2dd4e;\n  border: 6px solid #000;\n  border-radius: 57px;\n  margin-top: -70px;\n  margin-bottom: 39px;\n}\n\n.PackagesMainGredient .PackagesMain_bottom p {\n  padding-top: 74px;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  border: 0;\n}\n\n.PackagesMainGredient .PackagesMain_top {\n  align-items: center;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 40px;\n  align-items: center;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li {\n  padding: 22px 39px;\n  background: #56cdd5;\n  border-radius: 40px;\n  border-image-repeat: stretch;\n  border-image-slice: 22;\n  border-image-width: 23px;\n  border-image-outset: 5px;\n  border-style: solid;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li.active {\n  background: #0d5268;\n  position: relative;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li.active::before,\n.activeEffect::before {\n  content: \"\";\n  position: absolute;\n  left: -45px;\n  background: url(../../assets/images/ActiveLeft.png) 0 0 / contain no-repeat;\n  width: 31px;\n  height: 72px;\n  top: 0;\n}\n\n.activeEffect::before {\n  top: -6px;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li.active::after,\n.activeEffect::after {\n  content: \"\";\n  position: absolute;\n  right: -45px;\n  background: url(../../assets/images/ActiveRight.png) 0 0 / contain no-repeat;\n  width: 33px;\n  height: 74px;\n  top: 0;\n}\n\n.activeEffect::after {\n  top: -8px;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li.active span {\n  color: #fff;\n}\n\n.PackagesMainGredient .PackagesMain_nav ul li span {\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n}\n\n.PackagesMainGredient .pacakageNextcontent {\n  background: #56cdd5;\n  position: relative;\n  padding: 57px 0 38px;\n}\n\n.PackagesMainGredient .pacakageNextcontent::before {\n  content: \"\";\n  width: 100%;\n  height: 20%;\n  background: url(../../assets/images/dashed-line.png) 0 0 / contain no-repeat;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.PackagesMainGredient .pacakageNextcontent p {\n  font-weight: 500;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #1c2452;\n  padding: 39px 28px 150px;\n  width: 85%;\n  border-image: url(../../assets/images/dark-blue-border-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 16;\n  border-image-width: 15px;\n  border-image-outset: inherit;\n  border-style: solid;\n}\n\n.PackagesMainGredient .pacakageNextcontent .StoryFlowInfoBtn {\n  text-align: center;\n  margin-top: -126px;\n}\n\n.MyStories {\n  background: #56cdd5;\n  padding: 33px 0;\n  position: relative;\n}\n\n.MyStories .storybtn {\n  text-align: center;\n  margin-bottom: 41px;\n  margin-top: 25px;\n}\n\n.MyStories .mystoriesInner,\n.PalacecomMain {\n  margin-bottom: 28px;\n}\n\n.MyStories .storybtn .btnFill {\n  color: #56cdd5;\n  border-image-outset: 6px 6px 11px 6px;\n  border-image-slice: 16;\n  border-image-width: 10px;\n}\n\n.MyStories .storybtn .btnFill.btnFillLeft {\n  margin-right: 50px;\n  width: 240px;\n}\n\n.MyStories h3 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n}\n\n.MyStories p {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 20px;\n}\n\n.MyStories .mystoriesInner .mystoriesInnerInfo {\n  margin-top: -5px;\n  background: #d9eb41;\n  padding: 25px 39px;\n  text-align: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 4px solid #1c2452;\n  border-radius: 5px;\n}\n\n.MyStories .mystoriesInner .mystoriesInnerInfo h3 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  color: #000;\n  text-align: left;\n  margin-bottom: 0;\n}\n\n.MyStories .mystoriesInner .mystoriesInnerInfo p {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  text-align: left;\n  margin-bottom: 0;\n}\n\n.MyStories .mystoriesInner .mystoriesInnerInfo .mystoriesInnerRight {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.MyStories .mystoriesInner .mystoriesInnerInfo .mystoriesInnerRight img {\n  max-width: 98px;\n  height: auto;\n  margin-left: 50px;\n  border: 0;\n}\n\n.MyStories .mystoriesInner img {\n  width: 100%;\n  height: 366px;\n  border: 4px solid #1c2452;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n\n.sharebtnlink {\n  width: 168px;\n  padding: 15px 33px;\n  background: #0d5268;\n  border: 4px solid #000;\n  border-radius: 10px;\n  text-align: center;\n  position: relative;\n}\n\n.sharebtnlink .sharebtnimg {\n  position: absolute;\n  top: -4%;\n  right: -25%;\n}\n\n.sharebtnlink p {\n  font-weight: 700;\n  font-size: 30px;\n  line-height: 40px;\n  color: #fff;\n  margin-bottom: 22px;\n}\n\n.sharebtnlink img {\n  width: 70px;\n}\n\n.sharebtnlink a {\n  margin-bottom: 20px;\n  display: block;\n}\n\n.sharebtnlink span {\n  font-weight: 600;\n  font-size: 19px;\n  line-height: 25px;\n  color: #fff;\n}\n\n.MyStories .PackagesInfoInnerImg .arrowimgBottom {\n  bottom: 10px;\n  right: 25px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissionInfoInner h3 {\n  font-family: \"Roof runners active\";\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 41px;\n  text-align: center;\n  color: #0d5268;\n}\n\n.MySubmission\n  .MySubmissionInfo\n  .MySubmissiondetail_story\n  .MySubmissionInfoInner {\n  background-image: url(../../assets/images/mysub1.png);\n}\n\n.MySubmission\n  .MySubmissionInfo\n  .MySubmissiondetail_Ingredients\n  .MySubmissionInfoInner {\n  background-image: url(../../assets/images/mysub2.png);\n  height: 350px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissiondetail_publish .tick,\n.MySubmission .MySubmissionInfo .MySubmissiondetail_read .tick,\n.MySubmission .MySubmissionInfo .MySubmissiondetail_submit .tick {\n  position: absolute;\n  top: 0;\n  right: 15px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissiondetail_story .tick {\n  top: -10px;\n  right: -20px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissiondetail {\n  margin-top: -130px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissiondetail:first-child,\n.MySubmissionInfoDraft .MySubmissiondetail:first-child {\n  margin-top: 0;\n}\n\n.MySubmission .MySubmissionInfo {\n  margin: 0 200px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissionInfoInner h4 {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  color: #0d5268;\n}\n\n.MySubmission .MySubmissionInfo h4.MySubmissionInfo_publish {\n  color: #ed4c55;\n  border-image: url(../../assets/images/redborderImg.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 11px;\n  border-style: solid;\n  display: inline-block;\n  padding: 5px;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissionInfoInner {\n  background-repeat: no-repeat;\n  width: 340px;\n  height: 281px;\n  background-size: cover;\n  padding: 68px 0 0;\n  text-align: center;\n  display: block;\n  position: relative;\n}\n\n.MySubmission .MySubmissionInfo .MySubmissionInfoInner p {\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 23px;\n  color: #000;\n  margin-bottom: 30px;\n}\n\n.storynavigatemain .storynavigatemainInner img {\n  margin: 0 10px;\n  object-fit: contain;\n}\n\n.storynavigatemain {\n  text-align: center;\n  padding: 25px 0;\n}\n\n.storynavigatemain p {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: right;\n  color: #0d5268;\n}\n\n.MuniaMiddle {\n  position: fixed;\n  width: 120px;\n  height: 120px;\n  border-radius: 100px;\n  object-fit: contain;\n  bottom: 5%;\n  right: 10%;\n  z-index: 1;\n  cursor: pointer;\n}\n\n.storyPagecompMain img {\n  border-image: url(../../assets/images/borderNewMainStory.png);\n  border-image-repeat: stretch;\n  border-image-slice: 30;\n  border-image-width: 14px;\n  border-image-outset: 0;\n  border-style: solid;\n  height: 350px;\n  object-fit: contain;\n}\n\n.storyPagecompMain a img {\n  width: auto;\n  border: 0;\n  height: auto;\n}\n\n.storyPagecompMain a {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 50px;\n  color: #000;\n  display: inline-block;\n}\n\n.storyPagecompMain p {\n  font-weight: 500;\n  font-size: 28px;\n  line-height: 35px;\n  color: #000;\n  margin: 30px 0;\n  text-align: left;\n}\n\n.storyPageMain,\n.storyPageMainBottom {\n  background-color: #f5fef0;\n  text-align: center;\n  padding: 145px 0 0;\n}\n\n.storyPageMain .storyPAgeMainTitle {\n  font-weight: 700;\n  font-size: 50px;\n  line-height: 60px;\n  text-align: center;\n  font-family: \"Roof runners active\" !important;\n  color: #0d5268;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.storyPageMainMid {\n  background: #e4f2ff;\n  text-align: center;\n  padding: 65px 0 40px;\n  position: relative;\n  z-index: 0;\n}\n\n.storyPageMainMid p {\n  font-weight: 700;\n  font-size: 42px;\n  line-height: 55px;\n  text-align: center;\n  color: #000;\n}\n\n.storyPageMainMid span {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 40px;\n  text-align: center;\n  color: #000;\n}\n\n.storyPageMainMid .storyPageMidimg {\n  display: flex;\n  justify-content: center;\n  margin-top: 70px;\n}\n\n.storyPageMainMid .storyPageMidimg .storyimgInner img:last-child {\n  margin-top: -50px;\n}\n\n.storyPageMainBottom p {\n  margin-bottom: 43px;\n  font-weight: 500;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n}\n\n.storyPageMainMid .whereText span {\n  font-size: 30px;\n  line-height: 45px;\n  margin-top: -20px;\n}\n\n.PalacecomMain {\n  display: flex;\n  padding: 10px;\n  border-radius: 15px;\n  align-items: center;\n}\n\n.PalacecomMain h2 {\n  font-weight: 700;\n  font-size: 45px;\n  line-height: 53px;\n  color: #000;\n  margin-bottom: 45px;\n  text-align: left;\n}\n\n.PalacecomMain .PalacecomMainInner {\n  margin: 0 50px;\n}\n\n.ConfirmedBlueInner .ConfirmedBlueInnerInfo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ConfirmedBlueInner .ConfirmedBlueInnerInfo p {\n  text-align: left;\n  color: #0d5268;\n  margin-left: 15px;\n  font-weight: 600;\n}\n\n.ContactBottom .btndiv button.btnFill,\n.storyPageMain button {\n  padding: 0 25px;\n}\n\n.PasswordUpdatedScreenMain .PasswordUpdatedTop img,\n.banner,\n.menuMainHead .storySectiontwo .ZidZagDesktopStory,\n.menuMainHead .storySectiontwo .dashedLinebottom,\n.menuMainHead .storySectiontwo h2,\n.myaccount_main .storySectiontwo h2,\n.signUpOtp .signUpInfo::after,\n.storySectiontwo .bgImageStoryNewLeft,\n.storySectiontwo .dashedLine,\n.swiperNavBanner,\n.swiperNavtwo {\n  display: none;\n}\n\n@media (min-width: 768px) {\n  .PackagesMainGredient .PackagesMain_nav ul .PackagesMain_arrow,\n  .storySection .RedZigZagHomeStory {\n    display: none;\n  }\n  .myavtarsection {\n    margin-top: -15px;\n  }\n  .btsSection .btsSectionInfo {\n    border-image-slice: 21;\n    border-image-width: 12px;\n  }\n  .btsSection .btsSectionInfo button {\n    border-image-slice: 24 !important;\n    border-image-width: 18px !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .storyPagecompMain img {\n    height: auto;\n  }\n  .storyPageMain,\n  .storyPageMainBottom {\n    padding: 25px 0 0;\n  }\n  .signUpInfo .rightInfo .btndiv .btnFill {\n    width: 140px !important;\n    margin: 0 15px;\n  }\n  .storyPageMainMid .whereText span {\n    font-size: 18px;\n    line-height: 30px;\n    margin-top: -10px;\n  }\n  .MyStories h3,\n  .PackagesMain .PackagesInfo .PackagesInfoInner p,\n  .PackagesMainGredient .PackagesMain_nav ul li span,\n  .storyPageMainBottom p,\n  .storyPageMainMid p {\n    font-size: 24px;\n    line-height: 31px;\n  }\n  .PackagesMainGredient .PackagesMain_nav ul li {\n    border-image-slice: 22;\n    border-image-width: 17px;\n    border-image-outset: 4px;\n    border-radius: 27px;\n    padding: 5px 24px;\n    height: 60px;\n  }\n  .MyStories p br,\n  .MyStories::after,\n  .PackagesMainGredient .PackagesInfo .PackagesInfoInner:nth-child(4),\n  .PackagesMainGredient .PackagesInfo .PackagesInfoInner:nth-child(5),\n  .PackagesMainGredient .PackagesMain_nav ul li,\n  .PackagesMainGredient .PackagesMain_nav ul li.active::after,\n  .PackagesMainGredient .PackagesMain_nav ul li.active::before,\n  .PackagesMainGredient .PackagesMain_top .PackagesMain_topRight,\n  .PalacecomMain img,\n  .banner .bannerLeft .whtsNew img,\n  .faqMain .faqbgImg,\n  .faqMain::before {\n    display: none;\n  }\n  .activeEffect::before {\n    left: -30px;\n    background: url(../../assets/images/leftMobileActiveEffect.png);\n    width: 16px;\n    height: 36px;\n  }\n  .activeEffect::after {\n    right: -30px;\n    background: url(../../assets/images/rightMobileActiveEffect.png);\n    width: 17px;\n    height: 37px;\n  }\n  .MyStories .PackagesInfo .PackagesInfoInnerImg img {\n    width: 203px;\n  }\n  .storyPageMain button img {\n    width: 45px;\n  }\n  .storyPageMain p,\n  .storyPagecompMain a {\n    font-size: 24px;\n    line-height: 34px;\n  }\n  .storyPagecompMain a img {\n    width: 30px;\n  }\n  .storynavigatemain .storynavigatemainInner .active img {\n    width: 50px;\n  }\n  .PackagesInfo {\n    overflow: auto;\n    height: 100%;\n  }\n  .contactSection .mainInfo .mainInfoMobile {\n    display: flex;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n  }\n  .contactSection .mainInfo .mainInfoMobile .socialIcon img {\n    display: block;\n    margin: auto;\n  }\n  .contactSection .mainInfo .mainInfoMobile .socialIcon {\n    width: 50%;\n  }\n  .contactSection .mainInfo .mainInfoMobile .socialIcon:first-child {\n    order: 2;\n  }\n  .contactSection .mainInfo .mainInfoMobile .socialIcon:nth-child(2) {\n    order: 1;\n  }\n  .contactSection .mainInfo .mainInfoMobile .socialIcon:nth-child(3) {\n    order: 3;\n  }\n  .menuMain .menuMainInner a {\n    width: 70%;\n  }\n  .menuMain .menuMainInner .menubtn a {\n    width: 55%;\n  }\n  .storynavigatemain .storynavigatemainInner img {\n    width: 25px;\n  }\n  .PalacecomMain {\n    padding: 15px 10px;\n  }\n  .PalacecomMain .PalacecomMainInner {\n    margin: 0;\n  }\n  .PalacecomMain .PalacecomMainInner h2 {\n    font-size: 35px;\n    line-height: 35px;\n    margin-bottom: 35px;\n  }\n  .PalacecomMain .PalacecomMainInner .PalacecomMainInnerinfo img {\n    display: initial;\n  }\n  .storyPageMainBottom p strong {\n    display: block;\n  }\n  .storyPageMainMid .storyPageMidimg {\n    margin-top: 35px;\n  }\n  .MyStories,\n  .MyStoryFlowMain,\n  .PackagesMain,\n  .StoryFlows,\n  .contactSection,\n  .edit_profile_section,\n  .faqMain,\n  .loginBg,\n  .menuMain,\n  .myaccount_main,\n  .signUpBg,\n  .storyPageMain,\n  .storyPageMainMid .storyPageMidimg .storyimgInner img:last-child {\n    margin-top: -25px;\n  }\n  .storyPageMainMid .storyPageMidimg .storyimgInner img {\n    max-width: 125px;\n    display: block;\n  }\n  .storyPageMainMid::before {\n    width: 110px;\n    top: 50px;\n  }\n  .storyPageMainMid::after {\n    left: -129px;\n  }\n  .storyPageMainMid span {\n    font-size: 18px;\n    line-height: 30px;\n  }\n  .storyPageMain .storyPAgeMainTitle {\n    font-size: 28px;\n    line-height: 32px;\n  }\n  .MySubmission .MySubmissionInfo .MySubmissionInfoInner {\n    width: 305px;\n    height: 250px;\n    padding: 52px 0 0;\n  }\n  .MySubmission .MySubmissionInfo {\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n  .MySubmission .MySubmissionInfo .MySubmissiondetail:nth-child(2n),\n  .PackagesMainGredient .PackagesMain_top .PackagesMain_topLeft {\n    text-align: center;\n  }\n  .MySubmission .MySubmissionInfo .MySubmissiondetail {\n    margin-top: 0;\n    margin-bottom: 50px;\n  }\n  .MyStories .PackagesInfoInnerImg .arrowimgBottom {\n    bottom: 35px;\n    right: 22%;\n  }\n  .MyStories .PackagesInfoInner {\n    flex: 0 0 100% !important;\n    max-width: 100% !important;\n  }\n  .MyStories .storybtn button {\n    padding: 0 10px;\n  }\n  .MyStories .storybtn button.btnUnfill {\n    border-image-outset: 3 0 15px 0;\n  }\n  .MyStories .mystoriesInner .mystoriesInnerInfo {\n    padding: 10px;\n  }\n  .MyStories .mystoriesInner img {\n    height: 213px;\n  }\n  .MyStories .mystoriesInner .mystoriesInnerInfo .mystoriesInnerRight img {\n    max-width: 57px;\n    margin-left: 0;\n  }\n  .MyStories .mystoriesInner .mystoriesInnerInfo p {\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .MyStories .mystoriesInner .mystoriesInnerInfo h3 {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .MyStories p {\n    font-size: 24px;\n    line-height: 31px;\n    margin: 5px 0;\n  }\n  .MyStories::before {\n    background: url(../../assets/images/sign-up-right-img.png) no-repeat;\n    width: 26%;\n    height: 27%;\n    top: -90px;\n  }\n  .PackagesInfoInnerImg .arrowimgBottom {\n    right: -3px;\n    width: 57px;\n  }\n  .PackagesMainGredient .pacakageNextcontent p {\n    width: 100%;\n    padding: 25px 15px 65px;\n  }\n  .PackagesMainGredient .pacakageNextcontent .StoryFlowInfoBtn {\n    margin-top: -50px;\n  }\n  .PackagesMainGredient .PackagesMain_nav ul .PackagesMain_arrow,\n  .PackagesMainGredient .PackagesMain_nav ul li.active {\n    display: inherit;\n    padding: 13px 30px;\n    align-items: center;\n  }\n  .PackagesMainGredient\n    .PackagesMain_nav\n    ul\n    .PackagesMain_arrow:nth-child(odd) {\n    transform: rotate(180deg);\n  }\n  .PackagesMainGredient .PackagesMain_nav ul li a,\n  .PackagesMainGredient p {\n    font-size: 24px !important;\n    line-height: 31px !important;\n  }\n  .PackagesMainGredient .PackagesMain_nav ul .PackagesMain_arrow img {\n    width: 57px;\n  }\n  .PackagesMainGredient .PackagesMain_bottom {\n    margin-top: -60px;\n    background: url(../../assets/images/my-stories-mobile-bg.png) 0 0 / cover\n      no-repeat;\n    border: 0;\n  }\n  .PackagesMainGredient .PackagesInfo .PackagesInfoInner {\n    flex: 0 0 100%;\n    max-width: 100%;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  .PackagesInfo .PackagesInfoInner {\n    flex: 0 0 48%;\n    max-width: 48%;\n  }\n  .PackagesMain p {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .menuMain .menuMainhead_inner img {\n    max-width: 134px;\n  }\n  .MAinMEnudashedLineYellow {\n    margin-top: -60px !important;\n    z-index: -1;\n    position: relative;\n  }\n  .storyPageMainMid .imgafterstoryPageLeft {\n    width: 60px !important;\n    z-index: -1;\n  }\n  .storyPageMainMid .imgafterstoryPageRight {\n    width: 100px !important;\n  }\n  .myavtarsection .backbtn a {\n    left: 0;\n  }\n\n  .header_section .navheader .container-fluid .navbar .navbarBrand {\n    margin: auto !important;\n  }\n\n  .header_section .navheader .navbarBrand img {\n    width: 84px;\n    padding-bottom: 10px;\n  }\n  .banner {\n    margin-top: -20px;\n  }\n  .banner .banner_container {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .banner .bannerRightText {\n    margin: 25px auto;\n    max-width: 80%;\n  }\n  .cardPickSection .swiperSectionInfo_inner {\n    margin-left: 0 !important;\n    height: 25em !important;\n    display: flex;\n    justify-content: center;\n  }\n  .cardPickSection .swiperSectionInfo_inner .swiperSlide .cardNew {\n    max-width: 75%;\n  }\n  .cardPickSection .swiperSection {\n    margin-top: 15% !important;\n  }\n  .cardPickSection .swiperSectionInfo_inner .swiperSection_InfoDe {\n    max-width: 100%;\n  }\n  .PackagesMainGredient .PackagesInfo .PackagesInfoInner:nth-child(3) {\n    margin-bottom: 12%;\n  }\n  .PackagesMainGredient .PackagesMain_bottom p {\n    padding-top: 50px;\n  }\n  .PackagesMainGredient .pacakageNextcontent {\n    margin-top: -85px;\n  }\n  .PackagesMainGredient {\n    position: relative;\n  }\n  .PackagesMainGredient::before {\n    content: \"\";\n    background: url(../../assets/images/my-stories-mobile-bg-zig.png) no-repeat;\n    width: 111px;\n    height: 111px;\n    position: absolute;\n    top: 7%;\n    left: 0;\n  }\n  .PackagesMainGredient::after {\n    content: \"\";\n    background: url(../../assets/images/my-stories-mobile-bg-cir.png) no-repeat;\n    width: 48px;\n    height: 72px;\n    position: absolute;\n    top: 17%;\n    right: 0;\n  }\n  .PackagesMainGredient .PackagesMain_top .PackagesMain_topLeft img {\n    width: 285px;\n  }\n  .PackagesMainGredient\n    .PackagesInfo\n    .PackagesInfoInner\n    .PackagesInfoInnerImg\n    img {\n    width: 172px;\n  }\n}\n\n@media (max-width: 575px) {\n  .ViewCardStory .cardNew {\n    max-width: 285px;\n    width: 100%;\n  }\n  .menuMain .menuMainInner a {\n    width: 90%;\n  }\n  .menuMain .menuMainInner .menubtn a {\n    width: 82%;\n  }\n  .PalacecomMain .PalacecomMainInner .PalacecomMainInnerinfo {\n    display: block;\n  }\n  .PalacecomMain .PalacecomMainInner .PalacecomMainInnerinfo img {\n    margin-bottom: 50px;\n  }\n  .PalacecomMain .PalacecomMainInner .PalacecomMainInnerinfo button img {\n    margin-bottom: 0;\n  }\n  .cardPickSection\n    .swiperSectionInfo_inner\n    .swiperSlide\n    .cardNew\n    .cardFooter\n    .cardfooterName {\n    font-size: 26px;\n    line-height: 35px;\n  }\n  .cardPickSection .swiperSectionInfo_inner {\n    height: 17em !important;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .menuMain .menuMainHead .menuMainhead_inner span b {\n    display: block;\n  }\n  .myaccount_main .accountmain_top span .Uid {\n    display: inline-block;\n  }\n  .myaccount_main .accountmain_top::before {\n    top: 87%;\n  }\n  .MAinMEnudashedLineYellow {\n    margin-top: -90px !important;\n  }\n  .myaccount_main .account_bottom_info span {\n    font-size: 28px;\n    line-height: 34px;\n  }\n  .storyPageMainMid .imgafterstoryPageLeft {\n    width: 128px !important;\n  }\n  .storyPageMainMid .imgafterstoryPageRight {\n    width: 170px !important;\n  }\n  .btsSection .theaterInfo .theaterLeftInfo p br,\n  .contactSection .ContactTop .contactTopInfo p br,\n  .faqMain .faqTop span br,\n  .faqMain .faqbgImg,\n  .faqMain::before {\n    display: none;\n  }\n  .menuMain::after {\n    left: 0;\n  }\n  .menuMain .menuMainInner .menubtn a {\n    width: 41%;\n  }\n  .header_section .headerGb p,\n  .header_section .headerGs p {\n    font-size: 25px;\n    line-height: 40px;\n  }\n  .header_section .headerContact img,\n  .header_section .navbarTogglerIcon img {\n    width: 45px;\n  }\n  .header_section .headerGb img,\n  .header_section .headerGsNew img,\n  .header_section .navbarBrand img {\n    width: 130px;\n  }\n  h2 {\n    font-size: 38px;\n    line-height: 42px;\n  }\n  .swiperNavBanner button img {\n    max-width: 50px;\n  }\n  .swiperNavBannertwo button img {\n    max-width: 60px;\n  }\n  .cardPickSection .swiperNavBanner .page_num {\n    font-size: 24px;\n    line-height: 37px;\n  }\n  .cardPickSection .swiperSection .swiperNav button img {\n    max-width: 75px;\n  }\n  .cardPickSection .cardFooter .cardfooterName {\n    font-size: 40px;\n    line-height: 40px;\n  }\n  .cardPickSection .cardHeader img {\n    max-width: 400px;\n  }\n  .cardPickSection .swiperSection .swiperSectionInfo_inner {\n    height: 23em !important;\n  }\n  .cardPickSection::before {\n    left: -55px;\n  }\n  .cardPickSection .bgImageOverflow {\n    right: -120px;\n  }\n  .googleAdSection img {\n    max-width: 300px;\n  }\n  .googleAdSection button {\n    font-size: 27px;\n    line-height: 33px;\n  }\n  .desktopFooter .footerLeft .footerLogo img {\n    width: 280px;\n  }\n  .MyStories,\n  .MyStoryFlowMain,\n  .PackagesMain,\n  .StoryFlows,\n  .contactSection,\n  .edit_profile_section,\n  .faqMain,\n  .loginBg,\n  .menuMain,\n  .myaccount_main,\n  .signUpBg,\n  .storyPageMain {\n    margin-top: -15px;\n  }\n  .menuMain .menuMainHead span strong,\n  .myaccount_main .accountmain_top span strong {\n    font-size: 40px;\n  }\n  .menuMain .menuMainHead h3 {\n    font-size: 28px;\n    line-height: 35px;\n  }\n  .menuMain .menuMainHead h3 img {\n    width: 35px;\n  }\n  .backbtn img {\n    width: 60px;\n  }\n  .menuMain .menuMainhead_inner img,\n  .menuMainInner .menuMainInnerImg img,\n  .myaccount_main .accountmain_top img {\n    width: 200px;\n  }\n  .menuMain .menuMainInner a {\n    font-size: 31px;\n    line-height: 38px;\n  }\n  .myaccount_main .account_bottom_info img {\n    left: 5px;\n    width: 110px;\n  }\n  .faqMain p {\n    font-size: 30px;\n    line-height: 37px;\n  }\n  .faqMain .faqTop span {\n    font-size: 22px;\n    line-height: 29px;\n  }\n  .contactSection .ContactTop .contactTopInfo .contactinfoMain img {\n    margin-right: 15px;\n  }\n  .ContactBottom .btndiv,\n  .ContactBottom form,\n  .MySubmission .MySubmissionInfo,\n  .contactTopInfo {\n    margin: 0;\n  }\n  .MyStoryFlowMainExpand {\n    width: 85%;\n  }\n  .StoryFlows .StoryFlows_top .Storysharebtn a {\n    right: 7%;\n    width: 100px;\n    z-index: 1;\n  }\n  .PackagesInfoInnerImg .arrowimgBottom {\n    width: 70px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n  .myaccount_main .accountmain_top::before {\n    top: 85%;\n  }\n  .storynavigatemain .storynavigatemainInner img {\n    max-width: fit-content;\n    margin: 0;\n  }\n  .desktopFooter .footerLeft,\n  .desktopFooter .footerMidLeft,\n  .desktopFooter .footerMid,\n  .desktopFooter .footerRight {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .desktopFooter .footerLeft {\n    text-align: left;\n  }\n  .desktopFooter .socialIcon {\n    text-align: center;\n    width: 280px;\n  }\n  .PackagesMainGredient .PackagesMain_top .PackagesMain_topLeft {\n    text-align: center;\n  }\n  .PackagesMainGredient .PackagesMain_nav ul li a {\n    font-size: 26px;\n    line-height: 30px;\n  }\n  .PackagesMainGredient .PackagesMain_nav ul li {\n    padding: 18px;\n  }\n  .PackagesMainGredient .PackagesMain_bottom p br {\n    display: none;\n  }\n  .PackagesMainGredient .PackagesMain_bottom p {\n    font-size: 28px;\n    line-height: 35px;\n  }\n  .PackagesMainGredient\n    .PackagesInfo\n    .PackagesInfoInner\n    .PackagesInfoInnerImg\n    img {\n    width: 182px;\n  }\n}\n\n.MySubmissionInfoDraft {\n  margin: 0 180px;\n}\n\n.MySubmissionInfoDraft .MySubmissionInfoInner span {\n  display: block;\n  margin-top: 40%;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 18px;\n  color: #0d5268;\n}\n\n.MySubmissionInfoDraft .MySubmissiondetail {\n  margin-top: -70px;\n}\n\n.MySubmissionInfoDraft\n  .MySubmissiondetail:nth-child(2n)\n  .MySubmissionInfoInner {\n  background-image: url(../../assets/images/MySubmissionInfoDraftblue.png);\n  height: 337px;\n}\n\n.MySubmissionInfoDraft\n  .MySubmissiondetail:nth-child(2n)\n  .MySubmissionInfoInner\n  h2 {\n  background: #d9eb41;\n  top: 30px;\n  left: 60px;\n}\n\n.MySubmissionInfoDraft .MySubmissionInfoInner {\n  background-repeat: no-repeat;\n  width: 340px;\n  height: 281px;\n  background-size: cover;\n  padding: 68px 0 0;\n  text-align: center;\n  display: block;\n  position: relative;\n  background-image: url(../../assets/images/MySubmissionInfoDraftyellow.png);\n}\n\n.MySubmissionInfoDraft .MySubmissionInfoInner h2 {\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  color: #000;\n  border-image: url(../../assets/images/submissionDraftCircle.png);\n  border-style: solid;\n  border-image-repeat: stretch;\n  border-image-slice: 12;\n  border-image-width: 11px;\n  border-image-outset: 0;\n  padding: 0 15px;\n  background: #56cdd5;\n  border-radius: 100%;\n}\n\n.MySubmissionInfoDraft .progressdivsubmission {\n  transform: rotate(-1.82deg);\n  background-image: url(../../assets/images/submission-red-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: absolute;\n  top: 23%;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.MySubmissionInfoDraft .progressdivsubmission p {\n  font-weight: 700 !important;\n  font-size: 30px !important;\n  line-height: 36px !important;\n  text-align: center !important;\n  color: #fff !important;\n  transform: rotate(8.18deg);\n  margin-bottom: 0 !important;\n  padding: 45px 0;\n}\n\n.MySubmissionInfoDraft .MySubmissiondetail .EditInfoSubmission {\n  position: absolute;\n  top: -20px;\n  right: -57px;\n}\n\n.MySubmissionInfoDraft .MySubmissiondetail:nth-child(2n) .EditInfoSubmission {\n  top: 20px;\n  right: 10px;\n}\n\n.cardPickSection .swiperSectionInfo_inner .swiperSection_InfoDe:nth-child(2n) {\n  rotate: 10deg !important;\n}\n\n.cardPickSection .swiperSectionInfo_inner .swiperSection_InfoDe:nth-child(odd) {\n  rotate: -10deg !important;\n}\n\n.cardPickSection .swiperSectionInfo_inner .swiperSection_InfoDe:last-child {\n  rotate: 0deg !important;\n}\n\n.cardPickSection\n  .swiperSectionInfo_inner\n  .swiperSection_InfoDe\n  .swiperSlide\n  .cardHeader\n  img {\n  width: 400px;\n  height: 255px;\n}\n\n.birdTopText {\n  position: fixed;\n  bottom: 5%;\n  right: 10%;\n  z-index: 105;\n  border-radius: 100%;\n  overflow: hidden;\n  border-color: transparent;\n}\n\n.birdTopText img.MuniaMiddle {\n  position: static;\n}\n\n.birdTopText span {\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  z-index: 100;\n  top: -5px;\n  width: 120px;\n  padding: 5px 0;\n  text-align: center;\n  cursor: pointer;\n}\n\n.PickStoryHome p,\n.storyBtn {\n  font-size: 48px;\n  line-height: 62px;\n}\n\n.createStorySection .createStoryTop {\n  background: #56cdd5;\n  position: relative;\n  padding-top: 40px;\n}\n\n.createStorySection .createStoryTop::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: url(../../assets/images/YellowZigZagRight.png) no-repeat;\n  width: 235px;\n  height: 308px;\n}\n\n.createStorySection .createStoryTop::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  background: url(../../assets/images/YellowZigZagLeft.png) no-repeat;\n  width: 223px;\n  height: 254px;\n}\n\n.createStorySection .createStorySwiperInfo .swiperNav button {\n  background: 0 0;\n  border: 0;\n}\n\n.createStorySection .createStorySwiperInfo {\n  position: relative;\n  z-index: 0;\n  margin: 50px 0;\n}\n\n.createStorySection .createStorySwiperInfo .swiperNav {\n  display: flex;\n  justify-content: space-between;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  bottom: 0;\n  align-items: center;\n}\n\n.createStorySection .moreStory {\n  display: flex;\n  justify-content: center;\n  padding: 85px 0;\n  align-items: center;\n}\n\n.createStorySection .moreStory .moreStoryInner {\n  position: relative;\n  display: inline-block;\n  margin: 0 15px;\n}\n\n.createStorySection .moreStory .moreStoryInner img.RedCross {\n  position: absolute;\n  left: -10px;\n  top: -4px;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomShare span {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  display: block;\n  text-align: left;\n  margin-bottom: 5px;\n  margin-left: 10px;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomShare img {\n  margin-right: 24px;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomShare {\n  width: 50%;\n  margin: auto;\n}\n\n.footerMidLeft {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n@media (max-width: 992px) {\n  .qrdiv {\n    width: 50%;\n  }\n  .footerMidLeft {\n    align-items: flex-start;\n    padding-left: 0px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .qrdiv {\n    width: 80%;\n  }\n}\n\n.createStorySection .createStoryBottom {\n  background-color: #56cdd5;\n  padding: 50px 0;\n  position: relative;\n}\n\n.createStorySection .createStoryBottom::before {\n  content: \"\";\n  background: url(../../assets/images/YellowStoryBottomBgLeft.png) no-repeat;\n  width: 253px;\n  height: 389px;\n  top: 100px;\n  left: 0;\n  position: absolute;\n}\n\n.createStorySection .createStoryBottom::after {\n  content: \"\";\n  background: url(../../assets/images/YellowStoryBottomBgRight.png) no-repeat;\n  width: 260px;\n  height: 297px;\n  bottom: 0;\n  right: 0;\n  position: absolute;\n}\n\n.storyBtn {\n  font-weight: 600;\n  text-align: center;\n  color: #000;\n  padding: 12px 30px !important;\n  background: #56cdd5;\n  border-image-repeat: stretch;\n  border-image-slice: 22;\n  border-image-width: 23px;\n  border-image-outset: 5px;\n  border-radius: 40px;\n  border-style: solid;\n}\n\n.createStorySection .createStoryMid .createStoryMidInner .createMidInnerInfo {\n  flex: 0 0 48%;\n  max-width: 48%;\n}\n\n.createStorySection .createStoryMid .createMidInnerInfo button {\n  margin-bottom: 40px;\n  padding: 8px 15px;\n}\n\n.createStorySection .createStoryMid .createMidInnerInfo .findIngredients img {\n  margin-top: -15px;\n  transition: transform 0.7s ease-in-out;\n}\n\n.createStorySection\n  .createStoryMid\n  .createMidInnerInfo\n  .findIngredients\n  img:hover {\n  transform: rotate(360deg);\n  cursor: pointer;\n}\n\n.createStorySection .createStoryMid .createMidInnerInfo p {\n  color: #000;\n  margin-bottom: 25px;\n  font-style: italic;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  text-align: center;\n}\n\n.createStorySection .createStoryMid .createMidInnerInfo span {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  margin: 30px 0;\n  display: block;\n}\n\n.createStorySection .createStoryMid .createMidInnerInfo {\n  margin: 26px 0;\n  position: relative;\n}\n\n.createStorySection .createStoryMid .createMidInnerInfo:first-child:after,\n.createStorySection .createStoryMid .createMidInnerInfo:nth-child(2):after {\n  content: \"\";\n  position: absolute;\n  bottom: -20px;\n  left: 0;\n  background: url(../../assets/images/dashed-line.png) no-repeat;\n  width: 100%;\n  height: 3%;\n}\n\n.createStorySection .createStoryBottom p {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 71px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 0;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomBtn,\n.menuMainHead .storySectiontwo {\n  margin: 50px 0;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomBtn button.btnFill {\n  padding: 6px 25px;\n  border-image-outset: 6px 6px 12px 7px;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomBtn button.btnUnfill {\n  padding: 11px 80px 4px;\n}\n\n.createStorySection .createStoryBottom .createStoryBottomBtn button {\n  margin: 0 25px;\n}\n\n.createStorySection .createStoryBottom .dashedLine img {\n  margin-top: -100px;\n}\n\n.createStorySection .createStoryTop p {\n  font-style: italic;\n  font-weight: 600;\n  font-size: 36px;\n  line-height: 46px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 36px;\n}\n\n.createStorySection .createStoryTopMaintext p {\n  font-weight: 400;\n  font-size: 36px;\n  line-height: 54px;\n  text-align: center;\n  color: #000;\n  font-style: normal;\n  margin: 15px 0 70px;\n}\n\n.createStorySection .createStoryTop .cardFooter {\n  background: url(../../assets/images/createAnewStoryYellowBG.png) 0 0 / cover\n    no-repeat;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  border-top: 0;\n  padding: 12px 0;\n  position: absolute;\n  bottom: -15px;\n  width: 100%;\n  height: 120px;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n}\n\n.createStorySection .createStoryTop .cardHeader img {\n  border-radius: 13px;\n  width: 410px;\n  height: 380px;\n  border-image: url(../../assets/images/createStoryTOpBgline.png);\n  border-image-repeat: stretch;\n  border-image-slice: 30;\n  border-image-width: 30px;\n  border-image-outset: 0;\n  border-style: solid;\n  border-radius: 35px;\n}\n\n.createStorySection .cardFooter .cardfooterName {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  text-align: center;\n  color: #000;\n  font-family: Kodchasan, sans-serif;\n  display: block;\n  margin-top: 35px;\n}\n\n.createStorySection .cardNew {\n  max-width: 410px;\n}\n\n.celebrationBox .celebrationBoxInner p {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 42px;\n  color: #0d5268;\n  padding-top: 50px;\n}\n\n.celebrationBox .celebrationBoxBtn img {\n  position: absolute;\n  top: -42px;\n  left: -55px;\n  width: 175px;\n}\n\n.celebrationBox .celebrationBoxBtn a {\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 39px;\n  text-align: center;\n  color: #fff;\n  background: #0d5268;\n  display: flex;\n  padding: 12px 35px;\n  align-items: center;\n  justify-content: center;\n  width: 42%;\n  margin: auto;\n  position: relative;\n  border-image: url(../../assets/images/celebrationBorder.png);\n  border-image-repeat: stretch;\n  border-image-slice: 22;\n  border-image-width: 23px;\n  border-image-outset: 15px 10px 12px;\n  border-style: solid;\n}\n\n.celebrationBox .celebrationBoxBtn {\n  padding-bottom: 40px;\n  padding-top: 40px;\n}\n\n.createStorySection .createStorySwiperInfo .swiperSectionInfo_inner {\n  margin: auto !important;\n  display: flex;\n  justify-content: center;\n}\n\n.createStorySection .moreStoryInner .moreStoryInnerMainNew {\n  object-fit: cover;\n  border-radius: 20px !important;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .MySubmissionInfoDraft {\n    margin: 0;\n  }\n  .MyStories::after,\n  .MyStories::before,\n  .MySubmission::after,\n  .MySubmission::before,\n  .createStorySection .createStoryBottom::after,\n  .createStorySection .createStoryBottom::before,\n  .createStorySection .createStoryTop::after,\n  .createStorySection .createStoryTop::before {\n    display: none;\n  }\n  .celebrationBox .celebrationBoxInner p {\n    font-size: 30px;\n    line-height: 40px;\n  }\n  .celebrationBox .celebrationBoxBtn a {\n    width: 60%;\n  }\n  .createStorySection .createStoryBottom .createStoryBottomShare {\n    width: 100%;\n    margin: auto;\n    text-align: center;\n  }\n  .createStorySection .createStoryBottom .createStoryBottomShare span {\n    text-align: center;\n    margin-left: 0;\n  }\n  .createStorySection .createStoryBottom .createStoryBottomBtn button {\n    margin: 0 12px;\n  }\n  .createStorySection .createStoryBottom p {\n    font-size: 35px;\n    line-height: 45px;\n  }\n  .createStorySection .createStoryMid .createMidInnerInfo .findIngredients img {\n    width: 60px;\n  }\n  .createStorySection .createStoryTop {\n    margin-top: -15px;\n  }\n  .createStorySection .moreStory .moreStoryInner img.RedCross {\n    width: 50px;\n    height: 50px;\n  }\n  .createStorySection .createStoryMid .createMidInnerInfo button {\n    margin-bottom: 40px;\n    padding: 2px 10px;\n    font-size: 30px;\n  }\n  .PickStoryHome p {\n    font-size: 40px;\n    line-height: 56px;\n  }\n  .storySection .bgImageStoryNewLeft img {\n    width: 150px;\n  }\n}\n\n@media (max-width: 767px) {\n  .ContactTop {\n    position: relative;\n  }\n  .ContactTop::before {\n    content: \"\";\n    position: absolute;\n    bottom: 45%;\n    left: 0;\n    background-image: url(../../assets/images/dashed-line.png);\n    background-repeat: no-repeat;\n    width: 100%;\n    height: 2%;\n    background-size: contain;\n  }\n  .contactTopInfo .contactinfoMain .mainInfo span {\n    margin-top: 50px;\n  }\n  .MySubmissionInfoDraft .MySubmissiondetail,\n  .contactTopInfo .contactinfoMain .mainInfo .socialIcon span {\n    margin-top: 0;\n  }\n  .MySubmissionInfoDraft {\n    margin: 0;\n  }\n  .MySubmissionInfoDraft .MySubmissionInfoInner .progressdivsubmission p {\n    font-size: 24px !important;\n    line-height: 18px !important;\n    padding: 63px 0 !important;\n  }\n  .MySubmissionInfoDraft .MySubmissionInfoInner h2 {\n    font-size: 24px;\n    line-height: 28px;\n    padding: 0 9px;\n    border-image-slice: 10;\n    border-image-width: 7px;\n    top: 12px;\n    left: 20px;\n  }\n  .MySubmissionInfoDraft .MySubmissionInfoInner .EditInfoSubmission {\n    width: 70px;\n    top: 0;\n    right: -13px;\n  }\n  .MySubmissionInfoDraft\n    .MySubmissiondetail:nth-child(2n)\n    .MySubmissionInfoInner\n    .EditInfoSubmission {\n    top: 25px;\n    right: 45px;\n  }\n  .MySubmissionInfoDraft .MySubmissionInfoInner {\n    margin: auto;\n  }\n  .MySubmissionInfoDraft\n    .MySubmissiondetail:nth-child(2n)\n    .MySubmissionInfoInner\n    h2 {\n    top: 40px;\n  }\n  .createStorySection .moreStoryInner .moreStoryInnerMainNew {\n    width: 230px !important;\n    height: 155px !important;\n    object-fit: cover;\n    border-radius: 20px !important;\n  }\n  .swiperNavtwo {\n    display: flex;\n    position: absolute;\n    width: 100%;\n    bottom: 40%;\n    z-index: 999;\n    justify-content: space-between;\n  }\n  .swiperNavtwo .swiperNext,\n  .swiperNavtwo .swiperPrev {\n    background-color: #0000;\n    outline: 0;\n    border: none;\n    width: 20%;\n  }\n  .createStorySection .createStorySwiperInfo {\n    margin: 30px 0 50px;\n  }\n  .createStorySection .newparaCreateastory {\n    font-size: 20px !important;\n    line-height: 30px !important;\n    padding-bottom: 20px !important;\n  }\n  .createStorySection .cardFooter .cardfooterName {\n    font-size: 24px;\n    line-height: 31px;\n  }\n  .createStorySection .createStoryTop .cardHeader img {\n    width: 270px;\n    height: auto;\n  }\n  .celebrationBox .celebrationBoxBtn img {\n    width: 117px;\n  }\n  .celebrationBoxInner {\n    text-align: center;\n  }\n  .celebrationBox .celebrationBoxInner p {\n    font-size: 22px;\n    line-height: 26px;\n    padding-top: 20px;\n  }\n  .celebrationBox .celebrationBoxBtn a {\n    font-size: 24px;\n    line-height: 26px;\n    padding: 5px 35px;\n    width: 70%;\n  }\n  .celebrationBox {\n    padding: 12px 0;\n  }\n  .celebrationBox .celebrationBoxInner img {\n    width: 141px !important;\n  }\n  .createStorySection .createStoryBottom p {\n    font-size: 24px;\n    line-height: 32px;\n  }\n  .createStorySection .createStoryMid .createMidInnerInfo:after {\n    content: \"\";\n    position: absolute;\n    bottom: -20px;\n    left: 0;\n    background: url(../../assets/images/dashed-line.png) no-repeat;\n    width: 100%;\n    height: 3%;\n  }\n  .createStorySection .createStoryBottom .createStoryBottomBtn button.btnUnfill,\n  .createStorySection .createStoryBottom .createStoryBottomShare,\n  .createStorySection .createStoryBottom::after,\n  .createStorySection .createStoryBottom::before,\n  .createStorySection .createStoryMid .createMidInnerInfo:last-child::after,\n  .createStorySection .createStorySwiperInfo .swiperNav,\n  .createStorySection .createStoryTop::after,\n  .createStorySection .createStoryTop::before {\n    display: none;\n  }\n  .createStorySection .createStoryMid .createStoryMidInner .createMidInnerInfo {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .createStorySection .createStoryTop {\n    margin-top: -25px;\n  }\n  .createStorySection .createStorySwiperInfo .swiperSectionInfo_inner {\n    margin: auto !important;\n    height: 19em !important;\n  }\n  .createStorySection .moreStory {\n    padding: 30px 0;\n  }\n  .createStorySection .createStoryTop p {\n    font-size: 24px;\n    line-height: 30px;\n    padding-bottom: 25px;\n    margin-bottom: 0;\n  }\n  .createStorySection .createStoryBottom .createStoryBottomBtn {\n    margin: 50px 0 0;\n  }\n  .createStorySection .createStoryMid .createMidInnerInfo p {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .createStorySection\n    .createStoryMid\n    .createMidInnerInfo\n    .createMidInnerMainImg {\n    width: 200px;\n    height: 213px;\n  }\n  .createStorySection .createStoryMid .createMidInnerInfo .findIngredients img {\n    width: 68px;\n    height: 64px;\n    margin-top: -10px;\n    margin-right: 15px;\n  }\n  .createStorySection .createStoryMid .createMidInnerInfo span img {\n    width: 141px;\n  }\n  .storyBtn {\n    font-size: 36px;\n    line-height: 47px;\n    border-image-slice: 25;\n  }\n  .createStorySection .createStoryTop .MuniaMiddle {\n    width: 65px;\n    height: 63px;\n  }\n  .createStorySection .createStoryTop h2 {\n    font-size: 48px;\n    line-height: 64px;\n  }\n  .createStorySection .moreStory .moreStoryInner img.RedCross {\n    width: 38px;\n    height: 38px;\n  }\n  .createStorySection .createStoryTop .createStoryTopMaintext p {\n    font-size: 20px;\n    line-height: 30px;\n    margin-top: 0;\n  }\n}\n\n.PickStoryHome p {\n  font-weight: 600;\n  text-align: center;\n  color: #000;\n  margin: 98px 0 35px;\n}\n\n.storySectiontwo .storySectionTwoInnerInfo h4 {\n  display: block !important;\n}\n\n.storySectiontwo {\n  background: #d9eb41;\n  padding: 12px 0;\n}\n\n.storySectiontwo .storySectionTwoInner {\n  display: flex;\n  flex-wrap: wrap;\n  margin: 50px 0;\n}\n\n.storySectiontwo .storySectionTwoInner .btnStory,\n.storySectiontwo .storySectionTwoInner p {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.btnFillRight {\n  width: 240px;\n}\n\n@media (min-width: 992px) and (max-width: 1199px) {\n  .createStorySection .createStorySwiperInfo .swiperSectionInfo_inner {\n    height: 27em !important;\n  }\n}\n\n@media (max-width: 991px) {\n  .createStorySection .createStorySwiperInfo .swiperSectionInfo_inner {\n    height: 20em !important;\n  }\n  .createStorySection .createStoryTop .cardHeader img {\n    width: 300px;\n    height: 285px;\n    object-fit: cover;\n  }\n  .myaccount_main .account_bottom_info a {\n    margin: 0 auto 57px;\n    width: 90%;\n  }\n  .myaccount_main .account_bottom_info img {\n    left: 40px;\n  }\n}\n\n@media (max-width: 767px) {\n  .PickStoryHome p,\n  .storySectiontwo .storySectionTwoInner p {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .btnFillRight {\n    width: 150px;\n  }\n  .MyStories .storybtn .btnFill.btnFillLeft {\n    margin-right: 0;\n    width: 140px;\n  }\n  .MyStories .backbtn a {\n    top: -5px;\n  }\n  .myaccount_main .account_bottom_info img {\n    left: 12px;\n  }\n  .storySectiontwo .storySectionTwoInner {\n    margin: 20px 0;\n  }\n  .storySectiontwo .storySectionTwoInner .btnStory,\n  .storySectiontwo .storySectionTwoInner p {\n    flex: 0 0 100%;\n    max-width: 100%;\n    margin-bottom: 15px;\n  }\n  .storySectiontwo {\n    background: #56cdd5;\n  }\n  .MySubmission .MySubmissionInfo .MySubmissiondetail_publish .tick,\n  .MySubmission .MySubmissionInfo .MySubmissiondetail_read .tick,\n  .MySubmission .MySubmissionInfo .MySubmissiondetail_submit .tick {\n    width: 60px;\n  }\n  .MySubmission .MySubmissionInfo .MySubmissiondetail_read .tick {\n    top: 20px;\n    right: 32px;\n  }\n  .mobileFooter .footerRight .emailInput {\n    display: flex;\n    align-items: center;\n  }\n  .mobileFooter .footerRight .emailInput input {\n    width: 100%;\n  }\n  .mobileFooter .footerRight .emailInput img {\n    margin-top: 0;\n  }\n  .PickStoryHome p {\n    margin: 35px 0;\n  }\n  .storySection .bgImageStoryNewLeft img {\n    width: 85px;\n  }\n  .storySection .bgImageStoryNewLeft {\n    top: inherit;\n    bottom: -12px;\n    left: -45px;\n  }\n  .btsSection .btsSectionInfo button {\n    bottom: 15px !important;\n  }\n  .btsSection .btsSectionInfo {\n    height: 200px;\n  }\n  .MySubmission\n    .MySubmissionInfo\n    .MySubmissiondetail_Ingredients\n    .MySubmissionInfoInner {\n    width: 340px;\n  }\n}\n\n@media (min-width: 991px) {\n  .ZidZagDesktopStory img {\n    width: 205px;\n  }\n  .myaccount_main .MenuCircularImgBottom {\n    display: none;\n  }\n}\n\n@media (max-width: 450px) {\n  .ViewCardStory .swiperSection .swiperSectionInfo_inner {\n    height: 19em !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .createStorySection .createStoryTop .cardHeader img {\n    width: 250px;\n    height: 235px;\n    object-fit: cover;\n  }\n  .createStorySection .createStorySwiperInfo .swiperSectionInfo_inner {\n    height: 16em !important;\n  }\n}\n\n.signUpOtp .signUpInfo .rightInfo {\n  margin-top: -85px;\n}\n\n.menuMainHead .storySectiontwo .storySectionTwoInner {\n  margin-bottom: 0;\n}\n\n.menuMainHead .storySectiontwo .storySectionTwoInner .btnStory button {\n  margin-right: -1px;\n}\n\n.menuMain .backbtn {\n  top: -20px;\n}\n\n.menuMain .backbtn img {\n  width: 65px;\n  z-index: 1;\n  position: relative;\n}\n\n.menuMainHead .menuNoLogin .storySectiontwo {\n  background-color: transparent;\n  margin: 0 0 50px;\n}\n\n.menuMainHead .menuNoLogin .storySectiontwo h4 {\n  display: none !important;\n}\n\n.menuMainHead .menuNoLogin .storySectiontwo .storySectionTwoInner p {\n  color: #f2dd4e;\n  font-size: 24px;\n  line-height: 31px;\n}\n\n.menuMainHead\n  .menuNoLogin\n  .storySectiontwo\n  .storySectionTwoInner\n  .btnStory\n  .btnUnfill {\n  color: #f2dd4e;\n  border-image: url(../../assets/images/yellow-border-img.png);\n  border-image-repeat: stretch;\n  border-image-slice: 15;\n  border-image-width: 9px;\n  border-image-outset: 0 0 8px 0;\n}\n\n.MyStoryFlowInfo:active::after,\n.MyStoryFlowInfo:hover::after,\n.StoryFlowInfoBtn .btnFill:active::after,\n.StoryFlowInfoBtn .btnFill:hover::after,\n.ViewCardStory .btnFill:active::after,\n.ViewCardStory .btnFill:hover::after,\n.btnStory .btnFill:active::after,\n.btnStory .btnFill:hover::after,\n.downoadGuppyApp .btnFill:active::after,\n.downoadGuppyApp .btnFill:hover::after,\n.sharestorysec .btnFill:active::after,\n.sharestorysec .btnFill:hover::after {\n  content: \"\";\n  position: absolute;\n  right: -55px;\n  background: url(../../assets/images/ActiveRight.png) 0 0 / contain no-repeat;\n  width: 24px;\n  height: 60px;\n  top: 20px;\n}\n\n.MyStoryFlowInfo:active::before,\n.MyStoryFlowInfo:hover::before,\n.StoryFlowInfoBtn .btnFill:active:before,\n.StoryFlowInfoBtn .btnFill:hover:before,\n.ViewCardStory .btnFill:hover::before,\n.btnStory .btnFill:active::before,\n.btnStory .btnFill:hover::before,\n.downoadGuppyApp .btnFill:active:before,\n.downoadGuppyApp .btnFill:hover:before,\n.sharestorysec .btnFill:active::before,\n.sharestorysec .btnFill:hover::before {\n  content: \"\";\n  position: absolute;\n  left: -60px;\n  background: url(../../assets/images/ActiveLeft.png) 0 0 / contain no-repeat;\n  width: 24px;\n  height: 65px;\n  top: 20px;\n}\n\n.MyStoryFlowInfo:active::after,\n.MyStoryFlowInfo:active::before,\n.MyStoryFlowInfo:hover::after,\n.MyStoryFlowInfo:hover::before {\n  top: 33px;\n  cursor: pointer;\n}\n.createStoryTop .btnFill:hover::before,\n.createStoryTop .btnFill:active::before {\n  content: \"\";\n  position: absolute;\n  left: -60px;\n  background: url(../../assets/images/ActiveLeft.png) 0 0 / contain no-repeat;\n  width: 24px;\n  height: 65px;\n  top: 0;\n}\n.createStoryTop .btnFill:hover::after,\n.createStoryTop .btnFill:active::after {\n  content: \"\";\n  position: absolute;\n  right: -55px;\n  background: url(../../assets/images/ActiveRight.png) 0 0 / contain no-repeat;\n  width: 24px;\n  height: 60px;\n  top: 0;\n}\n.ViewCardStory .btnFill:hover::after,\n.ViewCardStory .btnFill:hover::before,\n.btnStory .btnFill:active::after,\n.btnStory .btnFill:active::before,\n.btnStory .btnFill:hover::after,\n.btnStory .btnFill:hover::before,\n.downoadGuppyApp .btnFill:hover::after,\n.downoadGuppyApp .btnFill:hover:before {\n  top: 0;\n}\n\n.menuMain .menuMainInner a:active::after,\n.menuMain .menuMainInner a:hover::after {\n  content: \"\";\n  position: absolute;\n  right: -35px;\n  background: url(../../assets/images/whiteRightHover.png) 0 0 / contain\n    no-repeat;\n  width: 19px;\n  height: 42px;\n  top: 20px;\n}\n\n.menuMain .menuMainInner a:active::before,\n.menuMain .menuMainInner a:hover::before {\n  content: \"\";\n  position: absolute;\n  left: -35px;\n  background: url(../../assets/images/whiteLeftHover.png) 0 0 / contain\n    no-repeat;\n  width: 17px;\n  height: 41px;\n  top: 20px;\n}\n\n.downoadGuppyApp .btnFill:active::after,\n.downoadGuppyApp .btnFill:hover::after {\n  height: 60px;\n}\n\n.downoadGuppyApp .btnFill:active:before,\n.downoadGuppyApp .btnFill:hover:before {\n  width: 30px;\n  height: 100px;\n  left: -50px;\n}\n\n.ShareStoryFlowNewbottom {\n  background: #56cdd5;\n  padding: 50px 0;\n  margin-top: -30px;\n  position: relative;\n}\n\n.ShareStoryFlowNewbottom p {\n  font-weight: 600;\n  font-size: 48px;\n  line-height: 71px;\n  text-align: center;\n  color: #000;\n  margin-bottom: 50px;\n}\n\n.ShareStoryFlowNewbottom .createStoryBottomBtn .btnUnfill {\n  padding: 12px 80px;\n}\n\n.ShareStoryFlowNewbottom .createStoryBottomShare {\n  width: 50%;\n  margin: 50px auto auto;\n}\n\n.ShareStoryFlowNewbottom .createStoryBottomShare span {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 31px;\n  color: #000;\n  display: block;\n  text-align: left;\n  margin-bottom: 5px;\n}\n\n@media (max-width: 767px) {\n  .cardPickSection\n    .swiperSectionInfo_inner\n    .swiperSection_InfoDe\n    .swiperSlide\n    .cardHeader\n    img {\n    width: 542px;\n    height: 152px;\n  }\n  .birdTopText span {\n    top: 16px;\n    width: 80px;\n    font-size: 12px;\n    line-height: 14px;\n    right: -2px;\n  }\n  .ShareStoryFlowNewbottom .createStoryBottomShare span,\n  .ShareStoryFlowNewbottom img,\n  .signUpOtp .signUpInfo .leftInfo .socialIcon,\n  .signUpOtp .signUpInfo .leftInfo h5,\n  .signUpOtp .signUpInfo .leftInfo p,\n  .signUpOtp .signUpInfo .leftInfo:after {\n    display: none;\n  }\n  .menuMainHead .menuNoLogin .storySectiontwo .storySectionTwoInner,\n  .signUpOtp .signUpInfo .rightInfo {\n    margin-top: 0;\n  }\n  .menuMainHead .menuNoLogin .storySectiontwo .storySectionTwoInner p {\n    font-size: 18px;\n    line-height: 23px;\n  }\n  .menuMainHead .menuNoLogin .storySectiontwo {\n    margin: 0 0 15px;\n  }\n  .menuMain .menuMainInner a:active::after,\n  .menuMain .menuMainInner a:hover::after {\n    top: 12px;\n    right: -25px;\n  }\n  .menuMain .menuMainInner a:active::before,\n  .menuMain .menuMainInner a:hover::before {\n    top: 12px;\n    left: -28px;\n  }\n  .MyStoryFlowInfo:active::before,\n  .MyStoryFlowInfo:hover::before,\n  .StoryFlowInfoBtn .btnFill:active:before,\n  .StoryFlowInfoBtn .btnFill:hover:before,\n  .ViewCardStory .btnFill:hover::before,\n  .btnStory .btnFill:active::before,\n  .btnStory .btnFill:hover::before,\n  .downoadGuppyApp .btnFill:active:before,\n  .downoadGuppyApp .btnFill:hover:before,\n  .sharestorysec .btnFill:active::before,\n  .sharestorysec .btnFill:hover::before {\n    top: 10px;\n    left: -35px;\n    background: url(../../assets/images/leftMobileActiveEffect.png);\n    width: 16px;\n    height: 36px;\n  }\n  .MyStoryFlowInfo:active::after,\n  .MyStoryFlowInfo:hover::after,\n  .StoryFlowInfoBtn .btnFill:active::after,\n  .StoryFlowInfoBtn .btnFill:hover::after,\n  .ViewCardStory .btnFill:active::after,\n  .ViewCardStory .btnFill:hover::after,\n  .btnStory .btnFill:active::after,\n  .btnStory .btnFill:hover::after,\n  .downoadGuppyApp .btnFill:active::after,\n  .downoadGuppyApp .btnFill:hover::after,\n  .sharestorysec .btnFill:active::after,\n  .sharestorysec .btnFill:hover::after {\n    top: 10px;\n    background: url(../../assets/images/rightMobileActiveEffect.png);\n    width: 17px;\n    height: 37px;\n    right: -35px;\n  }\n  .ViewCardStory .btnFill:hover::after,\n  .ViewCardStory .btnFill:hover::before,\n  .btnStory .btnFill:active::after,\n  .btnStory .btnFill:active::before,\n  .btnStory .btnFill:hover::after,\n  .btnStory .btnFill:hover::before {\n    top: 4px;\n  }\n  .MyStoryFlowInfo:active::before,\n  .MyStoryFlowInfo:hover::before {\n    top: 23px;\n    left: -30px;\n  }\n  .MyStoryFlowInfo:active::after,\n  .MyStoryFlowInfo:hover::after {\n    top: 23px;\n    right: -27px;\n  }\n  .ShareStoryFlowNewbottom p {\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 32px;\n  }\n}\n\n@media (max-width: 400px) {\n  .cardPickSection .swiperSectionInfo_inner {\n    height: 15em !important;\n  }\n  .PackagesMainGredient\n    .PackagesInfo\n    .PackagesInfoInner\n    .PackagesInfoInnerImg\n    img {\n    width: 105px;\n  }\n  .PackagesMainGredient .PackagesInfo {\n    margin-top: 20px;\n  }\n  .PackagesMainGredient .PackagesMain_bottom p {\n    font-size: 16px !important;\n    line-height: 22px !important;\n  }\n  .PackagesMainGredient .PackagesMain_bottom p br {\n    display: none;\n  }\n  .PackagesMainGredient::before {\n    top: 9%;\n  }\n  .PackagesMainGredient::after {\n    top: 23%;\n  }\n  .btnFill,\n  .btnUnfill {\n    font-size: 20px;\n    line-height: 22px;\n  }\n  .btnFill {\n    padding: 5px 10px;\n  }\n  .btnUnfill {\n    padding: 5px 15px;\n  }\n}\n\n.TermsConditionsMain {\n  background: #f2dd4e;\n  padding-top: 40px;\n  margin-top: -10px;\n}\n\n.TermsConditionsMain .TermsConditionsBottom ul {\n  margin-left: 40px;\n}\n\n.TermsConditionsMain .TermsConditionsBottom h5,\n.TermsConditionsMain .TermsConditionsBottom p,\n.TermsConditionsMain p span {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 21px;\n  color: #000;\n  margin: 15px 0;\n}\n\n.TermsConditionsMain .TermsConditionsBottom p {\n  font-weight: 500;\n}\n\n.TermsConditionsMain .TermsConditionsTop h1 {\n  text-align: center;\n  display: inline-block;\n  width: 90%;\n}\n\n.TermsConditionsMain h2 {\n  text-align: center;\n  color: #000;\n  font-weight: 700;\n  font-size: 36px;\n  line-height: 47px;\n  margin: 50px 0 30px;\n  position: relative;\n}\n\n.PasswordUpdatedScreenMain p,\n.signupHeadline {\n  font-weight: 600;\n  color: #000;\n  text-align: center;\n}\n\n.TermsConditionsMain h2::before {\n  content: \"\";\n  background-image: url(../../assets/images/BlackDashedLineNew.png);\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 24px;\n  background-size: cover;\n  position: absolute;\n  top: -30px;\n  left: 0;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .MySubmissionInfoDraft .MySubmissiondetail .EditInfoSubmission {\n    right: -30px;\n  }\n  .MySubmissionInfoDraft .MySubmissiondetail .EditInfoSubmission img {\n    width: 104px;\n  }\n  .cardPickSection .cardHeader img {\n    max-width: 100%;\n  }\n  .cardPickSection .swiperSection .swiperSectionInfo_inner {\n    margin-left: 0 !important;\n    display: flex;\n    justify-content: center;\n  }\n  .swiperSection .swiperNav .swiperNext {\n    right: -20px;\n  }\n  .swiperSection .swiperNav .swiperPrev {\n    left: -20px;\n  }\n  .menuMainHead\n    .menuNoLogin\n    .storySectiontwo\n    .storySectionTwoInner\n    .btnStory\n    .btnUnfill {\n    font-size: 20px;\n    padding: 7px 14px;\n    line-height: 32px;\n  }\n  .menuMainHead .menuNoLogin .storySectiontwo .storySectionTwoInner {\n    align-items: center;\n  }\n  .ShareStoryFlowNewbottom p {\n    font-size: 20px;\n    line-height: 30px;\n  }\n  .TermsConditionsMain h2 {\n    font-size: 25px;\n    line-height: 32px;\n  }\n  .TermsConditionsMain {\n    margin-top: -20px;\n  }\n}\n\n.PasswordUpdatedScreenMain {\n  background: #f2dd4e;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  padding: 100px 0 150px;\n}\n\n.PasswordUpdatedScreenMain p {\n  font-size: 24px;\n  line-height: 37px;\n}\n\n.PasswordUpdatedScreenMain p.PasswordNewSuccesspara1 {\n  margin-bottom: 40px;\n  margin-top: 40px;\n}\n\n.signupHeadline {\n  font-size: 28px;\n  line-height: 36px;\n  margin-bottom: 30px;\n}\n\n.ParentConsentFormSection {\n  border: 1px solid #000;\n  border-radius: 10px;\n  padding: 40px;\n  margin: 40px auto;\n}\n\n.ParentConsentFormSection h4 {\n  text-align: center;\n  font-family: Roboto, sans-serif;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 33px;\n  color: #000;\n  margin-bottom: 40px;\n}\n\n.ParentConsentFormSection p {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 28px;\n  color: #000;\n}\n\n.ParentConsentFormSection p input {\n  border: 0;\n  border-bottom: 2px dashed #000;\n}\n\n.ParentConsentFormSection p .fieldCommon {\n  width: 200px;\n  display: inline-block;\n}\n\n.signUpOtp .signUpInfo .rightInfo {\n  max-width: 50%;\n  padding-left: 15px;\n}\n\n.ParentConsentFormSectionTop {\n  margin-bottom: 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.LoadingMain {\n  background-color: #f2dd4e !important;\n}\n\n.LoadingMainChild,\n.LoadingMainChild span {\n  left: 50%;\n  background: 0 0;\n  position: absolute;\n}\n\n.LoadingMainChild {\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 150px;\n  height: 150px;\n  border: 3px solid #f2dd4e;\n  border-radius: 50%;\n  text-align: center;\n  line-height: 150px;\n  font-size: 25px;\n  color: #000 !important;\n  text-shadow: 0 0 10px #000;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\n}\n\n.LoadingMainChild:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 3px solid transparent;\n  border-top: 3px solid #000;\n  border-right: 3px solid #000;\n  border-radius: 50%;\n  animation: 2s linear infinite animateC;\n}\n\n.LoadingMainChild span {\n  display: block;\n  top: calc(50% - 2px);\n  width: 50%;\n  height: 4px;\n  transform-origin: left;\n  animation: 2s linear infinite animate;\n}\n\n.LoadingMainChild span:before {\n  content: \"\";\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #000;\n  top: -6px;\n  right: -8px;\n  box-shadow: 0 0 20px #000;\n}\n\n@keyframes animateC {\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate {\n  0% {\n    transform: rotate(45deg);\n  }\n  100% {\n    transform: rotate(405deg);\n  }\n}\n\n@media (min-width: 1200px) {\n  .menuMainHead .storySectiontwo {\n    margin: 50px 0 130px;\n  }\n  .myaccount_main .accountmain_top span .accountTitle {\n    display: inline-block !important;\n  }\n  .myaccount_main .accountmain_top span strong {\n    display: initial;\n  }\n}\n\n@media (max-width: 575px) {\n  .createStorySection .moreStoryInner .moreStoryInnerMainNew {\n    width: 95px !important;\n    height: 100px !important;\n  }\n  .banner {\n    margin-top: -22px;\n  }\n  .swiperNavtwo .swiperNext img,\n  .swiperNavtwo .swiperPrev img {\n    width: 50px;\n  }\n  .cardFooter {\n    padding: 8px 10px;\n  }\n  .cardPickSection .swiperSectionInfo_inner .swiperSlide .cardNew {\n    max-width: 62%;\n  }\n  .swiperNavtwo {\n    bottom: 42%;\n  }\n  .storySection .btnStory button.btnUnfill {\n    margin: auto 12px;\n    padding: 5px;\n    width: 145px;\n  }\n  .btsSection .btsSectionInfo button {\n    bottom: 0 !important;\n  }\n  .storyPageMain p {\n    font-size: 20px;\n    line-height: 32px;\n    margin: 15px 0;\n  }\n  .StoryFlows .StoryFlow_bottom .StoryFlowInfo p {\n    font-size: 20px;\n    line-height: 30px;\n    margin: 15px 0;\n  }\n  .menuMain {\n    width: 90% !important;\n  }\n  .menuMain .menuMainHead .menuMainhead_inner span {\n    flex: 0 0 55%;\n    max-width: 55%;\n  }\n  .menuMain .menunewdivmid {\n    display: block !important;\n  }\n  .menuMain .menuMainhead_inner span strong {\n    font-size: 25px !important;\n    line-height: 25px !important;\n  }\n  .menuMain .menuMainInner a {\n    padding: 5px !important;\n    font-size: 22px;\n  }\n  .menuMain .menuMainInner a img {\n    max-width: 40px;\n  }\n  .menuMain::after {\n    bottom: -10px;\n    left: -25px;\n    display: none;\n  }\n  .menuMain .menuMainInner {\n    margin-top: 10px;\n  }\n}\n\n@media (max-width: 767px) {\n  .TermsConditionsMain h2 {\n    font-size: 22px;\n    line-height: 30px;\n  }\n  .TermsConditionsMain {\n    margin-top: -20px;\n  }\n  .TermsConditionsMain .TermsConditionsTop h1 {\n    width: 80%;\n    font-size: 28px;\n    left: 35px;\n  }\n  .TermsConditionsMain .TermsConditionsTop img {\n    width: 35px;\n  }\n  .TermsConditionsMain a {\n    font-size: 20px !important;\n    line-height: 30px !important;\n    word-wrap: break-word;\n  }\n  .TermsConditionsMain .DownloadConsentFormimg {\n    width: 30px;\n  }\n  .TermsConditionsMain span {\n    font-size: 16px;\n    line-height: 25px;\n  }\n  .ParentConsentFormSectionTop img,\n  .PasswordUpdatedScreenMain p.PasswordNewSuccesspara2 {\n    margin-bottom: 20px;\n  }\n  .PasswordUpdatedScreenMain .PasswordUpdatedBottom img {\n    width: 100px;\n    margin-top: 40px;\n  }\n  .PasswordUpdatedScreenMain .PasswordUpdatedTop img {\n    display: block;\n    width: auto;\n    margin: auto;\n  }\n  .PasswordUpdatedScreenMain {\n    margin-top: -35px;\n  }\n  .PasswordUpdatedScreenMain p {\n    font-size: 20px;\n    line-height: 31px;\n  }\n  .PasswordUpdatedScreenMain p br,\n  .signUpOtp .signUpInfo .rightInfo br {\n    display: none;\n  }\n  .ParentConsentFormSectionTop {\n    justify-content: center;\n    flex-direction: column-reverse;\n  }\n  .ParentConsentFormSectionTop p {\n    text-align: center;\n  }\n  .ParentConsentFormSection p .fieldCommon {\n    width: 100%;\n  }\n  .ParentConsentFormSection p input {\n    margin-bottom: 15px;\n  }\n  .signUpOtp .signUpInfo .rightInfo {\n    max-width: 100%;\n    padding-left: 15px;\n  }\n  .signUpOtp .signUpInfo .rightInfo a,\n  .signUpOtp .signUpInfo .rightInfo p {\n    font-size: 20px !important;\n    line-height: 24px !important;\n  }\n  .signUpOtp .signUpInfo .rightInfo img {\n    margin-bottom: 40px;\n  }\n  .signUpOtp .signUpInfo {\n    padding-top: 100px;\n  }\n  .ParentConsentFormSection {\n    padding: 15px !important;\n  }\n  .ParentConsentFormSection p {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .signUpInfo .rightInfo form .wrapdiv span {\n    font-size: 16px;\n    line-height: 24px;\n  }\n  .header_section {\n    padding-top: 0;\n  }\n  .MyStories .storybtn .submissionNewLEftBtn {\n    margin-right: 28px !important;\n  }\n  .MyStories .storybtn button {\n    padding: 7px 10px;\n  }\n  .MyStories .storybtn button.activeEffect::after,\n  .MyStories .storybtn button.activeEffect::before {\n    top: 0;\n  }\n  .MyStories .storybtn .submissionNewRightBtn {\n    margin-left: 30px !important;\n  }\n  .DownloadConsentFormText {\n    font-size: 16px !important;\n    line-height: 28px !important;\n  }\n  .BackToTOpImg {\n    width: 50px !important;\n  }\n  .BackToTop {\n    margin-top: 15px;\n  }\n}\n\n.header_section {\n  position: fixed;\n  width: 100%;\n}\n.storySection .storySectionTwoInnerInfo {\n  display: none;\n}\n@media (min-width: 1200px) {\n  .MyStories,\n  .MyStoryFlowMain,\n  .PackagesMain,\n  .PasswordUpdatedScreenMain,\n  .loginBg,\n  .myavtarsection,\n  .signUpBg,\n  .myaccount_main,\n  .faqMain,\n  .contactSection,\n  .TermsConditionsMain,\n  .createStorySection,\n  .StoryFlows,\n  .edit_profile_section {\n    margin-top: 115px;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199px) {\n  .MyStories,\n  .MyStoryFlowMain,\n  .PackagesMain,\n  .PasswordUpdatedScreenMain,\n  .loginBg,\n  .menuMain,\n  .myavtarsection,\n  .signUpBg,\n  .myaccount_main,\n  .faqMain,\n  .contactSection,\n  .TermsConditionsMain,\n  .createStorySection,\n  .StoryFlows,\n  .edit_profile_section {\n    margin-top: 75px;\n  }\n}\n@media (min-width: 768px) and (max-width: 991px) {\n  .MyStories,\n  .MyStoryFlowMain,\n  .PackagesMain,\n  .PasswordUpdatedScreenMain,\n  .loginBg,\n  .menuMain,\n  .myavtarsection,\n  .signUpBg,\n  .myaccount_main,\n  .faqMain,\n  .StoryFlows,\n  .contactSection,\n  .edit_profile_section,\n  .storyPageMain,\n  .TermsConditionsMain,\n  .createStorySection {\n    margin-top: 80px;\n  }\n}\n@media (max-width: 767px) {\n  .MyStories,\n  .TermsConditionsMain,\n  .createStorySection,\n  .MyStoryFlowMain,\n  .myavtarsection,\n  .PackagesMain,\n  .StoryFlows,\n  .contactSection,\n  .edit_profile_section,\n  .faqMain,\n  .loginBg,\n  .myaccount_main,\n  .signUpBg,\n  .storyPageMain {\n    margin-top: 52px;\n  }\n  .cardPickSection {\n    padding: 90px 0 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnFill": `landingpage_btnFill__Ctw+3`,
	"btnUnfill": `landingpage_btnUnfill__uGDrD`,
	"border-main": `landingpage_border-main__XW+Vt`,
	"header_section": `landingpage_header_section__eWp+J`,
	"is_sticky": `landingpage_is_sticky__Km9Ty`,
	"headerGs": `landingpage_headerGs__HYoJR`,
	"cardPickSection": `landingpage_cardPickSection__-x4G0`,
	"cardborder": `landingpage_cardborder__Zk6K9`,
	"signUpInfo": `landingpage_signUpInfo__lrGdo`,
	"btsSection": `landingpage_btsSection__l5qw9`,
	"btsSectionInfo": `landingpage_btsSectionInfo__E6rYo`,
	"cardborderthree": `landingpage_cardborderthree__nKoeR`,
	"footerLeft": `landingpage_footerLeft__c5Eka`,
	"StoryFlows": `landingpage_StoryFlows__ZB9Nz`,
	"Viewfullstory": `landingpage_Viewfullstory__KUltV`,
	"footerMid": `landingpage_footerMid__ZQV9z`,
	"footerMidLeft": `landingpage_footerMidLeft__xizVl`,
	"loginBg": `landingpage_loginBg__JZmcK`,
	"forgerPass": `landingpage_forgerPass__DTiZ6`,
	"logoutMenuBottomNew": `landingpage_logoutMenuBottomNew__Plo0X`,
	"logoutMenuBottoma": `landingpage_logoutMenuBottoma__C2qUI`,
	"menuMain": `landingpage_menuMain__CIvXY`,
	"menuMainHead": `landingpage_menuMainHead__ZzQTs`,
	"logoutMenu": `landingpage_logoutMenu__le580`,
	"mobileFooter": `landingpage_mobileFooter__zaew6`,
	"mobilelink": `landingpage_mobilelink__NqFmt`,
	"myaccount_main": `landingpage_myaccount_main__ToIhz`,
	"logout": `landingpage_logout__b7eba`,
	"storyPagecompMain": `landingpage_storyPagecompMain__gqaI6`,
	"MySubmission": `landingpage_MySubmission__jt+jE`,
	"MySubmissionInfo": `landingpage_MySubmissionInfo__vCULm`,
	"MySubmissiondetail_Ingredients": `landingpage_MySubmissiondetail_Ingredients__Vo1Um`,
	"MySubmissionInfoInner": `landingpage_MySubmissionInfoInner__BmzgZ`,
	"theaterInfo": `landingpage_theaterInfo__nmkAq`,
	"theaterLeftInfo": `landingpage_theaterLeftInfo__PxUNY`,
	"MyStories": `landingpage_MyStories__xS1Bu`,
	"MyStoryFlowMain": `landingpage_MyStoryFlowMain__PvUat`,
	"PackagesMain": `landingpage_PackagesMain__vvtmP`,
	"PasswordUpdatedScreenMain": `landingpage_PasswordUpdatedScreenMain__89uxS`,
	"myavtarsection": `landingpage_myavtarsection__6IZ7k`,
	"signUpBg": `landingpage_signUpBg__6ajTf`,
	"TermsConditionsMain": `landingpage_TermsConditionsMain__wM2cb`,
	"TermsConditionsBottom": `landingpage_TermsConditionsBottom__yPJBt`,
	"MainMenu": `landingpage_MainMenu__CnRM+`,
	"rotating": `landingpage_rotating__PJL95`,
	"cardborderfouth": `landingpage_cardborderfouth__qNzpV`,
	"MyStoryFlowInfo": `landingpage_MyStoryFlowInfo__u-zOd`,
	"PackagesInfoInnerImg": `landingpage_PackagesInfoInnerImg__dXNPB`,
	"activeEffect": `landingpage_activeEffect__moV0-`,
	"backbtn": `landingpage_backbtn__JCEeY`,
	"banner": `landingpage_banner__GQV94`,
	"bannerSlideCar": `landingpage_bannerSlideCar__GLM3r`,
	"bannerLeft": `landingpage_bannerLeft__4go00`,
	"btnStory": `landingpage_btnStory__C12kQ`,
	"navheader": `landingpage_navheader__PpA9S`,
	"menuMainInner": `landingpage_menuMainInner__Fb0Xl`,
	"account_bottom_info": `landingpage_account_bottom_info__Bg0+O`,
	"sharestorysec": `landingpage_sharestorysec__AIFxv`,
	"storyPageMain": `landingpage_storyPageMain__C2nSX`,
	"navheaderBgImg": `landingpage_navheaderBgImg__OxKhc`,
	"headerContact": `landingpage_headerContact__BDbrF`,
	"storynavigatemain": `landingpage_storynavigatemain__QgymB`,
	"storynavigatemainInner": `landingpage_storynavigatemainInner__RGbmb`,
	"PasswordUpdatedBottom": `landingpage_PasswordUpdatedBottom__P4K-7`,
	"downoadGuppyApp": `landingpage_downoadGuppyApp__eQPEW`,
	"downoadGuppyApp_right": `landingpage_downoadGuppyApp_right__aW-S4`,
	"barcode_inner": `landingpage_barcode_inner__OqFVD`,
	"barcode_box": `landingpage_barcode_box__Urdz8`,
	"headerGb": `landingpage_headerGb__NsDub`,
	"headerGsNew": `landingpage_headerGsNew__FgHBK`,
	"bannerRightText": `landingpage_bannerRightText__3qipL`,
	"storySection": `landingpage_storySection__zDXM6`,
	"storySectiontwo": `landingpage_storySectiontwo__HdMel`,
	"ContactBottom": `landingpage_ContactBottom__U6x2n`,
	"btndiv": `landingpage_btndiv__gSekl`,
	"StoryFlowInfoBtn": `landingpage_StoryFlowInfoBtn__BLWad`,
	"PackagesMainGredient": `landingpage_PackagesMainGredient__y6S+y`,
	"signUpOtp": `landingpage_signUpOtp__hGlWQ`,
	"socialIcon": `landingpage_socialIcon__UuuAD`,
	"owl-dots": `landingpage_owl-dots__6nUIx`,
	"swiperNavBanner": `landingpage_swiperNavBanner__L6H1D`,
	"swiperNavBannertwo": `landingpage_swiperNavBannertwo__ZClJ9`,
	"page_num": `landingpage_page_num__WXNI7`,
	"swiperSection": `landingpage_swiperSection__tFPRl`,
	"swiperNav": `landingpage_swiperNav__KUIrH`,
	"swiperNext": `landingpage_swiperNext__Fr-HA`,
	"owlSlideText": `landingpage_owlSlideText__k14pg`,
	"whtsNew": `landingpage_whtsNew__YQy2a`,
	"bgImageOverflow": `landingpage_bgImageOverflow__ledaW`,
	"PasswordNewSuccesspara2": `landingpage_PasswordNewSuccesspara2__Ko0Uk`,
	"swiperSlide": `landingpage_swiperSlide__2xd3F`,
	"img": `landingpage_img__XZj7u`,
	"swiper": `landingpage_swiper__EDbDx`,
	"swiperSlideActive": `landingpage_swiperSlideActive__0E7bW`,
	"swiperPrev": `landingpage_swiperPrev__WqtYH`,
	"swiper-3d": `landingpage_swiper-3d__onPI8`,
	"swiperSlideShadow": `landingpage_swiperSlideShadow__KRdL+`,
	"muniaMiddleImg": `landingpage_muniaMiddleImg__mwiFo`,
	"dashedLine": `landingpage_dashedLine__cAwpn`,
	"bgImageStoryNewLeft": `landingpage_bgImageStoryNewLeft__-rs1G`,
	"createStorySection": `landingpage_createStorySection__0UUkg`,
	"dashedLinebottom": `landingpage_dashedLinebottom__t6BpV`,
	"googleAdSection": `landingpage_googleAdSection__ufifs`,
	"storeIconRight": `landingpage_storeIconRight__js8d+`,
	"faqMain": `landingpage_faqMain__0o88r`,
	"footerLogo": `landingpage_footerLogo__hRtO6`,
	"rightInfo": `landingpage_rightInfo__VCs2S`,
	"wrapdiv": `landingpage_wrapdiv__kXFlt`,
	"centerImg": `landingpage_centerImg__82+Oo`,
	"contactIcon": `landingpage_contactIcon__6C-hH`,
	"footerRight": `landingpage_footerRight__XMjSl`,
	"LoadingMainChild": `landingpage_LoadingMainChild__KSStZ`,
	"cardFooter": `landingpage_cardFooter__DpSg9`,
	"cardfooterName": `landingpage_cardfooterName__k7kVi`,
	"GuppyAppInner": `landingpage_GuppyAppInner__DsNDX`,
	"avtarBody": `landingpage_avtarBody__iAICN`,
	"emailInput": `landingpage_emailInput__j2Jzp`,
	"PalacecomMain": `landingpage_PalacecomMain__3KSO2`,
	"PalacecomMainInner": `landingpage_PalacecomMainInner__URsUl`,
	"PalacecomMainInnerinfo": `landingpage_PalacecomMainInnerinfo__mAT1e`,
	"contactTopInfo": `landingpage_contactTopInfo__sIedu`,
	"contactinfoMain": `landingpage_contactinfoMain__Wo6Sb`,
	"footerIconRow": `landingpage_footerIconRow__FtgnG`,
	"navbarToggler": `landingpage_navbarToggler__y0Aca`,
	"cardNew": `landingpage_cardNew__cPEuz`,
	"cardHeader": `landingpage_cardHeader__nUyBC`,
	"leftInfo": `landingpage_leftInfo__0XV3z`,
	"accountmain_top": `landingpage_accountmain_top__yo2en`,
	"checkboxdiv": `landingpage_checkboxdiv__1s2XC`,
	"arrowImgMain": `landingpage_arrowImgMain__k6Tgg`,
	"signLogRightLine": `landingpage_signLogRightLine__lTD86`,
	"signBgLeft": `landingpage_signBgLeft__SfKCz`,
	"againreg": `landingpage_againreg__EAIEE`,
	"avtarMain": `landingpage_avtarMain__XNI0G`,
	"avtarmainInfo": `landingpage_avtarmainInfo__+AuSN`,
	"ContactTop": `landingpage_ContactTop__-7+Ca`,
	"menuMainInnerImg": `landingpage_menuMainInnerImg__Y5ME5`,
	"mainInfo": `landingpage_mainInfo__2wT75`,
	"contactSection": `landingpage_contactSection__EICPg`,
	"createStoryMid": `landingpage_createStoryMid__u2+wD`,
	"createStoryMidInner": `landingpage_createStoryMidInner__0rqe3`,
	"edit_profile_section": `landingpage_edit_profile_section__ujP6U`,
	"profile_top": `landingpage_profile_top__1Qqjz`,
	"account_bottom_main": `landingpage_account_bottom_main__U-sTv`,
	"Uid": `landingpage_Uid__Mwqbl`,
	"profile_top_img": `landingpage_profile_top_img__RM0+1`,
	"profileInfo": `landingpage_profileInfo__OtQHM`,
	"profile_bottom": `landingpage_profile_bottom__N52NV`,
	"FaqBottom_main": `landingpage_FaqBottom_main__-jPww`,
	"faqBottomimg": `landingpage_faqBottomimg__xQw9W`,
	"backtotop": `landingpage_backtotop__s+C1y`,
	"faqTop": `landingpage_faqTop__f7jup`,
	"accordionTitle": `landingpage_accordionTitle__hlkBF`,
	"accordianArrrow": `landingpage_accordianArrrow__rGDFN`,
	"accordionItem": `landingpage_accordionItem__2MEgW`,
	"faqbgImg": `landingpage_faqbgImg__DKgMn`,
	"accordionContent": `landingpage_accordionContent__BN-aR`,
	"accordianConImg": `landingpage_accordianConImg__QTaNA`,
	"downoadGuppyApp_left": `landingpage_downoadGuppyApp_left__VB8yg`,
	"menuMainhead_inner": `landingpage_menuMainhead_inner__FfSW6`,
	"menubtn": `landingpage_menubtn__xRDwu`,
	"StoryFlowTop": `landingpage_StoryFlowTop__9XFEz`,
	"MyStoryFlowMainExpand": `landingpage_MyStoryFlowMainExpand__mmOZv`,
	"MySubmissionInfoDraft": `landingpage_MySubmissionInfoDraft__aHgi3`,
	"MySubmissiondetail": `landingpage_MySubmissiondetail__Jn9xs`,
	"leftalign": `landingpage_leftalign__lfnY6`,
	"MyStoryFlowInner": `landingpage_MyStoryFlowInner__Kdfmu`,
	"StoryFlows_top": `landingpage_StoryFlows_top__NuDly`,
	"StoryFlow_bottom": `landingpage_StoryFlow_bottom__3eYYZ`,
	"StoryFlowInfo": `landingpage_StoryFlowInfo__6Ytzx`,
	"StoryFlow_bottomBtn": `landingpage_StoryFlow_bottomBtn__YFqsw`,
	"Storysharebtn": `landingpage_Storysharebtn__Xq0oQ`,
	"MyStoryFlowInfoeditpencil": `landingpage_MyStoryFlowInfoeditpencil__CKGvY`,
	"StoryFlow_bgimg": `landingpage_StoryFlow_bgimg__deUMR`,
	"storyTopImg": `landingpage_storyTopImg__HkE2l`,
	"sharestorysecbg": `landingpage_sharestorysecbg__fqoqD`,
	"theEndImg": `landingpage_theEndImg__KceN5`,
	"storyPageMainBottom": `landingpage_storyPageMainBottom__LY77y`,
	"ViewCardStory": `landingpage_ViewCardStory__QSRQZ`,
	"mystoriesInnerInfo": `landingpage_mystoriesInnerInfo__3Hxzr`,
	"cardFooterNew": `landingpage_cardFooterNew__Gp5tU`,
	"btnFillRight": `landingpage_btnFillRight__vprmz`,
	"ZidZagDesktopStory": `landingpage_ZidZagDesktopStory__Wi+yI`,
	"swiperSectionInfo_inner": `landingpage_swiperSectionInfo_inner__m0gQX`,
	"desktopFooter": `landingpage_desktopFooter__uHw7+`,
	"MuniaMiddle": `landingpage_MuniaMiddle__p+N7F`,
	"faqBottom": `landingpage_faqBottom__BIdlo`,
	"recordBg": `landingpage_recordBg__sQ9dF`,
	"navbarTogglerIcon": `landingpage_navbarTogglerIcon__a9y4M`,
	"PackagesMain_nav": `landingpage_PackagesMain_nav__Rf4MK`,
	"storyBtn": `landingpage_storyBtn__rd8vk`,
	"PackagesInfo": `landingpage_PackagesInfo__sqhBn`,
	"PackagesInfoInner": `landingpage_PackagesInfoInner__+Ftfj`,
	"arrowimgBottom": `landingpage_arrowimgBottom__CsFZ0`,
	"PackagesMain_top": `landingpage_PackagesMain_top__mXWjt`,
	"PackagesMain_topLeft": `landingpage_PackagesMain_topLeft__dXtJ4`,
	"BackToTop": `landingpage_BackToTop__ymJgK`,
	"PackagesMain_topRight": `landingpage_PackagesMain_topRight__gzFB5`,
	"PackagesMain_bottom": `landingpage_PackagesMain_bottom__CFvIy`,
	"active": `landingpage_active__I2XuU`,
	"pacakageNextcontent": `landingpage_pacakageNextcontent__Ctp+3`,
	"storybtn": `landingpage_storybtn__Rmk5A`,
	"mystoriesInner": `landingpage_mystoriesInner__4yyn5`,
	"btnFillLeft": `landingpage_btnFillLeft__2bXxh`,
	"mystoriesInnerRight": `landingpage_mystoriesInnerRight__+MTcu`,
	"sharebtnlink": `landingpage_sharebtnlink__JxhRC`,
	"sharebtnimg": `landingpage_sharebtnimg__JZwNs`,
	"MySubmissiondetail_story": `landingpage_MySubmissiondetail_story__HHe86`,
	"MySubmissiondetail_publish": `landingpage_MySubmissiondetail_publish__NLDrF`,
	"tick": `landingpage_tick__GcADW`,
	"MySubmissiondetail_read": `landingpage_MySubmissiondetail_read__BQH4W`,
	"MySubmissiondetail_submit": `landingpage_MySubmissiondetail_submit__dT5H5`,
	"MySubmissionInfo_publish": `landingpage_MySubmissionInfo_publish__TmMlT`,
	"storyPAgeMainTitle": `landingpage_storyPAgeMainTitle__tCtS5`,
	"storyPageMainMid": `landingpage_storyPageMainMid__M9TlP`,
	"storyPageMidimg": `landingpage_storyPageMidimg__dI1ZO`,
	"storyimgInner": `landingpage_storyimgInner__tpNQn`,
	"whereText": `landingpage_whereText__yGNqP`,
	"ConfirmedBlueInner": `landingpage_ConfirmedBlueInner__x1ATD`,
	"ConfirmedBlueInnerInfo": `landingpage_ConfirmedBlueInnerInfo__vTO5k`,
	"PasswordUpdatedTop": `landingpage_PasswordUpdatedTop__V5SuE`,
	"swiperNavtwo": `landingpage_swiperNavtwo__vMqck`,
	"PackagesMain_arrow": `landingpage_PackagesMain_arrow__RYhCl`,
	"RedZigZagHomeStory": `landingpage_RedZigZagHomeStory__ntzXI`,
	"mainInfoMobile": `landingpage_mainInfoMobile__gScC0`,
	"MAinMEnudashedLineYellow": `landingpage_MAinMEnudashedLineYellow__HZipE`,
	"imgafterstoryPageLeft": `landingpage_imgafterstoryPageLeft__YmDUE`,
	"imgafterstoryPageRight": `landingpage_imgafterstoryPageRight__VbQpC`,
	"container-fluid": `landingpage_container-fluid__A1w4A`,
	"navbar": `landingpage_navbar__nOwoJ`,
	"navbarBrand": `landingpage_navbarBrand__MthO3`,
	"banner_container": `landingpage_banner_container__AMCt+`,
	"swiperSection_InfoDe": `landingpage_swiperSection_InfoDe__HyLRa`,
	"progressdivsubmission": `landingpage_progressdivsubmission__8+nF5`,
	"EditInfoSubmission": `landingpage_EditInfoSubmission__4o0Fn`,
	"birdTopText": `landingpage_birdTopText__vnNOx`,
	"PickStoryHome": `landingpage_PickStoryHome__W8mYH`,
	"createStoryTop": `landingpage_createStoryTop__C9bFo`,
	"createStorySwiperInfo": `landingpage_createStorySwiperInfo__4aOnp`,
	"moreStory": `landingpage_moreStory__1x5Ug`,
	"moreStoryInner": `landingpage_moreStoryInner__2NNY3`,
	"RedCross": `landingpage_RedCross__OkwOP`,
	"createStoryBottom": `landingpage_createStoryBottom__oCOx9`,
	"createStoryBottomShare": `landingpage_createStoryBottomShare__Ymsn5`,
	"qrdiv": `landingpage_qrdiv__eStKa`,
	"createMidInnerInfo": `landingpage_createMidInnerInfo__F6n1+`,
	"findIngredients": `landingpage_findIngredients__Uz4kN`,
	"createStoryBottomBtn": `landingpage_createStoryBottomBtn__HcwAv`,
	"createStoryTopMaintext": `landingpage_createStoryTopMaintext__h8Gxh`,
	"celebrationBox": `landingpage_celebrationBox__ZR8Bo`,
	"celebrationBoxInner": `landingpage_celebrationBoxInner__1ERDc`,
	"celebrationBoxBtn": `landingpage_celebrationBoxBtn__hEAVI`,
	"moreStoryInnerMainNew": `landingpage_moreStoryInnerMainNew__Hjvc1`,
	"newparaCreateastory": `landingpage_newparaCreateastory__WeQEh`,
	"createMidInnerMainImg": `landingpage_createMidInnerMainImg__LLO57`,
	"storySectionTwoInnerInfo": `landingpage_storySectionTwoInnerInfo__C1SgF`,
	"storySectionTwoInner": `landingpage_storySectionTwoInner__Uyga1`,
	"MenuCircularImgBottom": `landingpage_MenuCircularImgBottom__-RzME`,
	"menuNoLogin": `landingpage_menuNoLogin__XFI9E`,
	"ShareStoryFlowNewbottom": `landingpage_ShareStoryFlowNewbottom__R7pli`,
	"TermsConditionsTop": `landingpage_TermsConditionsTop__bQnZ-`,
	"signupHeadline": `landingpage_signupHeadline__BkgvB`,
	"PasswordNewSuccesspara1": `landingpage_PasswordNewSuccesspara1__RHQZg`,
	"ParentConsentFormSection": `landingpage_ParentConsentFormSection__IwY8Y`,
	"fieldCommon": `landingpage_fieldCommon__jYEsF`,
	"ParentConsentFormSectionTop": `landingpage_ParentConsentFormSectionTop__YVFAa`,
	"LoadingMain": `landingpage_LoadingMain__yz5gy`,
	"animateC": `landingpage_animateC__GT-yF`,
	"animate": `landingpage_animate__60nVA`,
	"accountTitle": `landingpage_accountTitle__yDT7z`,
	"menunewdivmid": `landingpage_menunewdivmid__sRCGi`,
	"DownloadConsentFormimg": `landingpage_DownloadConsentFormimg__uLmXi`,
	"submissionNewLEftBtn": `landingpage_submissionNewLEftBtn__6Ms8e`,
	"submissionNewRightBtn": `landingpage_submissionNewRightBtn__W+neQ`,
	"DownloadConsentFormText": `landingpage_DownloadConsentFormText__wwmxY`,
	"BackToTOpImg": `landingpage_BackToTOpImg__Zu1Gs`
};
export default ___CSS_LOADER_EXPORT___;
